 if (window.location.href.indexOf("cart") > -1) {
   window.location = '/?=mini';
}
$(document).ready(function(){
if(location.search == '?=mini'){
   $("#CartPopup").addClass("styles_active__7AzVD");
$("#UpcartPopupBackDrop").addClass("styles_active__7AzVD");
}
  });


function eventColorSwatchesChange(elem){
   var img = $(elem).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
    var newImage = $(elem).children("span").attr('data-img');
  if(newImage != null){
    img.attr('srcset', newImage);
    img.attr('src', newImage);
    }
}
$("#Color").on("change", function(){
  var getCol=$(this).val();
  $("#variant_2 .option-select-value-product-template-1").html(getCol);
});
function globalSelect(e, t, i) {
    var o = e + " / " + t + " / " + i;
    $(".externalSelect").children(".order").removeAttr("selected", "selected"),
        $(".externalSelect").children("option").removeClass("order"),
        $(".externalSelect")
            .children("option")
            .each(function () {
                var e = $(this),
                    t = $(this).attr("new");
                if (o == t) $(e).addClass("order"), !1;
            }),
        $(".externalSelect").children("option.order").prop("selected", !0),
        $(".externalSelect").val($(".externalSelect").children("option:selected").val()),
        $(".ComparePrice-product-template").removeClass("hide"),
        setTimeout(function () {
            var e = $(".externalSelect").children("option:selected").attr("price");
            $(".ProductPrice-product-template .money").html(e);
            var t = $(".externalSelect").find("option:selected").attr("compareprice");
            $(".ComparePrice-product-template .money").html(t);
            var i = $(".ComparePrice-product-template .money").text();
            t || i
                ? ($(".ComparePrice-product-template").removeClass("hide"), $(".compare_at_price").removeClass("loading"), $(".product_price").addClass("comparePriceAvail"))
                : ($(".ComparePrice-product-template").addClass("hide"), $(".compare_at_price").addClass("loading"), $(".product_price").removeClass("comparePriceAvail"));
        }, 250),
        changeSizeMobile();
}
function setFitSelectOnSize(e, t) {
    $(".externalSelect")
        .children("option")
        .each(function () {
            $(this);
            var i = $(this).attr("option1"),
                o = $(this).attr("option2"),
                s = $(this).attr("option3");
            i == e &&
                o == t &&
                $("[new=Fit]")
                    .children("option")
                    .each(function () {
                        var e = $(this),
                            t = $(this).attr("value");
                        s == t && $(e).addClass("availableFit");
                    });
        });
}
function setSizeSelectOnColor(e, t) {
    var i = $("#section_id").val();
    if (
        ($(".ProductSelect-" + i)
            .children("option")
            .each(function () {
                $(this);
                var t = $(this).attr("option2"),
                    i = $(this).attr("option1");
                if (($(this).attr("option3"), t == e)) {
                    $("[new=Size]")
                        .children("option")
                        .each(function () {
                            var e = $(this),
                                t = $(this).attr("value");
                            i == t && $(e).addClass("availableSize");
                        });
                    var o = $("[new=Size]").children("option:selected").val(),
                        s = ($("[new=Fit]").children("option:selected").val(), (o = $("[new=Size]").children("option:selected").val()), $("[new=Color]").children("option:selected").val());
                    $("[new=Fit] option").each(function () {
                        var e = $(this).val();
                        $(this).text(e);
                    }),
                        $("[new=Fit]").children("option").removeClass("availableFit"),
                        setFitSelectOnSize(o, s),
                        $(".availableFit").siblings("option").append(" (Not-Available)"),
                        $(".availableFit").siblings("option").attr("disabled", "disabled"),
                        $("[new=Fit]")
                            .children(".availableFit")
                            .each(function () {
                                var e = $(this).val();
                                $(this).text(e), $(this).removeAttr("disabled", "disabled");
                            }),
                        $("[new=Fit]")
                            .children("option")
                            .each(function () {
                                var e = $(this);
                                $(e).is(":selected") && $(e).is(":disabled") && ($(e).removeAttr("selected", "selected"), $("[new=Fit]").children(".availableFit:eq(0)").prop("selected", !0));
                            }),
                        globalSelect(o, s, $("[new=Fit]").children("option:selected").val()),
                        changeSizeMobile();
                }
            }),
        $(".availableSize").siblings("option").addClass("d-none"),
        $(".availableSize").removeClass("d-none"),
        $("option.d-none").is(":selected"))
    ) {
        $("option.d-none").siblings("option").removeAttr("selected", "selected"), $(".availableSize:eq(0)").prop("selected", !0);
        var o = $("[new=Size]").children("option:selected").val(),
            s = $("[new=Color]").children("option:selected").val();
        $("[new=Fit]").children("option").removeClass("availableFit"),
            setFitSelectOnSize(o, s),
            $(".availableFit").siblings("option").append(" (Not-Available)"),
            $(".availableFit").siblings("option").attr("disabled", "disabled"),
            $("[new=Fit]")
                .children(".availableFit")
                .each(function () {
                    var e = $(this).val();
                    $(this).text(e), $(this).removeAttr("disabled", "disabled");
                }),
            $("[new=Fit]")
                .children("option")
                .each(function () {
                    var e = $(this);
                    $(e).is(":selected") && $(e).is(":disabled") && ($(e).removeAttr("selected", "selected"), $("[new=Fit]").children(".availableFit:eq(0)").prop("selected", !0));
                });
        var a = $("[new=Fit]").children("option:selected").val();
        globalSelect(o, s, a),
            $(".swatch-element").each(function () {
                var e = $(this);
                $(this).children(".swatch-label").removeClass("selected");
                var t = $(this).children(".swatch-label").attr("title");
                s == t && ($(e).children("input").trigger("click"), $(e).children(".swatch-label").addClass("selected"), $("[new=Color]").trigger("change"));
            });
    }
}
function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos();
}
$(window).load(function () {
    $(".webyzeSwatches .swatchColor").each(function () {
        var e = $(this).attr("data-name");
        (e = (e = e.replace(/ /g, "-")).replace(/\//g, "-")), $(this).attr("data-name", e);
    });
}),
    $(document).ready(function () {
        setTimeout(function () {
            setSizeSelectOnColor($("[new=Color]").children("option:selected").val());
        }, 1500);
    }),
    (window.theme = window.theme || {}),
    (theme.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on("shopify:section:load", this._onSectionLoad.bind(this))
                .on("shopify:section:unload", this._onSectionUnload.bind(this))
                .on("shopify:section:select", this._onSelect.bind(this))
                .on("shopify:section:deselect", this._onDeselect.bind(this))
                .on("shopify:block:select", this._onBlockSelect.bind(this))
                .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function (e, t) {
            var i = $(e),
                o = i.attr("data-section-id"),
                s = i.attr("data-section-type");
            if (((t = t || this.constructors[s]), !_.isUndefined(t))) {
                var a = _.assignIn(new t(e), { id: o, type: s, container: e });
                this.instances.push(a);
            }
        },
        _onSectionLoad: function (e) {
            var t = $("[data-section-id]", e.target)[0];
            if (t) {
                this._createInstance(t);
                var i = _.find(this.instances, function (t) {
                    return t.id === e.detail.sectionId;
                });
                !_.isUndefined(i) && _.isFunction(i.onLoad) && i.onLoad(e);
            }
        },
        _onSectionUnload: function (e) {
            this.instances = _.filter(this.instances, function (t) {
                var i = t.id === e.detail.sectionId;
                return i && _.isFunction(t.onUnload) && t.onUnload(e), !i;
            });
        },
        _onSelect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e);
        },
        _onDeselect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e);
        },
        register: function (e, t) {
            (this.constructors[e] = t),
                $("[data-section-type=" + e + "]").each(
                    function (e, i) {
                        this._createInstance(i, t);
                    }.bind(this)
                );
        },
    })),
    (window.slate = window.slate || {}),
    (slate.rte = {
        wrapTable: function (e) {
            e.$tables.wrap('<div class="' + e.tableWrapperClass + '"></div>');
        },
        wrapIframe: function (e) {
            e.$iframes.each(function () {
                $(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'), (this.src = this.src);
            });
        },
    }),
    (window.slate = window.slate || {}),
    (slate.a11y = {
        pageLinkFocus: function (e) {
            var t = "js-focus-hidden";
            e.first()
                .attr("tabIndex", "-1")
                .focus()
                .addClass(t)
                .one("blur", function () {
                    e.first().removeClass(t).removeAttr("tabindex");
                });
        },
        focusHash: function () {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on(
                "click",
                function (e) {
                    this.pageLinkFocus($(e.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$elementToFocus || (e.$elementToFocus = e.$container),
                e.$container.attr("tabindex", "-1"),
                e.$elementToFocus.focus(),
                $(document).off("focusin"),
                $(document).on(t, function (t) {
                    e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus();
                });
        },
        removeTrapFocus: function (e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t);
        },
    }),
    (theme.Images = {
        preload: function (e, t) {
            "string" == typeof e && (e = [e]);
            for (var i = 0; i < e.length; i++) {
                var o = e[i];
                this.loadImage(this.getSizedImageUrl(o, t));
            }
        },
        loadImage: function (e) {
            new Image().src = e;
        },
        switchImage: function (e, t, i) {
            var o = this.imageSize(t.src),
                s = this.getSizedImageUrl(e.src, o);
            i ? i(s, e, t) : (t.src = s);
        },
        imageSize: function (e) {
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null !== t ? (void 0 !== t[2] ? t[1] + t[2] : t[1]) : null;
        },
        getSizedImageUrl: function (e, t) {
            if (null === t) return e;
            if ("master" === t) return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null === i) return null;
            var o = e.split(i[0]),
                s = i[0];
            return this.removeProtocol(o[0] + "_" + t + s);
        },
        removeProtocol: function (e) {
            return e.replace(/http(s)?:/, "");
        },
    }),
    (theme.Currency = {
        formatMoney: function (e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var i = "",
                o = /\{\{\s*(\w+)\s*\}\}/,
                s = t || "${{amount}}";
            function a(e, t, i, o) {
                if (((i = i || ","), (o = o || "."), isNaN(e) || null === e)) return 0;
                var s = (e = (e / 100).toFixed(t)).split(".");
                return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? o + s[1] : "");
            }
            switch (s.match(o)[1]) {
                case "amount":
                    i = a(e, 2);
                    break;
                case "amount_no_decimals":
                    i = a(e, 0);
                    break;
                case "amount_with_comma_separator":
                    i = a(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = a(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    i = a(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    i = a(e, 2, "'");
            }
            return s.replace(o, i);
        },
    }),
    (slate.Variants = (function () {
        function e(e) {
            (this.$container = e.$container),
                (this.product = e.product),
                (this.singleOptionSelector = e.singleOptionSelector),
                (this.originalSelectorId = e.originalSelectorId),
                (this.enableHistoryState = e.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _getCurrentOptions: function () {
                    var e = _.map($(this.singleOptionSelector, this.$container), function (e) {
                        var t = $(e),
                            i = t.attr("type"),
                            o = {};
                        return "radio" === i || "checkbox" === i ? !!t[0].checked && ((o.value = t.val()), (o.index = t.data("index")), o) : ((o.value = t.val()), (o.index = t.data("index")), o);
                    });
                    return _.compact(e);
                },
                _getVariantFromOptions: function () {
                    var e = this._getCurrentOptions(),
                        t = this.product.variants;
                    return _.find(t, function (t) {
                        return e.every(function (e) {
                            return _.isEqual(t[e.index], e.value);
                        });
                    });
                },
                _onSelectChange: function () {
                    var e = this._getVariantFromOptions();
                    this.$container.trigger({ type: "variantChange", variant: e }),
                        e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
                },
                _updateImages: function (e) {
                    var t = e.featured_image || {},
                        i = this.currentVariant.featured_image || {};
                    e.featured_image && t.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: e });
                },
                _updatePrice: function (e) {
                    (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant: e });
                },
                _updateSKU: function (e) {
                    e.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: e });
                },
                _updateHistoryState: function (e) {
                    if (history.replaceState && e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({ path: t }, "", t);
                    }
                },
                _updateMasterSelect: function (e) {
                    $(this.originalSelectorId, this.$container).val(e.id);
                },
            })),
            e
        );
    })()),
    (theme.Drawers = (function () {
        function e(e, t, i) {
            var o = { close: ".js-drawer-close", open: ".js-drawer-open-" + t, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + t };
            if (((this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer") }), (this.config = $.extend(o, i)), (this.position = t), (this.$drawer = $("#" + e)), !this.$drawer.length)) return !1;
            (this.drawerIsOpen = !1), this.init();
        }
        return (
            (e.prototype.init = function () {
                $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
            }),
            (e.prototype.open = function (e) {
                var t = !1;
                return (
                    e ? e.preventDefault() : (t = !0),
                    e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))),
                    this.drawerIsOpen && !t
                        ? this.close()
                        : (this.$drawer.prepareTransition(),
                          this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass),
                          (this.drawerIsOpen = !0),
                          slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                          this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()),
                          this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                          this.bindEvents(),
                          this)
                );
            }),
            (e.prototype.close = function () {
                this.drawerIsOpen &&
                    ($(document.activeElement).trigger("blur"),
                    this.$drawer.prepareTransition(),
                    this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass),
                    (this.drawerIsOpen = !1),
                    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                    this.unbindEvents());
            }),
            (e.prototype.bindEvents = function () {
                this.nodes.$parent.on(
                    "keyup.drawer",
                    $.proxy(function (e) {
                        return 27 !== e.keyCode || (this.close(), !1);
                    }, this)
                ),
                    this.nodes.$page.on("touchmove.drawer", function () {
                        return !1;
                    }),
                    this.nodes.$page.on(
                        "click.drawer",
                        $.proxy(function () {
                            return this.close(), !1;
                        }, this)
                    );
            }),
            (e.prototype.unbindEvents = function () {
                this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
            }),
            e
        );
    })()),
    (theme.Search = (function () {
        var e = ".header__search, .mobile-header__search",
            t = ".search__input",
            i = ".search__toggle",
            o = ".search__fullscreen",
            s = ".search__results",
            a = {};
        return {
            init: function () {
                $(e).length &&
                    ($(".search__ajax.no-js").each(function () {
                        var e = $(this),
                            i = e.find(t),
                            n = null,
                            r = e.data("limit"),
                            c = e.data("featured"),
                            l = e.data("featured_limit");
                        i.off("keyup"),
                            i.on("keyup", function () {
                                clearTimeout(n),
                                    (n = setTimeout(function () {
                                        var t = i.val();
                                        if (1 < t.length)
                                            if (t in a) {
                                                var n = a[t];
                                                $(s).html(n.html), $(n.html).find(".not__found").length && !$(n.html).find(".featured_title").length ? e.closest(o).removeClass("searching") : e.closest(o).addClass("searching");
                                            } else {
                                                $(s).empty();
                                                var d = { view: "search", type: "product", searched_limit: r, featured: c, featured_limit: l, q: "*" + t + "*", cache: !1 };
                                                $.ajax({
                                                    url: "/search",
                                                    data: d,
                                                    dataType: "html",
                                                    type: "GET",
                                                    beforeSend: function () {
                                                        e.addClass("loading").addClass("searching");
                                                    },
                                                    complete: function () {
                                                        e.removeClass("loading");
                                                    },
                                                    success: function (i) {
                                                        setTimeout(function () {
                                                            $(s).html(i),
                                                                $(i).find(".not__found").length && !$(i).find(".featured_title").length ? e.closest(o).removeClass("searching") : e.closest(o).addClass("searching"),
                                                                (a[t] = { found: !0, html: i });
                                                        }, 650);
                                                    },
                                                });
                                            }
                                        else $(s).empty();
                                    }, 500));
                            }),
                            e.removeClass("no-js");
                    }),
                    $(document).off("click", i),
                    $(document).on("click", i, function (e) {
                        e.preventDefault();
                        var i = $("body"),
                            o = $(this).closest(".header__search"),
                            a = $(".search__label-text", o);
                        o.hasClass("opened") ? (i.removeClass("search-opened"), o.removeClass("opened")) : (i.addClass("search-opened"), o.addClass("opened"), $(t, o).val(""), $(s, o).empty(), $(t, o).focus()),
                            a.length &&
                                "0" == a.attr("data-first_time") &&
                                (a.attr("data-first_time", "1"),
                                (function (e) {
                                    if (void 0 !== $.fn.typed) {
                                        var i = "^800 " + $(".search__label-text", e).data("typedtext"),
                                            o = $(".search__label-text", e).data("typedtext_2");
                                        $(".search__label-text", e).typed({ strings: [i, o], typeSpeed: 30, backSpeed: 20 }),
                                            $(".search__label", e).on("click", function () {
                                                $(this).fadeOut(200, function () {
                                                    $(this).addClass("hide");
                                                }),
                                                    $(t, e).focus();
                                            });
                                    }
                                })(o));
                    }),
                    $(document).keyup(function (t) {
                        if (27 == t.keyCode) {
                            var i = $(e);
                            i.hasClass("opened") && ($("body").removeClass("search-opened"), i.removeClass("opened"));
                        }
                    }),
                    $(document).mouseup(function (t) {
                        var s = $(i),
                            a = $(o);
                        if (!s.is(t.target) && 0 === s.has(t.target).length && !a.is(t.target) && 0 === a.has(t.target).length) {
                            var n = $(e);
                            n.hasClass("opened") && ($("body").removeClass("search-opened"), n.removeClass("opened"));
                        }
                    }));
            },
        };
    })()),
    (theme.CurrencyPicker = (function () {
        var e = {
                selector: ".money",
                container: ".currency__picker",
                currency: ".currency__picker .ml__switcher",
                currencyPicker: ".currency__picker .currency",
                currencyActive: ".currency__picker .currency.active",
                currencyCurrent: ".currency__picker .ml__current",
                currencyNotification: ".currency__notification",
            },
            t = { currency_format: "", shop_currency: "", default_currency: "", money_with_currency_format: "", money_format: "", auto_switch: "true", original_price: "true" };
        function i() {
            if ("false" == t.original_price) return !1;
            var i = Currency.currentCurrency,
                o = Currency.cookie.read(),
                s = t.shop_currency;
            o && (i = o),
                $(e.selector).each(function () {
                    var e = $(this);
                    if ((e.removeAttr("data-currency-default"), s != i)) {
                        var t = e.attr("data-currency-" + s);
                        "USD" == s && (t += " USD"), e.attr("data-currency-default", t);
                    }
                });
        }
        function o() {
            $(e.currencyNotification).length &&
                $(e.currency).length &&
                $(e.currency).hasClass("ml__js") &&
                (Currency.currentCurrency != t.shop_currency
                    ? $(e.currencyNotification).each(function () {
                          var e = $(this),
                              t = e.data("html"),
                              i = "<strong>" + Currency.currentCurrency + "</strong>";
                          (t = t.replace(new RegExp("{{ current_currency }}", "g"), i)), e.html(t), e.hasClass("loaded") || e.addClass("loaded").slideDown();
                      })
                    : $(e.currencyNotification).removeClass("loaded").slideUp());
        }
        return {
            init: function () {
                $(e.currency).length &&
                    ($(e.currency).hasClass("ml__js")
                        ? (function () {
                              var s = $(e.container);
                              (t.currency_format = s.find(".currency_format").val()),
                                  (t.shop_currency = s.find(".shop_currency").val()),
                                  (t.default_currency = s.find(".default_currency").val()),
                                  (t.money_with_currency_format = s.find(".money_with_currency_format").val()),
                                  (t.money_format = s.find(".money_format").val()),
                                  (t.auto_switch = s.find(".auto_switch").val()),
                                  (t.original_price = s.find(".original_price").val()),
                                  (Currency.format = t.currency_format);
                              var a = t.shop_currency;
                              (Currency.moneyFormats[a].money_with_currency_format = t.money_with_currency_format), (Currency.moneyFormats[a].money_format = t.money_format);
                              var n = t.default_currency,
                                  r = Currency.cookie.read();
                              $(".money .money").each(function () {
                                  $(this).parents(".money").removeClass("money");
                              }),
                                  $(e.selector).each(function () {
                                      var e = $(this);
                                      if (void 0 === e.attr("data-currency-" + t.shop_currency)) {
                                          var i = e.text();
                                          e.attr("data-currency-" + t.shop_currency, i);
                                      }
                                  }),
                                  null == r
                                      ? a !== n
                                          ? Currency.convertAll(a, n, e.selector)
                                          : (Currency.currentCurrency = n)
                                      : $(e.currency).length && 0 === $(e.currency + " .currency[data-code=" + r + "]").size()
                                      ? ((Currency.currentCurrency = a), Currency.cookie.write(a))
                                      : r === a
                                      ? (Currency.currentCurrency = a)
                                      : Currency.convertAll(a, r, e.selector),
                                  $(e.currency).off("click", ".currency:not(.active)"),
                                  $(e.currency).on("click", ".currency:not(.active)", function () {
                                      var t = $(this).data("code");
                                      Currency.convertAll(Currency.currentCurrency, t, e.selector),
                                          $(e.currencyPicker).removeClass("active"),
                                          $(this).addClass("active"),
                                          $(e.currencyCurrent).text(Currency.currentCurrency).attr("data-code", Currency.currentCurrency),
                                          i(),
                                          o();
                                  }),
                                  window.selectCallback,
                                  $(e.currencyPicker).removeClass("active"),
                                  $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"),
                                  $(e.currencyCurrent).text(Currency.currentCurrency).attr("data-code", Currency.currentCurrency),
                                  i(),
                                  "false" != t.auto_switch &&
                                      null == Currency.cookie.read() &&
                                      $.getJSON("//ipinfo.io/json", function (t) {
                                          var i = JSON.parse(JSON.stringify(t, null, 2));
                                          void 0 !== i.country &&
                                              $.getJSON("//restcountries.eu/rest/v1/alpha/" + i.country, function (t) {
                                                  var i = t.currencies[0];
                                                  $(e.currencyPicker + '[data-code="' + i + '"]').trigger("click");
                                              });
                                      }),
                                  o();
                          })()
                        : ($(e.currency).off("click", ".currency:not(.active)"),
                          $(e.currency).on("click", ".currency:not(.active)", function () {
                              var e = $(this).data("code"),
                                  t = window.location,
                                  i = t.pathname + t.search + t.hash,
                                  o = document.createElement("form");
                              o.setAttribute("action", "/cart/update"), o.setAttribute("method", "POST"), o.setAttribute("style", "display:none");
                              var s = document.createElement("input");
                              s.setAttribute("type", "hidden"), s.setAttribute("name", "form_type"), s.setAttribute("value", "currency");
                              var a = document.createElement("input");
                              a.setAttribute("type", "hidden"), a.setAttribute("name", "currency"), a.setAttribute("value", e);
                              var n = document.createElement("input");
                              n.setAttribute("type", "hidden"), n.setAttribute("name", "return_to"), n.setAttribute("value", i), o.appendChild(s), o.appendChild(a), o.appendChild(n), $(o).appendTo("body").submit();
                          })));
            },
            convert: function (o) {
                $(e.currency).length &&
                    $(e.currency).hasClass("ml__js") &&
                    ($(o).each(function () {
                        var e = $(this);
                        if (void 0 === e.attr("data-currency-" + t.shop_currency)) {
                            var i = e.text();
                            e.attr("data-currency-" + t.shop_currency, i);
                        }
                    }),
                    Currency.convertAll(t.shop_currency, $(e.currencyActive).attr("data-code"), o, t.currency_format),
                    i());
            },
            convertAll: function () {
                $(e.currency).length &&
                    $(e.currency).hasClass("ml__js") &&
                    ($(e.selector).each(function () {
                        var e = $(this);
                        if (void 0 === e.attr("data-currency-" + t.shop_currency)) {
                            var i = e.text();
                            e.attr("data-currency-" + t.shop_currency, i);
                        }
                    }),
                    Currency.convertAll(t.shop_currency, $(e.currencyActive).attr("data-code"), e.selector),
                    i());
            },
        };
    })()),
    (theme.LanguagePicker = (function () {
        var e = { language: ".language__picker .ml__switcher", languagePicker: ".language__picker .language", languageCurrent: ".language__picker .ml__current", selector: "#weketing_google_translate_element" };
        function t(t) {
            $(e.selector + " .goog-te-combo").val(t);
            var i,
                o = document.getElementsByClassName("goog-te-combo")[0];
            document.createEvent ? ((i = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.dispatchEvent(i)) : (((i = document.createEventObject()).eventType = "change"), o.fireEvent("on" + i.eventType, i));
        }
        function i() {
            if (!$(e.language).hasClass("skip")) {
                $(e.language).addClass("skip");
                var i = weketingJS.settingsJS[8];
                if ("yes" == i.enable) {
                    for (var o = i.default_language, s = i.custom_languages, a = weketingSGT.languages(), n = localStorage.getItem("roarStorage_language"), r = 0; r < s.length - 1; r++)
                        if (s[r] == o) {
                            s.pop();
                            break;
                        }
                    for (r = 0; r < s.length; r++)
                        if (s[r] == n) {
                            o = n;
                            break;
                        }
                    for (r = 0; r < s.length; r++) {
                        var c = '<li><a href="javascript:void(0);" class="language active notranslate" data-code="' + o + '">' + a[o] + "</a></li>";
                        s[r] != o && (c = '<li><a href="javascript:void(0);" class="language notranslate" data-code="' + s[r] + '">' + a[s[r]] + "</a></li>"), $(e.language).append(c);
                    }
                    $(e.language).closest(".language__picker").removeClass("hide"), $(e.languageCurrent).text(a[o]), t(o);
                }
            }
        }
        return {
            init: function () {
                $(e.language).length &&
                    $(e.selector).length &&
                    ("undefined" != typeof weketingJS && void 0 !== weketingJS.settingsJS[8]
                        ? i()
                        : $(e.selector).bind("google_translate", function () {
                              i();
                          }),
                    $(document).off("click", e.languagePicker + ":not(.active)"),
                    $(document).on("click", e.languagePicker + ":not(.active)", function () {
                        var i = $(this).data("code");
                        if ("" != i) {
                            var o = $(this).text();
                            $(e.languagePicker).removeClass("active"), $(e.languagePicker + '[data-code="' + i + '"]').addClass("active"), $(e.languageCurrent).text(o), localStorage.setItem("roarStorage_language", i), t(i);
                        }
                    }));
            },
        };
    })()),
    (theme.MiniCart = (function () {
        var e = {
            headerSticky: ".header-sticky__placeholder",
            headerCart: ".header__cart .cart__link",
            miniCart: ".minicart",
            miniCartAgree: ".minicart .cart__agree",
            miniCartCheckout: ".minicart .btn-checkout",
            miniCartRemove: ".minicart .item__remove",
            miniCartClose: ".minicart .cart__close, .minicart__overlay",
        };
        function t(t) {
            return (
                void 0 === t && (t = 0),
                $(e.miniCart).addClass("loading"),
                $.get("/search", function (i) {
                    $(e.miniCart).each(function () {
                        var t = $(this),
                            o = "";
                        t.hasClass("minicart-frame") ? (o = ".minicart-frame") : t.hasClass("minicart-sidebar") && (o = ".minicart-sidebar");
                        var s = $(i).find(e.miniCart + o);
                        t.removeClass("loading").html(s.html());
                        var a = t.prev();
                        a.html(s.prev().html()),
                            a.addClass("anim"),
                            setTimeout(function () {
                                a.removeClass("anim");
                            }, 2e3);
                    }),
                        0 < t && $(".product__" + t + " .addcart_btn").removeClass("added");
                })
            );
        }
        return {
            init: function () {
                $(document).off("click", e.headerCart),
                    $(document).on("click", e.headerCart, function (t) {
                        var i = $(this).parent().find(e.miniCart);
                        i.length &&
                            i.hasClass("minicart-sidebar") &&
                            ($(e.miniCart).each(function () {
                                i.attr("id") != $(this).attr("id") && $(this).removeClass("opened");
                            }),
                            i.hasClass("opened") ? i.removeClass("opened") : (i.addClass("opened"), $("body").addClass("cart-opened"), theme.MiniCart.anim()),
                            t.preventDefault());
                    }),
                    $(document).off("change", e.miniCartAgree),
                    $(document).on("change", e.miniCartAgree, function (t) {
                        $(this).is(":checked") ? ($(e.miniCartAgree).prop("checked", !0), $(e.miniCartCheckout).removeClass("btn-disabled")) : ($(e.miniCartAgree).prop("checked", !1), $(e.miniCartCheckout).addClass("btn-disabled"));
                    }),
                    $(document).off("click", e.miniCartCheckout),
                    $(document).on("click", e.miniCartCheckout, function (t) {
                        if ($(e.miniCartAgree).length) {
                            var i = $(e.miniCartAgree);
                            if (!i.is(":checked")) {
                                var o = i.data("message");
                                alert(o), t.preventDefault();
                            }
                        }
                    }),
                    $(document).off("click", e.miniCartRemove),
                    $(document).on("click", e.miniCartRemove, function (i) {
                        i.preventDefault();
                        var o = $(this),
                            s = o.attr("href"),
                            a = o.data("product_id");
                        $(e.miniCart).addClass("loading"),
                            $.post(s, function () {
                                t(a);
                            });
                    }),
                    $(document).off("click", e.miniCartClose),
                    $(document).on("click", e.miniCartClose, function () {
                        $(e.miniCart).removeClass("loading").removeClass("opened"), $("body").removeClass("cart-opened");
                    });
            },
            update: t,
            open: function () {
                if ($(e.miniCart).length) {
                    if ($(e.headerSticky).length && $(e.headerSticky).hasClass("stick")) {
                        var t = $(e.headerSticky).find(e.headerCart);
                        if (t.length) {
                            var i = t.closest(".header__cart").find(e.miniCart);
                            if (i.length && i.hasClass("minicart-sidebar") && !i.hasClass("opened")) return t.trigger("click"), !1;
                        }
                    }
                    $(e.headerCart).each(function () {
                        var t = $(this);
                        if (t.is(":visible")) {
                            var i = t.closest(".header__cart").find(e.miniCart);
                            if (i.length && i.hasClass("minicart-sidebar") && !i.hasClass("opened")) return t.trigger("click"), !1;
                        }
                    });
                }
            },
            anim: function () {
                var e = new TimelineLite(),
                    t = $(".minicart .cart__content"),
                    i = $(".minicart .cart__item"),
                    o = $(".minicart .cart__total"),
                    s = $(".minicart .cart__actions"),
                    a = $(".minicart .cart__empty"),
                    n = $(".minicart .cart__return");
                theme.settings.rtl
                    ? (e.fromTo(t, 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeIn }, 0.1),
                      e.staggerFromTo(i, 0.5, { opacity: 0, skewX: -20, x: -60 }, { opacity: 1, skewX: 0, x: 0 }, 0.1, 0.2),
                      e.fromTo(o, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.2),
                      e.fromTo(s, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.3),
                      e.fromTo(a, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.2),
                      e.fromTo(n, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.3))
                    : (e.fromTo(t, 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeIn }, 0.1),
                      e.staggerFromTo(i, 0.5, { opacity: 0, skewX: 20, x: 60 }, { opacity: 1, skewX: 0, x: 0 }, 0.1, 0.2),
                      e.fromTo(o, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.2),
                      e.fromTo(s, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.3),
                      e.fromTo(a, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.2),
                      e.fromTo(n, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.3));
            },
        };
    })()),
    (function () {
        var e = $(".return-link");
        function t(e) {
            var t = document.createElement("a");
            return (t.ref = e), t.hostname;
        }
        document.referrer &&
            e.length &&
            window.history.length &&
            e.one("click", function (e) {
                e.preventDefault();
                var i = t(document.referrer);
                return t(window.location.href) === i && history.back(), !1;
            });
    })(),
    (theme.SlideshowSection = (function () {
        function e(e) {
            var t = (this.$container = $(e)),
                i = (this.sectionId = t.attr("data-section-id")),
                o = (this.slideshow = "#Slideshow-" + i);
            $(".slideshow__video", o).each(function () {
                var e = $(this);
                theme.SlideshowVideo.init(e), theme.SlideshowVideo.loadVideo(e.attr("id"));
            }),
                this.beforeInit(),
                this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                beforeInit: function () {
                    var e = 0.01 * window.innerHeight;
                    document.documentElement.style.setProperty("--vh", e + "px"),
                        window.addEventListener("resize", function () {
                            var e = 0.01 * window.innerHeight;
                            document.documentElement.style.setProperty("--vh", e + "px");
                        });
                },
                init: function () {
                    var e = $(this.slideshow),
                        t = e.data("autoplay"),
                        i = e.data("speed"),
                        o = e.find(".slideshow__image"),
                        s = new Flickity(this.slideshow, {
                            bgLazyLoad: 1,
                            imagesLoaded: !0,
                            accessibility: !0,
                            prevNextButtons: !0,
                            pageDots: !0,
                            contain: !0,
                            wrapAround: !0,
                          pauseAutoPlayOnHover: !1,
                            setGallerySize: !1,
                            autoPlay: !!t && i,
                            arrowShape: { x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15 },
                            on: {
                                ready: function () {
                                    new TimelineLite(), e.find(".flickity-slider"), e.find(".slider-content-wrapper"), e.find(".flickity-button svg"), e.find(".flickity-page-dots");
                                },
                            },
                        });
                    s.on("scroll", function () {
                        s.slides.forEach(function (e, t) {
                            var i = o[t],
                                a = 0;
                            i &&
                                ((a =
                                    0 === t
                                        ? Math.abs(s.x) > s.slidesWidth
                                            ? s.slidesWidth + s.x + s.slides[s.slides.length - 1].outerWidth + e.target
                                            : e.target + s.x
                                        : t === s.slides.length - 1 && Math.abs(s.x) + s.slides[t].outerWidth < s.slidesWidth
                                        ? e.target - s.slidesWidth + s.x - s.slides[t].outerWidth
                                        : e.target + s.x),
                                void 0 === window.mobileCheck || window.mobileCheck() || (i.style.transform = "translateX(" + -0.5 * a + "px)"));
                        });
                    });
                },
                onSelect: function () {
                    void 0 !== theme.roarAdminJs && theme.roarAdminJs.refresh();
                },
            })),
            e
        );
    })()),
    (theme.Slideshow = (function () {
        this.$slideshow = null;
        var e = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            currentSlide: "slick-current",
            video: "slideshow__video",
            videoBackground: "slideshow__video--background",
            closeVideoBtn: "slideshow__video-control--close",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused",
        };
        function t(t) {
            (this.$slideshow = $(t)), (this.$wrapper = this.$slideshow.closest("." + e.wrapper)), (this.$pause = this.$wrapper.find("." + e.pauseButton));
            var i = this.$slideshow.data("arrows") || !1,
                o = this.$slideshow.data("dots") || !1,
                s = this.$slideshow.data("autoplay") || !1,
                a = parseInt(this.$slideshow.data("speed")) || 7e3,
                n = parseInt(this.$slideshow.data("per_view")) || 1;
            (this.settings = { mediaQueryMediumUp: "screen and (min-width: 768px)", mediaQuerySmall: "screen and (max-width: 767px)", arrows: i, dots: o, autoplay: s, speed: a, per_view: n, sliderImagesActive: !1 }), this.initBreakpoints();
        }
        function i(t) {
            return t.find("." + e.video).length;
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                initBreakpoints: function () {
                    var e = this;
                    enquire.register(e.settings.mediaQuerySmall, {
                        match: function () {
                            e.settings.sliderImagesActive && e.destroyImageSlider(), e.initImageSlider();
                        },
                    }),
                        enquire.register(e.settings.mediaQueryMediumUp, {
                            match: function () {
                                e.settings.sliderImagesActive && e.destroyImageSlider(), e.initImageSlider(!1);
                            },
                        });
                },
                destroyImageSlider: function () {
                    $(this.$slideshow).slick("unslick"), (this.settings.sliderImagesActive = !1);
                },
                initImageSlider: function (t) {
                    void 0 === t && (t = !0);
                    var o = {
                        rtl: theme.settings.rtl,
                        accessibility: !0,
                        arrows: this.settings.arrows,
                        dots: this.settings.dots,
                        fade: !this.settings.per_view,
                        speed: 1e3,
                        delay: 1600,
                        draggable: !0,
                        autoplay: this.settings.autoplay,
                        autoplaySpeed: this.settings.speed,
                        slidesToShow: this.settings.per_view,
                        slidesToScroll: 1,
                        prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
                        nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
                    };
                    1 == t && ((o.fade = !1), (o.draggable = !0), (o.slidesToShow = 1), (o.arrows = !1), (o.dots = !0)),
                        this.$slideshow.on(
                            "beforeChange",
                            function (t, o, s, a, n) {
                                var r = o.$slider,
                                    c = r.find("." + e.currentSlide),
                                    l = r.find('.slick-slide[data-slick-index="' + a + '"]');
                                if (i(c)) {
                                    var d = c.find("." + e.video),
                                        u = d.attr("id");
                                    theme.SlideshowVideo.pauseVideo(u), d.attr("tabindex", "-1");
                                }
                                if (i(l)) {
                                    var h = l.find("." + e.video),
                                        p = h.attr("id");
                                    h.hasClass(e.videoBackground) ? theme.SlideshowVideo.playVideo(p) : h.attr("tabindex", "0");
                                }
                                c.removeClass("slick-anim"), r.find('.slick-slide[data-slick-index="' + n + '"]').addClass("slick-anim"), r.find(".slick-arrow").addClass("disabled");
                            }.bind(this)
                        ),
                        this.$slideshow.on(
                            "afterChange",
                            function (e, t, i) {
                                t.$slider.find(".slick-arrow").removeClass("disabled");
                            }.bind(this)
                        ),
                        this.$slideshow.on(
                            "init",
                            function (t, i) {
                                var o = i.$slider,
                                    s = i.$list,
                                    a = this.$wrapper,
                                    n = this.settings.autoplay;
                                s.removeAttr("aria-live"),
                                    a.on("focusin", function (e) {
                                        a.has(e.target).length && (s.attr("aria-live", "polite"), n && o.slick("slickPause"));
                                    }),
                                    a.on("focusout", function (t) {
                                        if (a.has(t.target).length && (s.removeAttr("aria-live"), n)) {
                                            if ($(t.target).hasClass(e.closeVideoBtn)) return;
                                            o.slick("slickPlay");
                                        }
                                    }),
                                    i.$dots &&
                                        i.$dots.on("keydown", function (e) {
                                            37 === e.which && o.slick("slickPrev"), 39 === e.which && o.slick("slickNext"), (37 !== e.which && 39 !== e.which) || i.$dots.find(".slick-active button").focus();
                                        }),
                                    o.find("." + e.currentSlide).addClass("slick-anim"),
                                    new TimelineLite(),
                                    o.find(".slideshow__text-text"),
                                    o.find(".slick-arrow svg"),
                                    o.find(".slick-dots");
                            }.bind(this)
                        ),
                        this.$slideshow.slick(o),
                        this.$pause.on("click", this.togglePause.bind(this)),
                        (this.settings.sliderImagesActive = !0);
                },
                togglePause: function () {
                    var t = (function (e) {
                        return "#Slideshow-" + e.data("id");
                    })(this.$pause);
                    this.$pause.hasClass(e.isPaused) ? (this.$pause.removeClass(e.isPaused), $(t).slick("slickPlay")) : (this.$pause.addClass(e.isPaused), $(t).slick("slickPause"));
                },
            })),
            t
        );
    })()),
    (theme.SlideshowVideo = (function () {
        var e = !1,
            t = !1,
            i = !1,
            o = !1,
            s = !1,
            a = {},
            n = [],
            r = {
                ratio: 16 / 9,
                playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                events: {
                    onReady: function (e) {
                        e.target.setPlaybackQuality("hd1080");
                        var t = m(e);
                        switch ((i || ($(window).width() < 750 ? (o = !0) : void 0 !== window.mobileCheck && window.mobileCheck() && (o = !0), o && d(!1), (i = !0)), $("#" + t.id).attr("tabindex", "-1"), f(), t.type)) {
                            case "background-chrome":
                            case "background":
                                e.target.mute(), t.$parentSlide.closest("." + c.slickSlide).hasClass(c.currentSlide) && l(t.id);
                        }
                        t.$parentSlide.addClass(c.loaded);
                    },
                    onStateChange: function (e) {
                        var t = m(e);
                        switch (e.data) {
                            case 0:
                                !(function (e) {
                                    switch (e.type) {
                                        case "background":
                                            n[e.id].seekTo(0);
                                            break;
                                        case "background-chrome":
                                            n[e.id].seekTo(0), p(e.id);
                                            break;
                                        case "chrome":
                                            p(e.id);
                                    }
                                })(t);
                                break;
                            case 1:
                                u(t);
                                break;
                            case 2:
                                h(t);
                        }
                    },
                },
            },
            c = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "slideshow-wrapper",
                slide: "slideshow__slide",
                slideBackgroundVideo: "slideshow__slide--background-video",
                slideDots: "slick-dots",
                videoChrome: "slideshow__video--chrome",
                videoBackground: "slideshow__video--background",
                playVideoBtn: "slideshow__video-control--play",
                closeVideoBtn: "slideshow__video-control--close",
                currentSlide: "slick-current",
                slickSlide: "slick-slide",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay",
            };
        function l(i, s) {
            var r = a[i],
                l = n[i],
                h = a[i].$parentSlide;
            if (o) u(r);
            else if (s || (e && t)) return h.removeClass(c.loading), u(r), void l.playVideo();
            e ||
                (function (i, o) {
                    i.playVideo(),
                        (function (e) {
                            var i,
                                o,
                                s = $.Deferred();
                            return (
                                (i = setInterval(function () {
                                    e.getCurrentTime() <= 0 || ((t = !0), clearInterval(i), clearTimeout(o), s.resolve());
                                }, 500)),
                                (o = setTimeout(function () {
                                    clearInterval(i), s.reject();
                                }, 4e3)),
                                s
                            );
                        })(i)
                            .then(function () {
                                d(!0);
                            })
                            .fail(function () {
                                d(!1), i.stopVideo();
                            })
                            .always(function () {
                                (e = !0), o.removeClass(c.loading);
                            });
                })(l, h);
        }
        function d(t) {
            var i = t ? c.supportsAutoplay : c.supportsNoAutoplay;
            $(document.documentElement).addClass(i), t || (o = !0), (e = !0);
        }
        function u(e) {
            var t = e.$parentSlideshowWrapper,
                i = e.$parentSlide;
            if ((i.removeClass(c.loading), "background" !== e.status)) {
                switch (($("#" + e.id).attr("tabindex", "0"), e.type)) {
                    case "chrome":
                    case "background-chrome":
                        t.removeClass(c.paused).addClass(c.playing), i.removeClass(c.paused).addClass(c.playing);
                }
                i.find("." + c.closeVideoBtn).focus();
            }
        }
        function h(e) {
            var t = e.$parentSlideshowWrapper,
                i = e.$parentSlide;
            "background-chrome" !== e.type
                ? ("closed" !== e.status && "background" !== e.type && (t.addClass(c.paused), i.addClass(c.paused)),
                  "chrome" === e.type && "closed" === e.status && (t.removeClass(c.paused), i.removeClass(c.paused)),
                  t.removeClass(c.playing),
                  i.removeClass(c.playing))
                : p(e.id);
        }
        function p(e) {
            var t = a[e],
                i = t.$parentSlideshowWrapper,
                o = t.$parentSlide,
                s = [c.pause, c.playing].join(" ");
            switch (($("#" + t.id).attr("tabindex", "-1"), (t.status = "closed"), t.type)) {
                case "background-chrome":
                    n[e].mute(),
                        (function (e) {
                            var t = $("#" + e)
                                .addClass(c.videoBackground)
                                .removeClass(c.videoChrome);
                            a[e].$parentSlide.addClass(c.slideBackgroundVideo), (a[e].status = "background"), g(t);
                        })(e);
                    break;
                case "chrome":
                    n[e].stopVideo(), h(t);
            }
            i.removeClass(s), o.removeClass(s);
        }
        function m(e) {
            return a[e.target.a.id];
        }
        function f() {
            $("." + c.videoBackground).each(function (e, t) {
                g($(t));
            });
        }
        function g(e) {
            var t = e.closest("." + c.slide);
            if (!t.hasClass(c.slickClone)) {
                var i = t.width(),
                    o = e.width(),
                    s = e.height();
                i / r.ratio < s
                    ? ((o = Math.ceil(s * r.ratio)),
                      e
                          .width(o)
                          .height(s)
                          .css({ left: (i - o) / 2, top: 0 }))
                    : ((s = Math.ceil(i / r.ratio)),
                      e
                          .width(i)
                          .height(s)
                          .css({ left: 0, top: (s - s) / 2 })),
                    e.prepareTransition().addClass(c.loaded);
            }
        }
        function v() {
            $(document).on("click.videoPlayer", "." + c.playVideoBtn, function (e) {
                !(function (e) {
                    var t = a[e];
                    switch ((t.$parentSlide.addClass(c.loading), (t.status = "open"), t.type)) {
                        case "background-chrome":
                            !(function (e) {
                                $("#" + e)
                                    .removeAttr("style")
                                    .removeClass(c.videoBackground)
                                    .addClass(c.videoChrome),
                                    a[e].$parentSlideshowWrapper.removeClass(c.slideBackgroundVideo).addClass(c.playing),
                                    a[e].$parentSlide.removeClass(c.slideBackgroundVideo).addClass(c.playing),
                                    (a[e].status = "open");
                            })(e),
                                n[e].unMute(),
                                l(e, !0);
                            break;
                        case "chrome":
                            l(e, !0);
                    }
                    $(document).on("keydown.videoPlayer", function (t) {
                        27 === t.keyCode && p(e);
                    });
                })($(e.currentTarget).data("controls"));
            }),
                $(document).on("click.videoPlayer", "." + c.closeVideoBtn, function (e) {
                    p($(e.currentTarget).data("controls"));
                }),
                $(window).on(
                    "resize.videoPlayer",
                    $.debounce(250, function () {
                        s && f();
                    })
                );
        }
        return {
            init: function (e) {
                if (
                    e.length &&
                    ((a[e.attr("id")] = {
                        id: e.attr("id"),
                        videoId: e.data("id"),
                        type: e.data("type"),
                        status: "chrome" === e.data("type") ? "closed" : "background",
                        videoSelector: e.attr("id"),
                        $parentSlide: e.closest("." + c.slide),
                        $parentSlideshowWrapper: e.closest("." + c.slideshowWrapper),
                        controls: "background" === e.data("type") ? 0 : 1,
                        slideshow: e.data("slideshow"),
                    }),
                    !s)
                ) {
                    var t = document.createElement("script");
                    t.src = "https://www.youtube.com/iframe_api";
                    var i = document.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(t, i);
                }
            },
            loadVideos: function () {
                for (var e in a)
                    if (a.hasOwnProperty(e)) {
                        var t = $.extend({}, r, a[e]);
                        (t.playerVars.controls = t.controls), (n[e] = new YT.Player(e, t));
                    }
                v(), (s = !0);
            },
            loadVideo: function (e) {
                if (s) {
                    var t = $.extend({}, r, a[e]);
                    (t.playerVars.controls = t.controls), (n[e] = new YT.Player(e, t)), v();
                }
            },
            playVideo: function (e) {
                (i || o) && e && "function" == typeof n[e].playVideo && l(e);
            },
            pauseVideo: function (e) {
                n[e] && "function" == typeof n[e].pauseVideo && n[e].pauseVideo();
            },
            removeEvents: function () {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
            },
        };
    })()),
    (function () {
        var e = $("#BlogTagFilter");
        e.length &&
            e.on("change", function () {
                location.href = $(this).val();
            });
    })(),
    (window.theme = theme || {}),
    (theme.customerTemplates = (function () {
        function e() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
        }
        return {
            init: function () {
                var t;
                "#recover" === window.location.hash && e(),
                    $(document).off("click", "#RecoverPassword"),
                    $(document).on("click", "#RecoverPassword", function (t) {
                        t.preventDefault(), e();
                    }),
                    $(document).off("click", "#HideRecoverPasswordLink"),
                    $(document).on("click", "#HideRecoverPasswordLink", function (t) {
                        t.preventDefault(), e();
                    }),
                    $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"),
                    (t = $("#AddressNewForm")).length &&
                        (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                        $(".address-country-option").each(function () {
                            var e = $(this).data("form-id"),
                                t = "AddressCountry_" + e,
                                i = "AddressProvince_" + e,
                                o = "AddressProvinceContainer_" + e;
                            new Shopify.CountryProvinceSelector(t, i, { hideElement: o });
                        }),
                        $(".address-new-toggle").on("click", function () {
                            t.toggleClass("hide");
                        }),
                        $(".address-edit-toggle").on("click", function () {
                            var e = $(this).data("form-id");
                            $("#EditAddress_" + e).toggleClass("hide");
                        }),
                        $(".address-delete").on("click", function () {
                            var e = $(this),
                                t = e.data("form-id"),
                                i = e.data("confirm-message");
                            confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, { parameters: { _method: "delete" } });
                        }));
            },
        };
    })()),
    (theme.Cart = (function () {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.settings = { namespace: "#CartSection-" + t, sectionId: t }),
                (this.selectors = {
                    quantity: ".item__qty-" + t,
                    agree: "#cart__agree-" + t,
                    checkout: ".cart__checkout-" + t + ' [name="checkout"], .cart__checkout-' + t + ' [name="goto_pp"], .cart__checkout-' + t + ' [name="goto_gc"]',
                    remove: ".item__remove-" + t,
                    update: ".cart__update-" + t,
                }),
                this._qtyCart(),
                this._checkoutCart(),
                this._removeCart(),
                this._updateCart(),
                this._productsSlider();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _removeCart: function () {
                    var e = this;
                    $(document).off("click", e.selectors.remove),
                        $(document).on("click", e.selectors.remove, function (t) {
                            t.preventDefault();
                            var i = $(this).attr("href"),
                                o = $(e.settings.namespace);
                            o.addClass("loading"),
                                $.post(i, function () {
                                    $.get("/cart?view=popup", function (t) {
                                        o.html($(t).find(e.settings.namespace).html()),
                                            setTimeout(function () {
                                                o.removeClass("loading"), theme.MiniCart.update();
                                                var e = new theme.Sections();
                                                e.register("cart-gift-popup", theme.CartGift), e.register("shipping-calculator-popup", theme.ShippingCalculator);
                                            }, 100);
                                    });
                                });
                        });
                },
                _updateCart: function () {
                    var e = this;
                    $(document).off("click", e.selectors.update),
                        $(document).on("click", e.selectors.update, function (t) {
                            t.preventDefault();
                            var i = $(this).closest("form"),
                                o = $(e.settings.namespace);
                            return (
                                $.ajax({
                                    type: "POST",
                                    url: "/cart/update.js",
                                    async: !0,
                                    cache: !1,
                                    data: i.serialize(),
                                    dataType: "json",
                                    beforeSend: function () {
                                        o.addClass("loading");
                                    },
                                    success: function (t) {
                                        $.get("/cart?view=popup", function (t) {
                                            o.html($(t).find(e.settings.namespace).html()),
                                                setTimeout(function () {
                                                    o.removeClass("loading"), theme.MiniCart.update();
                                                    var e = new theme.Sections();
                                                    e.register("cart-gift-popup", theme.CartGift), e.register("shipping-calculator-popup", theme.ShippingCalculator);
                                                }, 100);
                                        });
                                    },
                                }),
                                !1
                            );
                        });
                },
                _qtyCart: function () {
                    $(document).off("click", this.selectors.quantity + " .plus"),
                        $(document).on("click", this.selectors.quantity + " .plus", function () {
                            var e = $(this).parent().find(".qty"),
                                t = parseInt(e.val());
                            (t += 1), e.val(t);
                        }),
                        $(document).off("click", this.selectors.quantity + " .minus"),
                        $(document).on("click", this.selectors.quantity + " .minus", function () {
                            var e = $(this).parent().find(".qty"),
                                t = parseInt(e.val());
                            0 < t && ((t -= 1), e.val(t));
                        });
                },
                _checkoutCart: function () {
                    var e = this;
                    $(e.selectors.agree).length &&
                        ($(document).off("click", e.selectors.checkout),
                        $(document).on("click", e.selectors.checkout, function () {
                            if ($(e.selectors.agree).length) {
                                var t = $(this),
                                    i = $(e.selectors.agree);
                                if (!i.is(":checked")) {
                                    var o = i.data("message");
                                    return alert(o), !1;
                                }
                                t.submit();
                            }
                        }),
                        $(document).on("change", e.selectors.agree, function (t) {
                            $(this).is(":checked") ? $(e.selectors.checkout).removeClass("btn-disabled") : $(e.selectors.checkout).addClass("btn-disabled");
                        }));
                },
                _productsSlider: function () {
                    new theme.Sections().register("products-slider-sub", theme.ProductsSlider);
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
                onUnload: function () {
                    this.$container.off(this.settings.namespace);
                },
            })),
            e
        );
    })()),
    (theme.ShippingCalculator = (function () {
        function ShippingCalculator(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.selectors = {
                shipping_btn: "#cart__shipping-btn-" + t,
                shipping_calculator: "#shipping__calculator-" + t,
                get_rates: "#shipping__calculator-btn-" + t,
                response: "#shipping__calculator-response-" + t,
                template: '<p id ="shipping-rates-feedback-' + t + '" class="shipping-rates-feedback"></p>',
                address_country: "address_country-" + t,
                address_province: "address_province-" + t,
                address_zip: "address_zip-" + t,
                address_province_label: "address_province_label-" + t,
                address_province_container: "address_province_container-" + t,
            }),
                (this.strings = { submitButton: theme.strings.shippingButton, submitButtonDisabled: theme.strings.shippingButtonDisabled, customerIsLoggedIn: theme.settings.customerIsLoggedIn, moneyFormat: theme.settings.moneyFormat }),
                this._init();
        }
        return (
            (ShippingCalculator.prototype = _.assignIn({}, ShippingCalculator.prototype, {
                _disableButtons: function () {
                    var e = this.selectors,
                        t = this.strings;
                    $(e.get_rates).text(t.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled");
                },
                _enableButtons: function () {
                    var e = this.selectors,
                        t = this.strings;
                    $(e.get_rates).removeAttr("disabled").removeClass("disabled").text(t.submitButton);
                },
                _render: function (e) {
                    var t = this.selectors,
                        i = (this.strings, $(t.template)),
                        o = $(t.response);
                    if (o.length) {
                        if (e.success)
                            if ((i.addClass("success"), e.rates)) {
                                i.append(e.rates);
                                var s = e.rates;
                                if (s[0]) {
                                    var a = s[0];
                                    i.append('Rates start at <span class="money">' + a.price + "</span>.");
                                }
                            } else i.append("We do not ship to this destination.");
                        else i.addClass("error"), i.append(e.errorFeedback);
                        i.appendTo(o), theme.CurrencyPicker.convert(t.response + " .money");
                    }
                },
                _formatRate: function (e) {
                    this.selectors;
                    var t = this.strings;
                    if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(e, t.moneyFormat);
                    "string" == typeof e && (e = e.replace(".", ""));
                    var i = "",
                        o = /\{\{\s*(\w+)\s*\}\}/,
                        s = t.moneyFormat;
                    function a(e, t) {
                        return void 0 === e ? t : e;
                    }
                    function n(e, t, i, o) {
                        if (((t = a(t, 2)), (i = a(i, ",")), (o = a(o, ".")), isNaN(e) || null == e)) return 0;
                        var s = (e = (e / 100).toFixed(t)).split(".");
                        return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? o + s[1] : "");
                    }
                    switch (s.match(o)[1]) {
                        case "amount":
                            i = n(e, 2);
                            break;
                        case "amount_no_decimals":
                            i = n(e, 0);
                            break;
                        case "amount_with_comma_separator":
                            i = n(e, 2, ".", ",");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            i = n(e, 0, ".", ",");
                    }
                    return s.replace(o, i);
                },
                _onCartShippingRatesUpdate: function (e, t) {
                    var i = this.selectors;
                    this.strings, this._enableButtons();
                    var o = "";
                    if ((t.zip && (o += t.zip + ", "), t.province && (o += t.province + ", "), (o += t.country), e.length)) for (var s = 0; s < e.length; s++) e[s].price = this._formatRate(e[s].price);
                    this._render({ rates: e, address: o, success: !0 }), $(i.response).fadeIn();
                },
                _pollForCartShippingRatesForDestination: function (e) {
                    var t = this,
                        i =
                            (this.selectors,
                            this.strings,
                            function () {
                                $.ajax("/cart/async_shipping_rates", {
                                    dataType: "json",
                                    success: function (o, s, a) {
                                        200 === a.status ? t._onCartShippingRatesUpdate(o.shipping_rates, e) : setTimeout(i, 500);
                                    },
                                    error: function (e, i) {
                                        t._onError(e, i, t);
                                    },
                                });
                            });
                    return i;
                },
                _fullMessagesFromErrors: function (e) {
                    this.selectors, this.strings;
                    var t = [];
                    return (
                        $.each(e, function (e, i) {
                            $.each(i, function (i, o) {
                                t.push(e + " " + o);
                            });
                        }),
                        t
                    );
                },
                _onError: function (XMLHttpRequest, textStatus, self) {
                    var selectors = self.selectors,
                        strings = self.strings;
                    self._enableButtons();
                    var feedback = "",
                        data = eval("(" + XMLHttpRequest.responseText + ")");
                    (feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + self._fullMessagesFromErrors(data).join("; ") + "."),
                        "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."),
                        self._render({ rates: [], errorFeedback: feedback, success: !1 }),
                        $(selectors.response).show();
                },
                _getCartShippingRatesForDestination: function (e) {
                    var t = this;
                    this.selectors,
                        this.strings,
                        $.ajax({
                            type: "POST",
                            url: "/cart/prepare_shipping_rates",
                            data: $.param({ shipping_address: e }),
                            success: t._pollForCartShippingRatesForDestination(e),
                            error: function (e, i) {
                                t._onError(e, i, t);
                            },
                        });
                },
                _init: function () {
                    var e = this,
                        t = this.selectors,
                        i = this.strings;
                    if ($(t.shipping_calculator).length) {
                        new Shopify.CountryProvinceSelector(t.address_country, t.address_province, { hideElement: t.address_province_container });
                        var o = $("#" + t.address_country),
                            s = $("#" + t.address_province_label).get(0);
                        "undefined" != typeof Countries &&
                            (Countries.updateProvinceLabel(o.val(), s),
                            o.change(function () {
                                Countries.updateProvinceLabel(o.val(), s);
                            })),
                            $(t.get_rates).off("click"),
                            $(t.get_rates).click(function () {
                                e._disableButtons(), $(t.response).empty().hide();
                                var i = {};
                                (i.zip = $("#" + t.address_zip).val() || ""), (i.country = $("#" + t.address_country).val() || ""), (i.province = $("#" + t.address_province).val() || ""), e._getCartShippingRatesForDestination(i);
                            }),
                            i.customerIsLoggedIn && $(t.get_rates + ":eq(0)").trigger("click"),
                            $(t.shipping_btn).off("click"),
                            $(t.shipping_btn).click(function () {
                                $(t.shipping_calculator).slideToggle();
                            });
                    }
                },
            })),
            ShippingCalculator
        );
    })()),
    (theme.CartGift = (function () {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.selectors = { gift: "#gift__wrapping-" + t, namespace: "#CartSection-" + t, redirect: !0 }), this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                check: function () {
                    var e = this.selectors;
                    if ($(e.gift).length)
                        switch ($(e.gift).data("gift_case")) {
                            case 1:
                                this.remove();
                                break;
                            case 2:
                            case 3:
                            case 3:
                                this.set();
                        }
                },
                set: function () {
                    var e = this.selectors;
                    if ($(e.gift).length) {
                        var t = $(e.gift).data("product_id"),
                            i = new Object();
                        i[t] = 1;
                        var o = new Object();
                        o["gift-wrapping"] = !0;
                        var s = new Object();
                        (s.updates = i),
                            (s.attributes = o),
                            $.ajax({
                                type: "POST",
                                url: "/cart/update.js",
                                data: s,
                                dataType: "json",
                                beforeSend: function () {
                                    e.redirect || $(e.namespace).addClass("loading");
                                },
                                success: function () {
                                    if (e.redirect) location.href = "/cart";
                                    else {
                                        var t = $(e.namespace);
                                        $.get("/cart?view=popup", function (i) {
                                            t.html($(i).find(e.namespace).html()),
                                                setTimeout(function () {
                                                    t.removeClass("loading"), theme.MiniCart.update(), new theme.Sections().register("shipping-calculator-popup", theme.ShippingCalculator);
                                                }, 100);
                                        });
                                    }
                                },
                            });
                    }
                },
                remove: function () {
                    var e = this.selectors;
                    if ($(e.gift).length) {
                        var t = $(e.gift).data("product_id"),
                            i = new Object();
                        i[t] = 0;
                        var o = new Object();
                        o["gift-wrapping"] = "";
                        var s = new Object();
                        (s.updates = i),
                            (s.attributes = o),
                            $.ajax({
                                type: "POST",
                                url: "/cart/update.js",
                                data: s,
                                dataType: "json",
                                beforeSend: function () {
                                    e.redirect || $(e.namespace).addClass("loading");
                                },
                                success: function () {
                                    if (e.redirect) location.href = "/cart";
                                    else {
                                        var t = $(e.namespace);
                                        $.get("/cart?view=popup", function (i) {
                                            t.html($(i).find(e.namespace).html()),
                                                setTimeout(function () {
                                                    t.removeClass("loading"), theme.MiniCart.update(), new theme.Sections().register("shipping-calculator-popup", theme.ShippingCalculator);
                                                }, 100);
                                        });
                                    }
                                },
                            });
                    }
                },
                init: function () {
                    var e = this,
                        t = this.selectors;
                    $(t.gift).length &&
                        (0 == $(t.gift).data("redirect") && (this.selectors.redirect = !1),
                        e.check(),
                        $(document).off("change", t.gift),
                        $(document).on("change", t.gift, function () {
                            $(this).is(":checked") ? e.set() : e.remove();
                        }));
                },
            })),
            e
        );
    })()),
    (theme.Filters = (function () {
        var e = "constraint",
            t = "#PerPage",
            i = "#SortBy",
            o = ".shop__view",
            s = "#site-pagination a.btn",
            a = "#site-pagination .loadmore",
            n = ".advanced-filter .filter",
            r = ".site-widget.filtering .clear";
        function c(e) {
            var c = (this.$container = $(e));
            (this.$limitSelect = $(t, c)),
                (this.$sortSelect = $(i, c)),
                (this.$selects = $(t, c).add($(i, c))),
                (this.defaultLimit = this._getDefaultLimitValue()),
                (this.defaultSort = this._getDefaultSortValue()),
                this._resizeSelect(this.$selects),
                this.$selects.removeClass("hidden"),
                this.$limitSelect.on("change", this._onLimitChange.bind(this)),
                this.$sortSelect.on("change", this._onSortChange.bind(this)),
                $(document).on("change", n, this._onFilterChange.bind(this)),
                $(document).on("click", r, this._onFilterClear.bind(this)),
                $(document).on("click", s, this._onPageClick.bind(this)),
                $(document).on("click", a, this._onLoadMoreClick.bind(this)),
                $(document).on("click", o, this._onViewClick.bind(this)),
                this._onLoadMoreInfinite(a),
                this._initFiltersHtml(),
                this._initFiltersActive(),
                this._filterClearAll();
        }
        return (
            (c.prototype = _.assignIn({}, c.prototype, {
                _initFiltersHtml: function () {
                    $(".shop__filtering").length && $(".shop__filtering-inner").empty().append($(".site-sidebar").html());
                },
                _initFiltersActive: function () {
                    if ($(".filters__active").length) {
                        var e = $(".filters__active .clear_nav").empty();
                        $(".site-sidebar .site-widget.filtering").each(function () {
                            var t = $(this);
                            if (t.find(".filter-tag.active").length) {
                                var i = t.find(".filter-tag.active label").clone();
                                e.append(i);
                            } else t.find(".filter-tag select").length && "" != t.find(".filter-tag select").val() && ((i = '<label for="' + t.find(".filter-tag input").attr("id") + '">' + t.find(".filter-tag select").val() + "</label>"), e.append(i));
                        }),
                            e.find("label").length ? $(".filters__active").show() : $(".filters__active").hide();
                    }
                },
                _filterClearAll: function () {
                    var t = this;
                    $(".filters__active").length &&
                        $(".filters__active").on("click", ".clear_all", function () {
                            delete Shopify.queryParams[e], t._filterAjaxClick(!0);
                        });
                },
                _onFilterClear: function (t) {
                    var i = [];
                    Shopify.queryParams[e] && (i = Shopify.queryParams[e].split("+"));
                    var o = $(t.currentTarget).closest(".site-widget.filtering"),
                        s = o.find("select");
                    0 < s.length &&
                        s.find("option").each(function () {
                            var e = $(this).val();
                            if (e) {
                                var t = i.indexOf(e);
                                0 <= t && i.splice(t, 1);
                            }
                        });
                    var a = o.find("input");
                    0 < a.length &&
                        a.each(function () {
                            var e = $(this).val();
                            if (e) {
                                var t = i.indexOf(e);
                                0 <= t && i.splice(t, 1);
                            }
                        }),
                        i.length ? (Shopify.queryParams[e] = i.join("+")) : delete Shopify.queryParams[e],
                        this._filterAjaxClick(!0);
                },
                _onFilterChange: function (t) {
                    var i = $(t.currentTarget),
                        o = i.closest(".advanced-filter"),
                        s = i.closest(".filter-tag"),
                        a = o.data("multi_choice"),
                        n = [];
                    if ((Shopify.queryParams[e] && (n = Shopify.queryParams[e].split("+")), 0 == a && !s.hasClass("active"))) {
                        var r = o.find(".active input");
                        0 < r.length &&
                            r.each(function () {
                                var e = $(this).val();
                                if (e) {
                                    var t = n.indexOf(e);
                                    0 <= t && n.splice(t, 1);
                                }
                            });
                    }
                    var c = o.find("select");
                    0 < c.length &&
                        c.find("option").each(function () {
                            var e = $(this).val();
                            if (e) {
                                var t = n.indexOf(e);
                                0 <= t && n.splice(t, 1);
                            }
                        });
                    var l = i.val();
                    if (l) {
                        var d = n.indexOf(l);
                        0 <= d ? n.splice(d, 1) : n.push(l);
                    }
                    n.length ? (Shopify.queryParams[e] = n.join("+")) : delete Shopify.queryParams[e], this._filterAjaxClick(!0);
                },
                _onViewClick: function (e) {
                    e.preventDefault();
                    var t = $(e.currentTarget),
                        i = $(o),
                        s = t.data("view");
                    "grid" == s && (s = s + "-" + t.data("per_row")), (Shopify.queryParams.view = s), this._filterAjaxClick(), i.removeClass("active"), t.addClass("active");
                },
                _onLoadMoreInfinite: function (e) {
                    if ($(e).closest(".ajax_load_button").hasClass("ajax_load_hidden")) {
                        var t = "#site-primary .products",
                            i = Math.abs(0);
                        $(window).scroll(function () {
                            $(t).length &&
                                $("#site-pagination").find("a.next").length &&
                                $(t).offset().top + $(t).outerHeight() - $(window).scrollTop() - i < $(window).height() &&
                                0 == parseInt($(e).attr("data-processing")) &&
                                $(e).trigger("click");
                        });
                    }
                },
                _onLoadMoreClick: function (e) {
                    e.preventDefault();
                    var t = "#site-pagination .loadmore",
                        i = "#site-pagination .ajax_load_button",
                        o = "#site-primary .products .product",
                        s = "#site-pagination";
                    if (1 != parseInt($(t).attr("data-processing")))
                        if ($(s).find("a.next").length) {
                            $(t).attr("data-processing", 1);
                            var a = $(s).find("a.next").attr("href"),
                                n = $(t).data("no_more");
                            $(i).addClass("loading"),
                                $.get(a, function (e) {
                                    $(s).empty().html($(e).find(s).html()),
                                        $(e)
                                            .find(o)
                                            .each(function () {
                                                $(o).last().after($(this));
                                            }),
                                        $(i).removeClass("loading"),
                                        $(t).attr("data-processing", 0),
                                        0 == $(s).find("a.next").length && ($(i).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(t).show().html(n).addClass("disabled").prop("disabled", !0));
                                });
                        } else (n = $(t).attr("data-no-more")), $(i).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(t).show().html(n).addClass("disabled").prop("disabled", !0);
                },
                _onPageClick: function (e) {
                    e.preventDefault();
                    var t = $(e.currentTarget).attr("href");
                    this._filterGetContent(t);
                },
                _onSortChange: function (e) {
                    var t = this.$sortSelect.val() || this.defaultSort;
                    (Shopify.queryParams.sort_by = t), this._filterAjaxClick(), this._resizeSelect($(e.target));
                },
                _onLimitChange: function (e) {
                    var t = this.$limitSelect.val() || this.defaultLimit;
                    (Shopify.queryParams.limit = t), this._filterAjaxClick(), this._resizeSelect($(e.target));
                },
                _getDefaultLimitValue: function () {
                    return $("#DefaultPerPage", this.$container).val();
                },
                _getDefaultSortValue: function () {
                    return $("#DefaultSortBy", this.$container).val();
                },
                _resizeSelect: function (e) {
                    e.each(function () {
                        var e = $(this),
                            t = e.find("option:selected").text(),
                            i = $("<span>").html(t);
                        i.appendTo("body");
                        var o = i.width();
                        i.remove(), e.width(o + 3);
                    });
                },
                _filterAjaxClick: function (e) {
                    void 0 === e && (e = !1), delete Shopify.queryParams.page;
                    var t = this._filterCreateUrl();
                    this._filterGetContent(t, e);
                },
                _filterCreateUrl: function () {
                    var e = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                    return location.pathname + "?" + e;
                },
                _filterGetContent: function (e, t) {
                    void 0 === t && (t = !1);
                    var i = "#site-primary .products",
                        o = "#site-primary .product-found",
                        s = "#site-primary .products .product",
                        a = "#site-pagination",
                        n = "#site-secondary .site-sidebar",
                        r = this;
                    $("body").removeClass("sidebar-open"), $(".shop__filtering").slideUp();
                    var c = 40;
                    $("#shopify-section-header-sticky").length && $("#shopify-section-header-sticky").is(":visible")
                        ? (c += $("#shopify-section-header-sticky").outerHeight())
                        : $("#shopify-section-header-mobile").length && $("#shopify-section-header-mobile").is(":visible") && (c += $("#shopify-section-header-mobile").outerHeight()),
                        $("html, body").animate({ scrollTop: $("#site-primary").offset().top - c }, 1200),
                        $.ajax({
                            type: "GET",
                            url: e,
                            beforeSend: function () {
                                $("body").addClass("loading");
                            },
                            complete: function () {
                                $("body").removeClass("loading");
                            },
                            success: function (c) {
                                $.fn.countdown &&
                                    $(i)
                                        .find(".product__countdown .is-countdown")
                                        .each(function () {
                                            $(this).countdown("destroy");
                                        }),
                                    $(a).empty().html($(c).find(a).html()),
                                    t && ($(n).empty().html($(c).find(n).html()), $("#site-primary .shop__filtering-inner").empty().append($(n).html()), new theme.Sections().register("sidebar-sticky", theme.SidebarSticky)),
                                    $(i).empty().attr("class", $(c).find(i).attr("class")),
                                    0 < $(c).find(s).length
                                        ? $(c)
                                              .find(s)
                                              .each(function () {
                                                  $(i).append($(this));
                                              })
                                        : $(i).append($(c).find("#site-primary .no-products")),
                                    $(o).empty().html($(c).find(o).html()),
                                    r._initFiltersActive();
                                var l = $(c).filter("title").text();
                                History.pushState({ param: Shopify.queryParams }, l, e);
                            },
                        });
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
                onUnload: function () {
                    this.$limitSelect.off("change", this._onLimitChange),
                        this.$sortSelect.off("change", this._onSortChange),
                        $(document).off("click", o, this._onViewClick),
                        $(document).off("click", s, this._onPageClick),
                        $(document).off("click", a, this._onLoadMoreClick);
                },
            })),
            c
        );
    })()),
    (theme.SidebarSticky = (function () {
        function e(e) {
            (this.$container = $(e)).attr("data-section-id"), (this.settings = { selector: "#site-secondary .site-sidebar", primary: "#site-primary", toggle: "#site-secondary .site-widget__toggle" }), this.init(), this.update();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                init: function (e) {
                    var t = $(this.settings.selector);
                    if (!($(window).width() < 992)) {
                        var i = 40,
                            o = $(this.settings.primary);
                        $(".site-header").hasClass("header-sticky") && (i = 60);
                        var s = t.outerHeight() - o.outerHeight();
                        s < -100 ? t.stick_in_parent({ offset_top: i }) : 100 < s && o.stick_in_parent({ offset_top: i }),
                            $(window).resize(function () {
                                $(window).width() < 992 ? (t.trigger("sticky_kit:detach"), o.trigger("sticky_kit:detach")) : t.outerHeight() < o.outerHeight() ? t.stick_in_parent({ offset_top: i }) : o.stick_in_parent({ offset_top: i });
                            });
                    }
                },
                update: function () {
                    $(this.settings.toggle).on("change", function () {
                        $(document.body).trigger("sticky_kit:recalc");
                    });
                },
            })),
            e
        );
    })()),
    (theme.HeaderMobile = (function () {
        function e(e) {
            (this.$container = $(e)).attr("data-section-id"),
                (this.selectors = { headerFixed: ".header__mobile.is-fixed", navOpenIcon: ".mobile-nav__open", navCloseIcon: ".mobile-nav__close", navWrapper: ".mobile-header__nav .mobile__menu", megaMenu: "#phantom__menu" }),
                this._initHeaderFixed(),
                this._initMenu(),
                this._productsSlider(),
                theme.Search.init(),
                theme.MiniCart.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _animMenu: function () {
                    var e = new TimelineLite(),
                        t = $(".mobile__menu .listitem-0"),
                        i = $(".mobile__menu .listitem-0 > .listitem > .site-nav__link");
                    theme.settings.rtl
                        ? (e.fromTo(t, 0.1, { autoAlpha: 0 }, { autoAlpha: 1 }, 0), e.staggerFromTo(i, 2, { opacity: 0, y: 150, x: -30, rotation: -10 }, { opacity: 1, y: 0, x: 0, rotation: 0, ease: Power4.easeInOut }, 0.08, -0.8))
                        : (e.fromTo(t, 0.1, { autoAlpha: 0 }, { autoAlpha: 1 }, 0), e.staggerFromTo(i, 2, { opacity: 0, y: 150, x: 30, rotation: 10 }, { opacity: 1, y: 0, x: 0, rotation: 0, ease: Power4.easeInOut }, 0.08, -0.8));
                },
                _initHeaderFixed: function () {
                    if ($(this.selectors.headerFixed).length) {
                        var e = $(this.selectors.headerFixed),
                            t = e.parent();
                        function i() {
                            if (e.is(":visible")) {
                                var i = e.outerHeight();
                                e.addClass("finished"), t.css("height", i);
                            }
                        }
                        i(),
                            $(window).resize(function () {
                                i();
                            });
                        var o = 10;
                        function s() {
                            var i = $(window).scrollTop();
                            $(t).offset().top + o <= i ? $(e).removeClass("unstick").addClass("stick") : $(e).removeClass("stick").addClass("unstick");
                        }
                        $(t).offset().top,
                            s(),
                            $(window).scroll(function () {
                                s();
                            });
                    }
                },
                _initMenu: function () {
                    if (void 0 === $.fn.roarmenu) return !1;
                    var e = this,
                        t = e.selectors;
                    if ($(t.navWrapper).hasClass("has-megamenu") && $(t.megaMenu).length) {
                        var i = $($(t.megaMenu).val());
                        i.find(".product__form").remove(),
                            i.find(".site-nav__dropdown:not(.drilldown)").removeAttr("class").removeAttr("style"),
                            i.find(".drilldown").removeAttr("class").addClass("drilldown"),
                            i.find(".text-left").removeClass("text-left"),
                            i.find(".text-center").removeClass("text-center"),
                            i.find(".text-right").removeClass("text-right"),
                            $(t.navWrapper).find(".listitem-1").remove(),
                            $(t.navWrapper + " .listitem-0").prepend(i.find(".site-nav__items > .site-nav__item").removeAttr("class"));
                    }
                    $(t.navWrapper).length && $(t.navWrapper).roarmenu({ navbar: { add: !0, close: "mobile-nav__close", title: "Menu", titleLink: "anchor" } }),
                        $(document).off("click", t.navOpenIcon),
                        $(document).on("click", t.navOpenIcon, function (t) {
                            t.preventDefault(), $("body").addClass("menu-opened"), e._animMenu();
                        }),
                        $(document).off("click", t.navCloseIcon),
                        $(document).on("click", t.navCloseIcon, function (e) {
                            e.preventDefault(), $("body").removeClass("menu-opened");
                        });
                },
                _productsSlider: function () {
                    new theme.Sections().register("products-slider-sub", theme.ProductsSlider);
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
            })),
            e
        );
    })()),
    (theme.HeaderSection = (function () {
        function e(e) {
            (this.$container = $(e)).attr("data-section-id"), this._initElements(), this._initSticky();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _initElements: function () {
                    theme.Search.init(), theme.CurrencyPicker.init(), theme.LanguagePicker.init(), theme.MiniCart.init(), new theme.Sections().register("mega-menu", theme.MegaMenu);
                },
                _initSticky: function () {
                    var e = "#shopify-section-header-sticky",
                        t = "#shopify-section-header",
                        i = "#shopify-section-header-topbar";
                    if ($(e).length) {
                        var o,
                            s = $(t).offset().top + $(t).outerHeight() + $(i).outerHeight() + 200;
                        $(window).scroll(function () {
                            var t = $(this).scrollTop();
                            $(e).is(":visible") && (t < s ? $(e).hasClass("stick") && $(e).removeClass("stick").removeClass("sticky-hide").addClass("unstick") : $(e).hasClass("stick") || $(e).removeClass("unstick").addClass("stick"));
                        }),
                            (o = $(window).scrollTop()),
                            $(t).offset().top + $(t).outerHeight() + $(i).outerHeight() + 200 <= o && $(e).addClass("stick");
                    }
                },
            })),
            e
        );
    })()),
    (theme.MegaMenu = (function () {
        function e() {
            this._initMenu(), this._navigationInit(), this._productsSlider();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _initMenu: function () {
                    var e,
                        t = "#phantom__menu",
                        i = ".header__menu",
                        o = ".header__menu-left",
                        s = ".header__menu-right";
                    $(t).length &&
                        $(i).length &&
                        $(i).each(function () {
                            var e = $(t).val();
                            $(this).empty().append(e);
                        }),
                        $(t).length &&
                            $(o).length &&
                            ((e = $($(t).val())).find(".site-nav__items > .site-nav__item").each(function () {
                                $(this).hasClass("pull-right") && $(this).remove();
                            }),
                            $(o).each(function () {
                                var t = e.clone();
                                $(this).empty().append(t);
                            })),
                        $(t).length &&
                            $(s).length &&
                            ((e = $($(t).val())).find(".site-nav__items > .site-nav__item").each(function () {
                                $(this).hasClass("pull-right") || $(this).remove();
                            }),
                            $(s).each(function () {
                                var t = e.clone();
                                $(this).empty().append(t);
                            }));
                },
                _navigationInit: function () {
                    var e = [".site-navigation .site-nav__items > .site-nav--has-dropdown", ".my-account-has-drop", ".currency__picker .has-drop", ".language__picker .has-drop"].join(", ");
                    $(e)
                        .mouseenter(function (e) {
                            $(this).closest(".site-header-main, .header-sticky__placeholder").attr("data-sticky", "visible"), $(".site-overlay").addClass("visible");
                        })
                        .mouseleave(function (e) {
                            $(".site-overlay").removeClass("visible"), $(this).closest(".site-header-main, .header-sticky__placeholder").removeAttr("data-sticky", "visible");
                        });
                },
                _productsSlider: function () {
                    new theme.Sections().register("products-slider-sub", theme.ProductsSlider);
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
            })),
            e
        );
    })()),
    (theme.VerticalMenu = (function () {
        function e() {
            this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                init: function () {
                    var e = ".phantom__menu-vertical .site-nav__vertical",
                        t = ".header__menu-vertical";
                    $(e).length &&
                        $(t).length &&
                        $(t).each(function () {
                            var t = $(e).clone();
                            $(this).empty().append(t);
                        });
                },
            })),
            e
        );
    })()),
    (theme.Maps = (function () {
        var e = null,
            t = [],
            i = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
            o = "[data-map]",
            s = "map-section--load-error",
            a = "map-section__error errors text-center";
        function n(i) {
            (this.$container = $(i)),
                (this.$map = this.$container.find(o)),
                (this.key = this.$map.data("api-key")),
                void 0 !== this.key &&
                    ("loaded" === e
                        ? this.createMap()
                        : (t.push(this),
                          "loading" !== e &&
                              ((e = "loading"),
                              void 0 === window.google &&
                                  $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                                      (e = "loaded"),
                                          $.each(t, function (e, t) {
                                              t.createMap();
                                          });
                                  }))));
        }
        return (
            (window.gm_authFailure = function () {
                Shopify.designMode && ($('[data-section-type="map"]').addClass(s), $(o).remove(), $("[data-map-overlay]").after('<div class="' + a + '">' + theme.strings.authError + "</div>"));
            }),
            (n.prototype = _.assignIn({}, n.prototype, {
                createMap: function () {
                    var e = this.$map;
                    return (function (e) {
                        var t = $.Deferred(),
                            i = new google.maps.Geocoder(),
                            o = e.data("address-setting");
                        return (
                            i.geocode({ address: o }, function (e, i) {
                                i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
                            }),
                            t
                        );
                    })(e)
                        .then(
                            function (t) {
                                var i = [];
                                (i[0] = {}), (i[1] = {}), (i[2] = {});
                                var o = [];
                                (o[0] = {}), (o[1] = {}), (o[2] = {}), (o[3] = {}), (o[4] = {}), (o[5] = {}), (o[6] = {}), (o[7] = {}), (o[8] = {}), (o[9] = {}), (o[10] = {}), (o[11] = {}), (o[12] = {});
                                var s = [
                                        { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
                                        { featureType: "road.local", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                                        { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                                        { featureType: "road", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
                                        { featureType: "transit", elementType: "geometry.fill", stylers: [{ hue: "#dadeef" }, { visibility: "on" }, { lightness: 1 }, { saturation: 7 }] },
                                        { elementType: "labels", stylers: [{ saturation: -100 }] },
                                        { featureType: "poi", elementType: "geometry.fill", stylers: [{ hue: "#dadeef" }, { visibility: "on" }, { lightness: 20 }, { saturation: 7 }] },
                                        { featureType: "landscape", stylers: [{ hue: "#dadeef" }, { visibility: "on" }, { lightness: 20 }, { saturation: 20 }] },
                                        { featureType: "road", elementType: "geometry.fill", stylers: [{ hue: "#dadeef" }, { visibility: "on" }, { lightness: 1 }, { saturation: 7 }] },
                                        { featureType: "water", elementType: "geometry", stylers: [{ hue: "#dadeef" }, { visibility: "on" }, { lightness: 1 }, { saturation: 7 }] },
                                        o[0],
                                        o[1],
                                        o[2],
                                        o[3],
                                        o[4],
                                        o[5],
                                        o[6],
                                        o[7],
                                        o[8],
                                        o[9],
                                        o[10],
                                        o[11],
                                        o[12],
                                        i[0],
                                        i[1],
                                        i[2],
                                    ],
                                    a = new google.maps.StyledMapType(s, { name: "Styled Map" }),
                                    n = {
                                        center: t[0].geometry.location,
                                        zoom: 19,
                                        mapTypeControlOptions: { mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"] },
                                        scrollwheel: !1,
                                        panControl: !1,
                                        zoomControl: 1,
                                        disableDoubleClickZoom: 1,
                                        zoomControlOptions: { style: google.maps.ZoomControlStyle.LARGE, position: google.maps.ControlPosition.LEFT_CENTER },
                                        mapTypeControl: !1,
                                        scaleControl: !1,
                                        streetViewControl: !1,
                                        fullscreenControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
                                    },
                                    r = (this.map = new google.maps.Map(e[0], n));
                                r.mapTypes.set("map_style", a), r.setMapTypeId("map_style");
                                var c = (this.center = r.getCenter()),
                                    l = new google.maps.OverlayView();
                                (l.draw = function () {
                                    var e = this.div_;
                                    e ||
                                        (((e = this.div_ = $('<div><div class="animated-dot"><div class="pin"></div><div class="pulse"></div></div></div>')[0]).style.position = "absolute"),
                                        (e.style.paddingLeft = "0px"),
                                        (e.style.cursor = "pointer"),
                                        this.getPanes().overlayImage.appendChild(e));
                                }),
                                    l.setMap(r),
                                    google.maps.event.addDomListener(
                                        window,
                                        "resize",
                                        $.debounce(250, function () {
                                            google.maps.event.trigger(r, "resize"), r.setCenter(c), e.removeAttr("style");
                                        })
                                    );
                            }.bind(this)
                        )
                        .fail(function () {
                            var t;
                            switch (status) {
                                case "ZERO_RESULTS":
                                    t = i.addressNoResults;
                                    break;
                                case "OVER_QUERY_LIMIT":
                                    t = i.addressQueryLimit;
                                    break;
                                case "REQUEST_DENIED":
                                    t = i.authError;
                                    break;
                                default:
                                    t = i.addressError;
                            }
                            Shopify.designMode &&
                                e
                                    .parent()
                                    .addClass(s)
                                    .html('<div class="' + a + '">' + t + "</div>");
                        });
                },
                onUnload: function () {
                    0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize");
                },
            })),
            n
        );
    })()),
    (theme.Product = (function () {
        function e(e) {
            var t = (this.$container = $(e)),
                i = t.attr("data-section-id");
            (this.settings = {
                mediaQueryLargeUp: "screen and (min-width: 992px)",
                mediaQueryMedium: "screen and (max-width: 991px)",
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                enableHistoryState: t.data("enable-history-state") || !1,
                namespace: ".ProductSection-" + i,
                sectionId: i,
                sectionType: t.data("section-type"),
                zoomEnabled: !1,
                sliderThumbsActive: !1,
                sliderImagesActive: !1,
                swatchColor: t.data("product_swatch_color"),
                swatchColorAdvanced: t.data("product_swatch_color_advanced"),
                swatchSize: t.data("product_swatch_size"),
            }),
                (this.selectors = {
                    container: t,
                    inComing: ".InComing-" + i,
                    addToCart: ".AddToCart-" + i,
                    addToCartText: ".AddToCartText-" + i,
                    comparePrice: ".ComparePrice-" + i,
                    originalPrice: ".ProductPrice-" + i,
                    SKU: ".product-single__sku",
                    originalSelectorId: ".ProductSelect-" + i,
                    productImage: ".ProductImage-" + i,
                    productImages: ".product-single__photos-" + i,
                    productImageWraps: ".product-single__photo-" + i,
                    productVideo: ".product-single__video-" + i,
                    productVideoWrap: ".product-single__video-wrapper",
                    productPrices: ".product-single__price-" + i,
                    productThumbImages: ".product-single__thumbnail--" + i,
                    productThumbs: ".product-single__thumbnails-" + i,
                    productNav: ".product-single__nav-" + i,
                    singleOptionSelector: ".single-option-selector-" + i,
                    singleOptionSelectorId: ".single-option-selector-" + i,
                    singleOptionSwatches: "tawcvs-swatches-" + i,
                    sizeChart: ".sizechart_btn",
                    productContent: ".product-single__content",
                    productQuantity: ".product-form__item--quantity",
                    productTabs: ".product-single__tabs",
                    productReviews: ".product-single__review",
                    productGalleryTrigger: ".product-single__photo.photoswipe-enabled",
                    productVideoTrigger: ".product-single__show-video",
                    recentlyViewed: ".recently-viewed-" + i,
                    cartAgree: "#product-cart__agree-" + i,
                    cartCheckout: "#product-buy__1click-" + i,
                    stockCountdown: "#product-single__stock-" + i,
                    visitorCounter: "#product-single__visitor-" + i,
                    totalSold: "#product-single__sold-" + i,
                }),
                $(".ProductJson-" + i, t).html() &&
                    ((this.productSingleObject = JSON.parse($(".ProductJson-" + i, t).html())),
                    (this.productSwatchSingleObject = JSON.parse($(".ProductSwatchJson-" + i, t).html())),
                    (this.productMoreSingleObject = JSON.parse($(".ProductMoreJson-" + i, t).html())),
                    (this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass("zoom-enabled")),
                    this._updateProductObject(),
                    this._initBreakpoints(),
                    this._initVariants(),
                    this._initSwatches(),
                    this._initImageSwitch(),
                    this._initReviews(),
                    this._initQuantity(),
                    this._productInView(),
                    "product-template" == this.settings.sectionType &&
                        (this._initGalleryZoom(),
                        this._initVideoZoom(),
                        this._initTabs(),
                        this._stickyDetails(),
                        this._recordRecentlyViewed(),
                        this._sizeChart(),
                        this._checkoutCart(),
                        this._initStockCountdown(),
                        this._visitorCounter(),
                        this._totalSold(),
                        this._productNav(),
                        this._productsSlider()));
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _initBreakpoints: function () {
                    var e = this;
                    enquire.register(e.settings.mediaQueryMedium, {
                        match: function () {
                            e.settings.sliderThumbsActive && e._destroyThumbnailSlider(), e._initThumbnailSlider();
                        },
                    }),
                        enquire.register(e.settings.mediaQueryLargeUp, {
                            match: function () {
                                e.settings.sliderThumbsActive && e._destroyThumbnailSlider(), e._initThumbnailSlider(!1);
                            },
                        }),
                        enquire.register(e.settings.mediaQuerySmall, {
                            match: function () {
                                e.settings.sliderImagesActive && e._destroyImageSlider(),
                                    e._initImageSlider(),
                                    e.settings.zoomEnabled &&
                                        $(e.selectors.productImageWraps).each(function () {
                                            $(this).trigger("zoom.destroy");
                                        });
                            },
                        }),
                        enquire.register(e.settings.mediaQueryMediumUp, {
                            match: function () {
                                e.settings.sliderImagesActive && e._destroyImageSlider(),
                                    e._initImageSlider(!1),
                                    e.settings.zoomEnabled &&
                                        $(e.selectors.productImageWraps).each(function () {
                                            var e;
                                            (e = $(this).data("zoom")),
                                                $(this).zoom({
                                                    duration: 500,
                                                    url: e,
                                                    onZoomIn: function () {
                                                        $(this).addClass("active");
                                                    },
                                                    onZoomOut: function () {
                                                        $(this).removeClass("active");
                                                    },
                                                });
                                        });
                            },
                        });
                },
                _productNav: function () {
                    if ($(this.selectors.productNav).length) {
                        function e() {
                            var e = i.offset().top / 3,
                                s = o.offset().top - 400,
                                a = $(window).scrollTop();
                            e < a ? t.addClass("visible") : t.removeClass("visible"), s < a && t.removeClass("visible");
                        }
                        var t = $(this.selectors.productNav),
                            i = t,
                            o = $(".product-template__end");
                        e(), $(window).scroll(e), $(window).resize(e);
                    }
                },
                _productInView: function () {
                    if ("undefined" == typeof ScrollReveal) return !1;
                    (window.sr = ScrollReveal()),
                        sr.reveal(".product-single__inview:not(.no-anim)", {
                            mobile: !1,
                            beforeReveal: function (e) {
                                (e.visuelRevealTL = new TimelineLite()),
                                    $(e).addClass("anim"),
                                    e.visuelRevealTL.fromTo(e, 2, { y: 40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0).call(function (t) {
                                        $(e).removeClass("anim").addClass("no-anim");
                                    });
                            },
                        });
                },
                _updateProductObject: function () {
                    var e = this;
                    $.each(e.productMoreSingleObject.variants, function (t, i) {
                        $.each(i, function (i, o) {
                            e.productSingleObject.variants[t][i] = o;
                        });
                    });
                },
                _totalSold: function () {
                    if ($(this.selectors.totalSold).length) {
                        var e = $(this.selectors.totalSold),
                            t = e.data("qty_min"),
                            i = e.data("qty_max"),
                            o = e.data("time_min"),
                            s = e.data("time_max");
                        (t = Math.ceil(t)), (i = Math.floor(i)), (o = Math.ceil(o)), (s = Math.floor(s));
                        var a = Math.floor(Math.random() * (i - t + 1)) + t;
                        (a = parseInt(a)) <= t && (a = t), i < a && (a = i), e.html(e.html().replace("/count/", a));
                        var n = Math.floor(Math.random() * (s - o + 1)) + o;
                        (n = parseInt(n)) <= o && (n = o),
                            s < n && (n = s),
                            e.html(e.html().replace("/time/", n)),
                            e.show(),
                            e.find("img").first().length &&
                                setInterval(function () {
                                    e.find("img")
                                        .first()
                                        .fadeIn(function () {
                                            $(this).css("visibility", "visible");
                                        })
                                        .delay(1600)
                                        .fadeIn(function () {
                                            $(this).css("visibility", "hidden");
                                        })
                                        .delay(400);
                                }, 2e3);
                    }
                },
                _visitorCounter: function () {
                    if ($(this.selectors.visitorCounter).length) {
                        var e = $(this.selectors.visitorCounter),
                            t = e.data("max"),
                            i = e.data("interval"),
                            o = 1,
                            s = t;
                        (o = Math.ceil(o)), (s = Math.floor(s));
                        var a = Math.floor(Math.random() * (s - o + 1)) + o,
                            n = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
                            r = "",
                            c = "",
                            l = ["10", "20", "15"],
                            d = ((r = ""), (c = ""), "");
                        setInterval(function () {
                            (r = Math.floor(Math.random() * n.length)),
                                (c = n[r]),
                                (a = parseInt(a) + parseInt(c)) <= 1 && ((d = Math.floor(Math.random() * l.length)), (a += l[d])),
                                (a < 1 || t < a) && (a = Math.floor(Math.random() * (s - o + 1)) + o),
                                e.find("strong").first().text(parseInt(a)),
                                e.show();
                        }, 1e3 * i);
                    }
                },
                _initStockCountdown: function () {
                    if ($(this.selectors.stockCountdown).length) {
                        var e = $(this.selectors.stockCountdown);
                        if (e.hasClass("is-fake")) {
                            var t = 60,
                                i = e.data("min"),
                                o = e.data("max"),
                                s = r(i, o),
                                a = null,
                                n = null;
                            function r(e, t) {
                                return Math.floor(Math.random() * (t - e + 1) + e);
                            }
                            function c() {
                                var i = (100 * s) / t;
                                e.find(".progress-bar span").css("width", i + "%");
                            }
                            e.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", s)),
                                (a = setTimeout(function () {
                                    --s < 1 && (s = r(i, o)), e.find(".stock-countdown-message strong").text(s), c(), s < i && clearTimeout(a);
                                }, 3e3)),
                                (n = setInterval(function () {
                                    --s < 1 && (s = r(i, o)), e.find(".stock-countdown-message strong").text(s), c(), s < i && clearInterval(n);
                                }, 102e3)),
                                e.hasClass("is-visible") && e.removeClass("hide");
                        }
                    }
                },
                _updateStockCountdown: function (e) {
                    var t = $(this.selectors.stockCountdown);
                    t.hasClass("is-fake")
                        ? t.removeClass("hide")
                        : (t.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", e)),
                          t.find(".progress-bar span").first().css("width", "100%"),
                          t.removeClass("hide"),
                          setTimeout(function () {
                              t.find(".progress-bar span").first().css("width", "28%");
                          }, 500));
                },
                _checkoutCart: function () {
                    var e = this;
                    $(e.selectors.cartAgree).length &&
                        ($(document).on("DOMNodeInserted", e.selectors.cartCheckout, function () {
                            var t = $(this);
                            setTimeout(function () {
                                var i = t.find(".shopify-payment-button__button");
                                i.length &&
                                    (t.hide(),
                                    setTimeout(function () {
                                        $(e.selectors.cartAgree).is(":checked") ? i.removeClass("btn-disabled") : i.addClass("btn-disabled"), t.fadeIn();
                                    }, 300));
                            }, 0);
                        }),
                        $(document).on("change", e.selectors.cartAgree, function (t) {
                            var i = $(this),
                                o = $(e.selectors.cartCheckout).find(".shopify-payment-button__button");
                            i.is(":checked") ? o.removeClass("btn-disabled") : o.addClass("btn-disabled");
                        }));
                },
                _pauseVideo: function () {
                    var e = $(this.selectors.productVideoWrap).find("video")[0];
                    e && e.played && (e.pause(), e.load()), $(this.selectors.productVideo).removeClass("played");
                },
                _playVideo: function (e) {
                    var t = this,
                        i = $(t.selectors.productVideoWrap).find("video")[0];
                    if (i) {
                        i.play();
                        var o = 1;
                        i.addEventListener(
                            "ended",
                            function () {
                                o < 2 ? (i.play(), o++) : $(t.selectors.productThumbImages + "[data-thumbnail_id='" + e + "']")[0].click();
                            },
                            !1
                        );
                    }
                    $(t.selectors.productVideo).addClass("played");
                },
                _initImageSlider: function (e) {
                    void 0 === e && (e = !0);
                    var t = this,
                        i = {
                            rtl: theme.settings.rtl,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            fade: !0,
                            dots: !0,
                            infinite: !0,
                            centerMode: !0,
                            arrows: !0,
                            prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev2"></use></svg></button>',
                            nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next2"></use></svg></button>',
                            asNavFor: t.selectors.productThumbs,
                        };
                    if (
                        (0 == e
                            ? 1 == $(t.selectors.productImages).data("center_mode") && ((i.centerMode = !0), (i.centerPadding = "25%"), (i.fade = !1), (i.arrows = !0))
                            : ((i.slidesToShow = 1), (i.fade = !1), (i.dots = !0), (i.arrows = !1)),
                        $(t.selectors.productImages).closest(".product-single__photos").find(".carousel-status").length)
                    ) {
                        var o = $(t.selectors.productImages).closest(".product-single__photos").find(".carousel-status");
                        $(t.selectors.productImages).on("beforeChange", function (e, t, i, s) {
                            o.html("<span>" + (s + 1) + "</span>/<span>" + t.$slides.length + "</span>");
                        });
                    }
                    $(t.selectors.productImages).on("init", function (e, t) {
                        var i = new TimelineLite(),
                            o = t.$slider,
                            s = o.parent();
                        i.fromTo(o, 1, { opacity: 0 }, { ease: Power4.easeInOut, opacity: 1 }, 0), i.fromTo(s, 2, { scale: 1.1, opacity: 0 }, { ease: Power4.easeInOut, scale: 1, opacity: 1 }, 0.3);
                    }),
                        (t.settings.sliderImagesActive = !0),
                        $(t.selectors.productImages).slick(i);
                },
                _initThumbnailSlider: function (e) {
                    void 0 === e && (e = !0);
                    var t = this,
                        i = !1;
                    0 == e && 1 == $(t.selectors.productThumbs).data("vertical") && (i = !0);
                    var o = {
                        rtl: !1,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        vertical: !1,
                        infinite: !1,
                        centerMode: !1,
                        verticalSwiping: i,
                        asNavFor: t.selectors.productImages,
                        focusOnSelect: !0,
                        arrows: !0,
                        prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev2"></use></svg></button>',
                        nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next2"></use></svg></button>',
                    };
                    $(t.selectors.productThumbs).on("init", function (e, t) {
                        var i = new TimelineLite(),
                            o = t.$slider;
                        i.fromTo(
                            o.find(".slick-list"),
                            1.4,
                            { y: 20, opacity: 0 },
                            {
                                ease: Power4.easeInOut,
                                y: 0,
                                opacity: 1,
                                onStart: function () {
                                    setTimeout(function () {
                                        o.addClass("shadow");
                                    }, 600);
                                },
                            },
                            1
                        );
                    }),
                        (t.settings.sliderThumbsActive = !0),
                        $(t.selectors.productThumbs).slick(o);
                },
                _destroyImageSlider: function () {
                    $(this.selectors.productImages).slick("unslick"), (this.settings.sliderImagesActive = !1);
                },
                _destroyThumbnailSlider: function () {
                    $(this.selectors.productThumbs).slick("unslick"), (this.settings.sliderThumbsActive = !1);
                },
                _initImageSwitch: function () {
                    if ($(this.selectors.productThumbImages).length) {
                        $.fn.visible = function (e) {
                            var t = $(this),
                                i = $(window),
                                o = i.scrollTop(),
                                s = o + i.height(),
                                a = t.offset().top,
                                n = a + t.height();
                            return (!0 === e ? a : n) <= s && o <= (!0 === e ? n : a);
                        };
                        var e = this;
                        $(document).off("click", e.selectors.productThumbImages),
                            $(document).on("click", e.selectors.productThumbImages, function (e) {
                                e.preventDefault();
                            }),
                            $(e.selectors.productThumbs).on("beforeChange", function (t, i, o, s) {
                                var a = $(e.selectors.productThumbs).find(".slick-slide").eq([s]);
                                if (a.find(".product-single__thumbnail").length) {
                                    var n = a.find(".product-single__thumbnail").data("thumbnail_id");
                                    $(e.selectors.productVideo).data("thumbnail_prev", n), $(e.selectors.productVideoWrap).hide(), $(e.selectors.productImages).show(), e._pauseVideo();
                                }
                            }),
                            $(e.selectors.productVideo).on("click", function () {
                                var t = $(this),
                                    i = t.data("thumbnail_prev");
                                t.hasClass("played")
                                    ? $(e.selectors.productThumbImages + "[data-thumbnail_id='" + i + "']")[0].click()
                                    : ($(e.selectors.productThumbs).find(".slick-slide").removeClass("slick-current"), $(e.selectors.productImages).hide(), $(e.selectors.productVideoWrap).show(), e._playVideo(i));
                            });
                    }
                },
                _switchImage: function (e) {
                    "product-quickview" != this.settings.sectionType
                        ? $(this.selectors.productThumbImages).length && $(this.selectors.productThumbImages + "[data-thumbnail_id='" + e.id + "']")[0].click()
                        : $(this.selectors.productImage, this.selectors.container).attr("data-bgset", theme.roarJs.bgSet(e)).removeClass("lazyloaded").addClass("lazyload");
                },
                _initVideoZoom: function () {
                    var e = this,
                        t = $(".pswp")[0];
                    $(document).off("click", e.selectors.productVideoTrigger),
                        $(document).on("click", e.selectors.productVideoTrigger, function (i) {
                            i.preventDefault(), $(this).parent();
                            var o = new PhotoSwipe(
                                t,
                                PhotoSwipeUI_Default,
                                (function () {
                                    var t = [];
                                    return t.push({ html: $(e.selectors.productVideoWrap + " .product-single__video").html() }), t;
                                })(),
                                { index: 0, closeOnScroll: !1, bgOpacity: 0.1, tapToClose: !0, tapToToggleControls: !1 }
                            );
                            o.init(),
                                $("body").addClass("blurred"),
                                $(".pswp__item").fadeTo(1e3, 1),
                                o.listen("close", function () {
                                    $(".pswp__item .pswp__video").each(function () {
                                        $(this).attr("src", $(this).attr("src"));
                                    }),
                                        $(".pswp__item").fadeOut("slow", 0),
                                        $("body").removeClass("blurred");
                                });
                        });
                },
                _initGalleryZoom: function () {
                    var e = this,
                        t = $(".pswp")[0];
                    $(document).off("click", e.selectors.productGalleryTrigger),
                        $(document).on("click", e.selectors.productGalleryTrigger, function (i) {
                            i.preventDefault(), $(this).parent();
                            var o = { index: $(this).data("index"), closeOnScroll: !1, bgOpacity: 0.1, tapToClose: !0, tapToToggleControls: !1 },
                                s = new PhotoSwipe(
                                    t,
                                    PhotoSwipeUI_Default,
                                    (function () {
                                        var t = [];
                                        return (
                                            $(e.selectors.productImages + " .product-single__photo-container:not(.slick-cloned) .feature-row__image").each(function () {
                                                var e = $(this).data("large_image"),
                                                    i = $(this).data("large_image_width"),
                                                    o = $(this).data("large_image_height");
                                                t.push({ src: e, w: i, h: o, title: !1 });
                                            }),
                                            t
                                        );
                                    })(),
                                    o
                                );
                            s.init(),
                                s.listen("imageLoadComplete", function (e, t) {
                                    $(".pswp__item").fadeTo(1e3, 1), $("body").addClass("blurred");
                                }),
                                s.listen("close", function (e, t) {
                                    $(".pswp__item").fadeOut("slow", 0), $("body").removeClass("blurred");
                                });
                        });
                },
                _initQuantity: function () {
                    var e = this;
                    function t(t) {
                        var i = 0;
                        $(t)
                            .closest("form")
                            .find(e.selectors.productQuantity + " .quantity")
                            .each(function () {
                                i += $(this).val();
                            }),
                            0 < i ? $(e.selectors.addToCart).prop("disabled", !1) : $(e.selectors.addToCart).prop("disabled", !0);
                    }
                    $(document).off("click", e.selectors.productQuantity + " .plus"),
                        $(document).on("click", e.selectors.productQuantity + " .plus", function () {
                            var i = $(this).closest(e.selectors.productQuantity).find(".quantity"),
                                o = parseInt(i.val());
                            (o += 1), i.val(o), t(this);
                        }),
                        $(document).off("click", e.selectors.productQuantity + " .minus"),
                        $(document).on("click", e.selectors.productQuantity + " .minus", function () {
                            var i = $(this).closest(e.selectors.productQuantity).find(".quantity"),
                                o = parseInt(i.val());
                            0 < o && ((o -= 1), i.val(o), t(this));
                        });
                },
                _stickyDetails: function () {
                    var e = $(this.selectors.productContent);
                    !e.data("sticky") ||
                        $(window).width() < 992 ||
                        e.each(function () {
                            var e = $(this).parent(),
                                t = $(this),
                                i = e.closest(".product-single").find(".product-single__photos"),
                                o = t.outerHeight() - i.outerHeight();
                            o < -100 ? t.stick_in_parent({ offset_top: 20 }) : 100 < o && i.stick_in_parent({ offset_top: 20 }),
                                $(window).resize(function () {
                                    $(window).width() < 992
                                        ? (t.trigger("sticky_kit:detach"), i.trigger("sticky_kit:detach"))
                                        : t.outerHeight() < i.outerHeight()
                                        ? t.stick_in_parent({ offset_top: 20 })
                                        : i.stick_in_parent({ offset_top: 20 });
                                });
                        });
                },
                _initTabs: function () {
                    var e = $(this.selectors.productTabs),
                        t = ".product-tabs__title";
                    (e.hasClass("tabs-layout-tabs") || e.hasClass("tabs-layout-accordion")) &&
                        ($(document).off("click", t),
                        $(document).on("click", t, function (i) {
                            i.preventDefault();
                            var o = $(this),
                                s = o.attr("href"),
                                a = $(t, e),
                                n = $(".product-tabs__panel", e);
                            $(".product-tabs", e).is(":visible")
                                ? (a.removeClass("active"), n.removeClass("active"), o.addClass("active"), $(s).addClass("active"))
                                : (o.hasClass("active") ? (o.removeClass("active"), $(s).removeClass("active")) : (a.removeClass("active"), n.removeClass("active"), o.addClass("active"), $(s).addClass("active")),
                                  n.each(function () {
                                      $(this).hasClass("active") ? $(this).slideDown(250) : $(this).slideUp(250);
                                  }));
                        }));
                },
                _initReviews: function () {
                    if (!$(this.selectors.productTabs).length) return !1;
                    var e = this.selectors.productTabs;
                    $(document).off("click", this.selectors.productReviews),
                        $(document).on("click", this.selectors.productReviews, function () {
                            if ($(e).hasClass("tabs-layout-tabs") || $(e).hasClass("tabs-layout-accordion")) {
                                var t = $(e + " #tab-reviews").prev();
                                $(".product-tabs", e).is(":visible") && (t = $(e + " .reviews_tab .product-tabs__title")), t.hasClass("active") || t.trigger("click");
                            }
                            var i = $(e + " #tab-reviews").parent();
                            $(".product-tabs", e).is(":visible") && (i = $(e)),
                                setTimeout(function () {
                                    $("html, body").animate({ scrollTop: i.offset().top }, 500, "swing");
                                }, 250);
                        });
                },
                _initSwatches: function () {
                    var e,
                        t = this,
                        o = this.productSingleObject,
                        s = this.productSwatchSingleObject,
                        a = new Array();
                    if (("1" == this.settings.swatchSize && a.push("Size"), a.push("size"), "1" == this.settings.swatchColor && (a.push("Color"), a.push("Colour"), a.push("color"), a.push("colour")), 0 < a.length)) {
                        var n = !1,
                            r = 0,
                            c = theme.settings.assetUrl.substring(0, theme.settings.assetUrl.lastIndexOf("?")),
                            l = theme.settings.assetUrl.substring(theme.settings.assetUrl.lastIndexOf("?"), theme.settings.assetUrl.length);
                        for (i = 0; i < o.options.length; i++) {
                            var d = "",
                                u = "",
                                h = "",
                                p = "",
                                m = "",
                                f = "",
                                g = " img";
                            if (((d = "object" == typeof o.options[i] ? o.options[i].name : o.options[i]), (n = !1), -1 < a.indexOf(d))) {
                                (n = !0), (r = i);
                                var v = d.toLowerCase();
                                if ((/color|colour/i.test(v), n)) {
                                    var _ = new Array();
                                    for (j = 0; j < o.variants.length; j++) {
                                        var y = o.variants[j],
                                            w = ((e = y.options[r]), String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")),
                                            b = w
                                                .toLowerCase()
                                                .replace(/[^a-z0-9 -]/g, "")
                                                .replace(/\s+/g, "-")
                                                .replace(/-+/g, "-");
                                        t.settings.sectionId,
                                            _.indexOf(w) < 0 &&
                                                ("color" != v && "colour" != v
                                                    ? ((f = "<i>" + w + "</i>"), (g = ""))
                                                    : (f =
                                                          "1" == this.settings.swatchColorAdvanced
                                                              ? null !== s[b] && void 0 !== s[b] && "" != s[b]
                                                                  ? ((g = " img swatch_color_advanced"), '<i style="background-image:url(' + c + s[b] + ".png" + l + ');"></i>')
                                                                  : null !== y.featured_image
                                                                  ? ((g = " img swatch_color_advanced"), '<i style="background-image:url(' + theme.Images.getSizedImageUrl(y.featured_image.src,"1024x1024@2x") + ');"></i>')
                                                                  : '<i style="background-color:' + w + ";background-image:url(" + c + b + ".png" + l + ');"></i>'
                                                              : '<i style="background-color:' + w + ";background-image:url(" + c + b + ".png" + l + ');"></i>'),
                                                (h =
                                                    h +
                                                    '<div class="swatch-element ' +
                                                    v +
                                                    b +
                                                    ' available"><label class="swatch-label' +
                                                    g +
                                                    ($(t.selectors.singleOptionSelectorId + "-" + r).val() == w ? " selected" : "") +
                                                    '" title="' +
                                                    w +
                                                    '"><input class="swatch-radio swatch-' +
                                                    t.settings.sectionId +
                                                    "-" +
                                                    r +
                                                    "-" +
                                                    b +
                                                    '" type="radio" value="' +
                                                    w +
                                                    '" data-value="' +
                                                    w +
                                                    '" data-poption="' +
                                                    r +
                                                    '" name="option-' +
                                                    r +
                                                    '">' +
                                                    f +
                                                    '<span class="soldout-image"></span></label></div>'),
                                                _.push(w));
                                    }
                                    (u = '<div class="' + t.selectors.singleOptionSwatches + " wrapper-swatches swatch " + v + '" data-attribute_name="attribute_pa_' + v + '">' + h + "</div>"),
                                        (p = $(t.selectors.singleOptionSelectorId + "-" + r)),
                                        (m = $(t.selectors.variationSelector + "-" + r)),
                                        "" != u && (p.after(u), p.hide(), m.addClass("hide-choose-option"));
                                }
                            }
                        }
                    }
                    var C = "",
                        k = "." + t.selectors.singleOptionSwatches + " .swatch-radio";
                    0 < $("." + t.selectors.singleOptionSwatches, t.selectors.container).length &&
                        ((C = $(k)).unbind("click"),
                        C.on("click", function () {
                            var e = $(this).closest(".selector-wrapper").find(".single-option-selector").first(),
                                s = $(this).data("poption"),
                                a = $(this).data("value");
                            a != e.val() &&
                                (e.val(a).trigger("change"),
                                e.closest(".selector-wrapper").find(".swatch-label").removeClass("selected"),
                                e.closest(".selector-wrapper").find(".option-select-value").html(a),
                                $(this).closest(".swatch-label").addClass("selected")),
                                (function (e, o, s) {
                                    if (1 < e.options.length)
                                        for (i = 0; i < e.options.length; i++)
                                            i != o &&
                                                $(t.selectors.singleOptionSelectorId + "-" + i + " option", t.selectors.container).each(function () {
                                                    var a = "unavailable",
                                                        n = $(this).attr("value");
                                                    for (j = 0; j < e.variants.length; j++) {
                                                        var r = e.variants[j];
                                                        if (r.options[o] == s && r.options[i] == n) {
                                                            a = 1 == r.available ? "available" : "sold_out";
                                                            break;
                                                        }
                                                    }
                                                    var c =
                                                        ".swatch-" +
                                                        t.settings.sectionId +
                                                        "-" +
                                                        i +
                                                        "-" +
                                                        n
                                                            .toLowerCase()
                                                            .replace(/[^a-z0-9 -]/g, "")
                                                            .replace(/\s+/g, "-")
                                                            .replace(/-+/g, "-");
                                                    $(c, t.selectors.container).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(a);
                                                });
                                    else
                                        for (i = 0; i < e.options.length; i++)
                                            $(t.selectors.singleOptionSelectorId + "-" + i + " option", t.selectors.container).each(function () {
                                                var o = "unavailable",
                                                    s = $(this).attr("value");
                                                for (j = 0; j < e.variants.length; j++)
                                                    if (e.variants[j].options[i] == s) {
                                                        o = e.variants[j].available ? "available" : "sold_out";
                                                        break;
                                                    }
                                                var a =
                                                    ".swatch-" +
                                                    t.settings.sectionId +
                                                    "-" +
                                                    i +
                                                    "-" +
                                                    s
                                                        .toLowerCase()
                                                        .replace(/[^a-z0-9 -]/g, "")
                                                        .replace(/\s+/g, "-")
                                                        .replace(/-+/g, "-");
                                                $(a, t.selectors.container).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(o);
                                            });
                                })(o, s, a);
                        })),
                        $(k, t.selectors.container).closest(".selector-wrapper").find(".swatch-label.selected .swatch-radio").trigger("click");
                },
                _initVariants: function () {
                    var e = {
                        $container: this.$container,
                        enableHistoryState: this.$container.data("enable-history-state") || !1,
                        singleOptionSelector: this.selectors.singleOptionSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                        product: this.productSingleObject,
                    };
                    (this.variants = new slate.Variants(e)),
                        this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)),
                        this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)),
                        this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)),
                        this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
                },
                _updateAddToCart: function (e) {
                    e.variant;
                    var t = $(e.target).attr("new");
                    if (($(this.selectors.originalSelectorId).addClass("externalSelect"), null == t || "Color" == t)) {
                        var i = $("[new=Color]").children("option:selected").val(),
                            o = $("[new=Fit]").children("option:selected").val();
                        $("[new=Size]").children("option").removeClass("availableSize"), setSizeSelectOnColor(i, o), $(".sizeBoxNew.focus").trigger("click");
                    } else if ("Fit" == t) globalSelect((s = $("[new=Size]").children("option:selected").val()), (i = $("[new=Color]").children("option:selected").val()), (o = $("[new=Fit]").children("option:selected").val()));
                    else {
                        var s = $("[new=Size]").children("option:selected").val();
                        (i = $("[new=Color]").children("option:selected").val()),
                            $("[new=Fit] option").each(function () {
                                var e = $(this).val();
                                $(this).text(e);
                            }),
                            $("[new=Fit]").children("option").removeClass("availableFit"),
                            setFitSelectOnSize(s, i),
                            $(".availableFit").siblings("option").append(" (Not-Available)"),
                            $(".availableFit").siblings("option").attr("disabled", "disabled"),
                            $("[new=Fit]")
                                .children(".availableFit")
                                .each(function () {
                                    var e = $(this).val();
                                    $(this).text(e), $(this).removeAttr("disabled", "disabled");
                                }),
                            $("[new=Fit]").children("option").removeAttr("selected", "selected"),
                            $("[new=Fit]").children(".availableFit:eq(0)").prop("selected", !0),
                            globalSelect(s, i, (o = $("[new=Fit]").children("option:selected").val()));
                    }
                    setTimeout(function () {
                        var e = $(".externalSelect").find("option:selected").val();
                        if (($(location).attr("search"), $(location).attr("href"), history.pushState))
                            if ("null" == e || null == e) {
                                $(".externalSelect").children("option:first").prop("selected", !0), $(".externalSelect").val($(".externalSelect").children("option:selected").val()), (e = $(".externalSelect").find("option:selected").val());
                                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e;
                                window.history.pushState({ path: t }, "", t);
                            } else (t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e), window.history.pushState({ path: t }, "", t);
                    }, 50);
                },
                _updateImages: function (e) {
                    var t = e.variant;
                    this._switchImage(t.featured_image);
                },
                _updatePrice: function (e) {
                    var t = e.variant;
                    $(this.selectors.originalPrice, this.selectors.container).html('<span class="money">' + theme.Currency.formatMoney(t.price, theme.settings.moneyFormat) + "</span>"),
                        t.compare_at_price > t.price
                            ? $(this.selectors.comparePrice, this.selectors.container)
                                  .html('<span class="money">' + theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat) + "</span>")
                                  .removeClass("hide")
                            : $(this.selectors.comparePrice, this.selectors.container).addClass("hide"),
                        theme.CurrencyPicker.convert(this.selectors.productPrices + " .money");
                },
                _updateSKU: function (e) {
                    var t = e.variant;
                    $(this.selectors.SKU).html(t.sku);
                },
                _recordRecentlyViewed: function () {
                    var e = "roarStorage_recentlyViewed",
                        t = localStorage.getItem(e) || "[]";
                    try {
                        t = JSON.parse(t);
                    } catch (i) {
                        localStorage.removeItem(e), (t = JSON.parse("[]"));
                    }
                    var i = this.productSingleObject.id;
                    t.includes(i) || t.unshift(i);
                    try {
                        localStorage.setItem(e, JSON.stringify(t.slice(0, 180)));
                    } catch (i) {}
                },
                _sizeChart: function () {
                    var e = $("body"),
                        t = $(".sizechart-modal");
                    $(document).off("click", this.selectors.sizeChart),
                        $(document).on("click", this.selectors.sizeChart, function (i) {
                            i.preventDefault(), t.addClass("opened"), e.addClass("sizechart-opened");
                        }),
                        $(document).off("click", ".sizechart_overlay, .sizechart_close"),
                        $(document).on("click", ".sizechart_overlay, .sizechart_close", function (i) {
                            i.preventDefault(), t.removeClass("opened"), e.removeClass("sizechart-opened");
                        }),
                        $(document).keyup(function (i) {
                            "27" == i.which && (t.removeClass("opened"), e.removeClass("sizechart-opened"));
                        }),
                        $("body").append(t);
                },
                _productsSlider: function () {
                    new theme.Sections().register("products-slider-sub", theme.ProductsSlider);
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
                onUnload: function () {
                    this.$container.off(this.settings.namespace);
                },
            })),
            e
        );
    })()),
    (theme.LineItem = (function () {
        function e(e) {
            var t = (this.$container = $(e)),
                i = t.attr("data-section-id");
            (this.settings = { enableHistoryState: !1, namespace: ".ProductSection-" + i, sectionId: i, swatchColor: !0, swatchColorAdvanced: !0, swatchSize: !0 }),
                (this.selectors = {
                    container: t,
                    productImage: ".ProductImage-" + i,
                    addToCart: ".AddToCart-" + i,
                    addToCartText: ".AddToCartText-" + i,
                    comparePrice: ".ComparePrice-" + i,
                    originalPrice: ".ProductPrice-" + i,
                    productPrices: ".product-single__price-" + i,
                    originalSelectorId: ".ProductSelect-" + i,
                    singleOptionSelector: ".single-option-selector-" + i,
                    singleOptionSelectorId: ".single-option-selector-" + i,
                    singleOptionSwatches: "tawcvs-swatches-" + i,
                }),
                $(".ProductJson-" + i, t).html() &&
                    (t.data("section-state") ||
                        ((this.productSingleObject = JSON.parse($(".ProductJson-" + i, t).html())),
                        (this.productSwatchSingleObject = JSON.parse($(".ProductSwatchJson-" + i, t).html())),
                        (this.productMoreSingleObject = JSON.parse($(".ProductMoreJson-" + i, t).html())),
                        this._updateProductObject(),
                        this._initVariants(),
                        this._initSwatches(),
                        t.data("section-state", !0)));
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _updateProductObject: function () {
                    var e = this;
                    $.each(e.productMoreSingleObject.variants, function (t, i) {
                        $.each(i, function (i, o) {
                            e.productSingleObject.variants[t][i] = o;
                        });
                    });
                },
                _initSwatches: function () {
                    var e,
                        t = this,
                        o = this.productSingleObject,
                        s = this.productSwatchSingleObject,
                        a = new Array();
                    if (("1" == this.settings.swatchSize && a.push("Size"), a.push("size"), "1" == this.settings.swatchColor && (a.push("Color"), a.push("Colour"), a.push("color"), a.push("colour")), 0 < a.length)) {
                        var n = !1,
                            r = 0,
                            c = theme.settings.assetUrl.substring(0, theme.settings.assetUrl.lastIndexOf("?")),
                            l = theme.settings.assetUrl.substring(theme.settings.assetUrl.lastIndexOf("?"), theme.settings.assetUrl.length);
                        for (i = 0; i < o.options.length; i++) {
                            var d = "",
                                u = "",
                                h = "",
                                p = "",
                                m = "",
                                f = "",
                                g = " img";
                            if (((d = "object" == typeof o.options[i] ? o.options[i].name : o.options[i]), (n = !1), -1 < a.indexOf(d))) {
                                (n = !0), (r = i);
                                var v = d.toLowerCase();
                                if ((/color|colour/i.test(v), n)) {
                                    var _ = new Array();
                                    for (j = 0; j < o.variants.length; j++) {
                                        var y = o.variants[j],
                                            w = ((e = y.options[r]), String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")),
                                            b = w
                                                .toLowerCase()
                                                .replace(/[^a-z0-9 -]/g, "")
                                                .replace(/\s+/g, "-")
                                                .replace(/-+/g, "-");
                                        t.settings.sectionId,
                                            _.indexOf(w) < 0 &&
                                                ("color" != v && "colour" != v
                                                    ? ((f = "<i>" + w + "</i>"), (g = ""))
                                                    : (f =
                                                          "1" == this.settings.swatchColorAdvanced
                                                              ? null !== s[b] && void 0 !== s[b] && "" != s[b]
                                                                  ? ((g = " img swatch_color_advanced"), '<i style="background-image:url(' + c + s[b] + ".png" + l + ');"></i>')
                                                                  : null !== y.featured_image
                                                                  ? ((g = " img swatch_color_advanced"), '<i style="background-image:url(' + theme.Images.getSizedImageUrl(y.featured_image.src, "1024x1024@2x") + ');"></i>')
                                                                  : '<i style="background-color:' + w + ";background-image:url(" + c + b + ".png" + l + ');"></i>'
                                                              : '<i style="background-color:' + w + ";background-image:url(" + c + b + ".png" + l + ');"></i>'),
                                                (h =
                                                    h +
                                                    '<div class="swatch-element ' +
                                                    v +
                                                    b +
                                                    ' available"><label class="swatch-label' +
                                                    g +
                                                    ($(t.selectors.singleOptionSelectorId + "-" + r).val() == w ? " selected" : "") +
                                                    '" title="' +
                                                    w +
                                                    '"><input class="swatch-radio swatch-' +
                                                    t.settings.sectionId +
                                                    "-" +
                                                    r +
                                                    "-" +
                                                    b +
                                                    '" type="radio" value="' +
                                                    w +
                                                    '" data-value="' +
                                                    w +
                                                    '" data-poption="' +
                                                    r +
                                                    '" name="option-' +
                                                    r +
                                                    '">' +
                                                    f +
                                                    '<span class="soldout-image"></span></label></div>'),
                                                _.push(w));
                                    }
                                    (u = '<div class="' + t.selectors.singleOptionSwatches + " wrapper-swatches swatch " + v + '" data-attribute_name="attribute_pa_' + v + '">' + h + "</div>"),
                                        (p = $(t.selectors.singleOptionSelectorId + "-" + r, t.selectors.container)),
                                        (m = $(t.selectors.variationSelector + "-" + r, t.selectors.container)),
                                        "" != u && (p.after(u), p.hide(), m.addClass("hide-choose-option"));
                                }
                            }
                        }
                    }
                    var C = "",
                        k = "." + t.selectors.singleOptionSwatches + " .swatch-radio";
                    0 < $("." + t.selectors.singleOptionSwatches, t.selectors.container).length &&
                        ((C = $(k)).unbind("click"),
                        C.on("click", function () {
                            var e = $(this).closest(".selector-wrapper").find(".single-option-selector").first(),
                                s = $(this).data("poption"),
                                a = $(this).data("value");
                            a != e.val() &&
                                (e.val(a).trigger("change"),
                                e.closest(".selector-wrapper").find(".swatch-label").removeClass("selected"),
                                e.closest(".selector-wrapper").find(".option-select-value").html(a),
                                $(this).closest(".swatch-label").addClass("selected")),
                                (function (e, o, s) {
                                    if (1 < e.options.length)
                                        for (i = 0; i < e.options.length; i++)
                                            i != o &&
                                                $(t.selectors.singleOptionSelectorId + "-" + i + " option", t.selectors.container).each(function () {
                                                    var a = "unavailable",
                                                        n = $(this).attr("value");
                                                    for (j = 0; j < e.variants.length; j++) {
                                                        var r = e.variants[j];
                                                        if (r.options[o] == s && r.options[i] == n) {
                                                            a = 1 == r.available ? "available" : "sold_out";
                                                            break;
                                                        }
                                                    }
                                                    var c =
                                                        ".swatch-" +
                                                        t.settings.sectionId +
                                                        "-" +
                                                        i +
                                                        "-" +
                                                        n
                                                            .toLowerCase()
                                                            .replace(/[^a-z0-9 -]/g, "")
                                                            .replace(/\s+/g, "-")
                                                            .replace(/-+/g, "-");
                                                    $(c, t.selectors.container).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(a);
                                                });
                                    else
                                        for (i = 0; i < e.options.length; i++)
                                            $(t.selectors.singleOptionSelectorId + "-" + i + " option", t.selectors.container).each(function () {
                                                var o = "unavailable",
                                                    s = $(this).attr("value");
                                                for (j = 0; j < e.variants.length; j++)
                                                    if (e.variants[j].options[i] == s) {
                                                        o = e.variants[j].available ? "available" : "sold_out";
                                                        break;
                                                    }
                                                var a =
                                                    ".swatch-" +
                                                    t.settings.sectionId +
                                                    "-" +
                                                    i +
                                                    "-" +
                                                    s
                                                        .toLowerCase()
                                                        .replace(/[^a-z0-9 -]/g, "")
                                                        .replace(/\s+/g, "-")
                                                        .replace(/-+/g, "-");
                                                $(a, t.selectors.container).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(o);
                                            });
                                })(o, s, a);
                        })),
                        $(k, t.selectors.container).closest(".selector-wrapper").find(".swatch-label.selected .swatch-radio").trigger("click");
                },
                _initVariants: function () {
                    var e = { $container: this.$container, enableHistoryState: !1, singleOptionSelector: this.selectors.singleOptionSelector, originalSelectorId: this.selectors.originalSelectorId, product: this.productSingleObject };
                    (this.variants = new slate.Variants(e)),
                        this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)),
                        this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)),
                        this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this));
                },
                _updateAddToCart: function (e) {
                    var t = e.variant;
                    t
                        ? ($(this.selectors.productPrices).removeClass("visibility-hidden"),
                          t.available
                              ? ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !1),
                                t.inventory_quantity <= 0 && "shopify" == t.inventory_management
                                    ? $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.preOrder)
                                    : $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.addToCart))
                              : ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !0), $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.soldOut)))
                        : ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !0),
                          $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.unavailable),
                          $(this.selectors.productPrices).addClass("visibility-hidden"));
                },
                _updateImages: function (e) {
                    var t = e.variant;
                    this._switchImage(t.featured_image);
                },
                _updatePrice: function (e) {
                    var t = e.variant;
                    $(this.selectors.originalPrice, this.selectors.container).html('<span class="money">' + theme.Currency.formatMoney(t.price, theme.settings.moneyFormat) + "</span>"),
                        t.compare_at_price > t.price
                            ? $(this.selectors.comparePrice, this.selectors.container)
                                  .html('<span class="money">' + theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat) + "</span>")
                                  .removeClass("hide")
                            : $(this.selectors.comparePrice, this.selectors.container).addClass("hide"),
                        theme.CurrencyPicker.convert(this.selectors.productPrices + " .money");
                },
                _switchImage: function (e) {
                    $(this.selectors.productImage).attr("data-bgset", theme.roarJs.bgSet(e)).removeClass("lazyloaded").addClass("lazyload");
                },
                onUnload: function () {
                    this.$container.off(this.settings.namespace);
                },
            })),
            e
        );
    })()),
    (theme.Instagram = (function () {
        function e(e) {
            var t = (this.$container = $(e)),
                i = t.attr("data-section-id");
            (this.settings = {
                template:
                    '<div class="item"><a href="{{href}}" target="_blank"><span class="meta d-flex align-items-center justify-content-center"><span class="likes">{{likes}}</span><span class="comments">{{comments}}</span></span><img class="lazyload" src="{{src}}" data-srcset="{{srcset}}" /></a></div>',
                accessToken: t.data("access_token"),
                count: t.data("count"),
                selector: "#instagram-" + i,
            }),
                "" != this.settings.accessToken && 0 != this.settings.count && this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                init: function (e) {
                    var t = this,
                        o = t._buildUrl();
                    $.get(o, function (e) {
                        if ("object" == typeof e && 200 == e.meta.code && 0 < e.data.length) {
                            var o = e.data,
                                s = "";
                            for (i = 0, len = o.length; i < len; i++) {
                                var a = o[i],
                                    n = a.images.thumbnail.url,
                                    r = a.images.thumbnail.url + " 150w, " + a.images.low_resolution.url + " 320w, " + a.images.standard_resolution.url + " 480w";
                                s += t._makeTemplate(t.settings.template, { href: a.link, src: n, srcset: r, likes: a.likes.count, comments: a.comments.count });
                            }
                            $(t.settings.selector).append(s);
                        }
                    });
                },
                _buildUrl: function () {
                    var e;
                    return (e = "https://api.instagram.com/v1/users/self/media/recent"), (e += "?access_token=" + this.settings.accessToken) + "&count=" + this.settings.count;
                },
                _makeTemplate: function (e, t) {
                    var i, o, s, a, n;
                    for (o = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, i = e; o.test(i); )
                        (a = i.match(o)[1]),
                            (n = null != (s = this._getObjectProperty(t, a)) ? s : ""),
                            (i = i.replace(o, function () {
                                return "" + n;
                            }));
                    return i;
                },
                _getObjectProperty: function (e, t) {
                    var i, o;
                    for (o = (t = t.replace(/\[(\w+)\]/g, ".$1")).split("."); o.length; ) {
                        if (((i = o.shift()), !(null != e && i in e))) return null;
                        e = e[i];
                    }
                    return e;
                },
            })),
            e
        );
    })()),
    (theme.CountdownTimer = (function () {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.settings = { selector: ".countdown-" + t + ":not(.is-countdown)" }), this.regional(), this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                regional: function () {
                    if (void 0 === $.fn.countdown) return !1;
                    ($.countdown.regionalOptions.roar = {
                        labels: ["Years", "Months", "Weeks", theme.strings.days, theme.strings.hours, theme.strings.minutes, theme.strings.seconds],
                        labels1: ["Year", "Month", "Week", theme.strings.day, theme.strings.hour, theme.strings.minute, theme.strings.second],
                        compactLabels: ["y", "m", "w", "d"],
                        whichLabels: null,
                        digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                        timeSeparator: ":",
                        isRTL: theme.settings.rtl,
                    }),
                        $.countdown.setDefaults($.countdown.regionalOptions.roar);
                },
                init: function (e) {
                    if (void 0 === $.fn.countdown) return !1;
                    $(this.settings.selector).each(function () {
                        var e = $(this);
                        if ("" != e.data("end_date")) {
                            var t = e.data("end_date").split("-"),
                                i = new Date(t[2], parseInt(t[0]) - 1, t[1]);
                            new Date(),
                                e.countdown({
                                    until: i,
                                    alwaysExpire: !0,
                                    onExpiry: function () {
                                        e.hide();
                                    },
                                });
                        }
                    });
                },
            })),
            e
        );
    })()),
    (theme.NewsletterPopup = (function () {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.settings = { selector: "#newsletter-popup-" + t }), this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                init: function (e) {
                    try {
                        var t = $(this.settings.selector),
                            i = t.data("period"),
                            o = t.data("delay"),
                            s = t.data("version");
                        if (0 < i && document.cookie.match(/^(.*;)?\s*roarStorage_newsletter\s*=\s*[^;]+(.*)?$/)) return;
                        function a() {
                            $(document.body).removeClass("newsletter-opened").removeClass("newsletter2-opened"), $(document.body).trigger("roarNewsletter_closed", [t]);
                        }
                        $(window).on("load", function () {
                            setTimeout(function () {
                                "popup2" == s ? $(document.body).addClass("newsletter2-opened") : $(document.body).addClass("newsletter-opened");
                            }, 1e3 * o);
                        }),
                            $(document.body).on("roarNewsletter_closed", function (e, t) {
                                var o = new Date(),
                                    s = o.getTime();
                                o.setTime(o.getTime() + 24 * i * 60 * 60 * 1e3), (document.cookie = "roarStorage_newsletter=" + s + ";expires=" + o.toGMTString() + ";path=/");
                            }),
                            $(document.body).on("click", ".newsletter-popup-section .close_icon, .newsletter-popup2-section .close_icon, .newsletter-popup-backdrop", function (e) {
                                e.preventDefault(), a();
                            }),
                            $(document).on("keyup", function (e) {
                                27 === e.keyCode && a();
                            });
                    } catch (e) {
                        return;
                    }
                },
            })),
            e
        );
    })()),
    (theme.LookbookSection = (function () {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.settings = { init: !1 }), (this.selectors = { lookbookId: "#lookbook__id-" + t + " .roarlookbook", lookbookContent: "#lookbook__content-" + t }), this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                init: function (e) {
                    var t = this;
                    $(document).on("DOMNodeInserted", t.selectors.lookbookId, function () {
                        if (0 == t.settings.init) {
                            t.settings.init = !0;
                            var e = $(this);
                            setTimeout(function () {
                                e.closest(".slideshow__slide").addClass("slide-active"), e.find(".media__blank-preview").append($(t.selectors.lookbookContent));
                            }, 0);
                        }
                    });
                },
                onLoad: function () {
                    roarLookbook.buildLookbook();
                },
            })),
            e
        );
    })()),
    (theme.ProductsSlider = (function () {
        function ProductsSlider(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            (this.settings = { cache: {}, grid_num: 4, grid_row: 1, max_pages: 1, next_page: 1, cat_id: !1, storage_id: !1, storage_data: [], atts: {} }),
                (this.selectors = { slider: ".slick-slider-" + t + ":not(.slick-initialized)" }),
                this._initSlider();
        }
        return (
            (ProductsSlider.prototype = _.assignIn({}, ProductsSlider.prototype, {
                _isEditor: function () {
                    return window !== window.parent && 0 <= window.top.location.pathname.indexOf("/admin") && 0 <= window.top.location.pathname.indexOf("/editor");
                },
                _initSlider: function (evt) {
                    var self = this,
                        that = $(self.selectors.slider);
                    if (
                        ((self.settings.atts = eval("({" + that.data("atts") + "})")),
                        (self.settings.max_pages = that.data("max_pages")),
                        (self.settings.cat_id = that.data("cat_id")),
                        (self.settings.storage_id = that.data("storage_id")),
                        (self.settings.storage_data = []),
                        void 0 !== self.settings.cat_id || void 0 !== self.settings.storage_id)
                    ) {
                        var parent = that.closest(".products-slider");
                        if (((self.settings.grid_num = that.data("grid_num")), (self.settings.grid_row = that.data("grid_row")), void 0 !== self.settings.storage_id && self.settings.storage_id.length)) {
                            var storageName = "roarStorage_" + self.settings.storage_id,
                                items = localStorage.getItem(storageName) || "[]";
                            try {
                                items = JSON.parse(items);
                            } catch (e) {
                                localStorage.removeItem(storageName), (items = JSON.parse("[]"));
                            }
                            var productId = 0;
                            (productId = void 0 !== window.ShopifyAnalytics ? window.ShopifyAnalytics.meta.product.id : weketingShop.productJson.id),
                                items.includes(productId) && items.splice(items.indexOf(productId), 1),
                                (self.settings.storage_data = items);
                            var howManyToShow = Math.min(self.settings.storage_data.length, 180);
                            howManyToShow && (howManyToShow <= self.settings.grid_num * self.settings.grid_row && $(".slick-arrows", parent).remove(), self._buildSlider());
                        }
                        self.settings.max_pages < 2 ||
                            ($(".slick-prev", parent)
                                .off("click")
                                .on("click", function (e) {
                                    e.preventDefault(), self._isEditor() || ((self.settings.next_page = self.settings.next_page - 1), self.settings.next_page <= 0 && (self.settings.next_page = self.settings.max_pages), self._buildSlider());
                                }),
                            $(".slick-next", parent)
                                .off("click")
                                .on("click", function (e) {
                                    e.preventDefault(), self._isEditor() || ((self.settings.next_page = self.settings.next_page + 1), self.settings.next_page > self.settings.max_pages && (self.settings.next_page = 1), self._buildSlider());
                                }),
                            $(window).scroll(function () {
                                var e = $(".slick-arrows", parent),
                                    t = $(".slick-prev", parent),
                                    i = $(".slick-next", parent),
                                    o = $(window).height() / 2,
                                    s = ($(window).outerWidth(!0), parent.outerWidth(!0)),
                                    a = $(window).scrollTop(),
                                    n = parent.offset().top - o,
                                    r = parent.offset().left - 50,
                                    c = s + parent.offset().left + 50 - i.outerWidth(),
                                    l = t.outerHeight(),
                                    d = n + (parent.height() - l);
                                $(window).width() <= 1024 && ((r += 35), (c -= 35)), t.css({ left: r + "px" }), i.css({ left: c + "px" }), a < n || d < a ? e.removeClass("show-arrow") : e.addClass("show-arrow");
                            }));
                    }
                },
                _buildSlider: function () {
                    var e = this,
                        t = !1,
                        i = 1e3;
                    e.settings.cache[e.settings.next_page] || ((t = void 0 !== e.settings.cat_id ? e._ajaxCollection() : e._ajaxStorage()), (i = 0));
                    var o = $(e.selectors.slider).closest(".products-slider");
                    o.addClass("loading"),
                        $.when(t).done(function () {
                            setTimeout(function () {
                                e._buildProducts(), e._lineItem();
                            }, i),
                                setTimeout(function () {
                                    o.removeClass("loading");
                                }, i + 250);
                        });
                },
                _ajaxCollection: function () {
                    var e = this,
                        t = $(e.selectors.slider).closest(".products-slider");
                    if (!t.hasClass("loading") && !t.hasClass("finished"))
                        return (
                            (e = this),
                            $.ajax({
                                url: "/collections/" + e.settings.cat_id,
                                type: "GET",
                                dataType: "html",
                                data: {
                                    view: "custom",
                                    limit: e.settings.grid_num + "*" + e.settings.grid_row,
                                    page: e.settings.next_page,
                                    type:
                                        e.settings.atts.image_ratio +
                                        "*" +
                                        1 * e.settings.atts.image_ratio_crop +
                                        "*" +
                                        1 * e.settings.atts.image_second +
                                        "*" +
                                        e.settings.atts.image_overlay +
                                        "*" +
                                        e.settings.atts.product_hover +
                                        "*" +
                                        1 * e.settings.atts.vendor +
                                        "*" +
                                        1 * e.settings.atts.review +
                                        "*" +
                                        1 * e.settings.atts.quickview +
                                        "*" +
                                        1 * e.settings.atts.wishlist +
                                        "*" +
                                        1 * e.settings.atts.compare,
                                    cache: !1,
                                },
                                success: function (i) {
                                    $(i).find(".product").length ? ((e.settings.cache[e.settings.next_page] = i), 0 == $(i).data("is_next") && t.addClass("finished"), e._buildProducts()) : t.addClass("finished");
                                },
                            })
                        );
                },
                _ajaxStorage: function () {
                    var e = this,
                        t = $(e.selectors.slider).closest(".products-slider");
                    if (!t.hasClass("loading") && !t.hasClass("finished")) {
                        var i = (e = this).settings.grid_num * e.settings.grid_row,
                            o = (e.settings.next_page - 1) * i,
                            s = e.settings.storage_data
                                .splice(o, i)
                                .map(function (e) {
                                    return "id:" + e;
                                })
                                .join(" OR ");
                        return $.ajax({
                            url: "/search",
                            data: { view: "viewed", type: "product", q: s },
                            dataType: "html",
                            type: "GET",
                            success: function (i) {
                                $(i).find(".product").length
                                    ? ((e.settings.cache[e.settings.next_page] = i), t.closest(".products-slider_hide").removeClass("hide"), 0 == e.settings.storage_data.length && t.addClass("finished"), e._buildProducts())
                                    : t.addClass("finished");
                            },
                        });
                    }
                },
                _buildProducts: function () {
                    var e = $(this.selectors.slider).closest(".products-slider"),
                        t = $(this.settings.cache[this.settings.next_page]),
                        i = e.find(".products");
                    $.fn.countdown &&
                        i.find(".product__countdown .is-countdown").each(function () {
                            $(this).countdown("destroy");
                        }),
                        i.empty(),
                        0 < t.find(".product").length &&
                            (t.find(".product__image").removeClass("lazyloaded").removeClass("lazyloading").addClass("lazyload"),
                            t.find(".product").each(function () {
                                i.append($(this));
                            }));
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews(), theme.roarJs.splitText(), theme.roarJs.animationProduct();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
            })),
            ProductsSlider
        );
    })()),
    (theme.ProductTabs = (function () {
        function e(e) {
            (this.$container = $(e)).attr("data-section-id"), (this.selectors = { container: ".tabs__container", title: ".tabs__title", panel: ".tabs__panel" }), this._initTabs(), this._productsSlider();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _initTabs: function (e) {
                    var t = this;
                    $(document).off("click", t.selectors.title),
                        $(document).on("click", t.selectors.title, function (e) {
                            e.preventDefault();
                            var i = $(this),
                                o = i.closest(t.selectors.container),
                                s = $(i.attr("href")),
                                a = s.find(".slick-slider"),
                                n = o.find(t.selectors.title),
                                r = o.find(t.selectors.panel);
                            n.removeClass("active"), r.removeClass("active"), i.addClass("active"), s.addClass("active"), a.hasClass("slick-initialized") && a.slick("setPosition");
                        });
                },
                _productsSlider: function () {
                    new theme.Sections().register("products-slider-sub", theme.ProductsSlider);
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
            })),
            e
        );
    })()),
    (theme.RichBanner = (function () {
        function e(e) {
            var t = (this.$container = $(e)),
                i = (this.sectionId = t.attr("data-section-id"));
            (this.selectors = {
                bannerId: "#shopify-section-" + i,
                bannerNamspace: "#rich-banners-" + i,
                bannerAnime: "#rich-banners-" + i + " .has--anime-fx",
                bannerTilter: "#rich-banners-" + i + " .has--tilt-effect",
                bannerSlider: "#rich-banners-" + i + " .rich-banner--group.is-slick_slider",
            }),
                (this.settings = { mediaQueryMediumUp: "screen and (min-width: 768px)", mediaQuerySmall: "screen and (max-width: 767px)", sliderActive: !1 }),
                this._initBreakpoints(),
                this._initAnime(),
                this._initTilter();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _initBreakpoints: function () {
                    var e = this;
                    enquire.register(this.settings.mediaQuerySmall, {
                        match: function () {
                            e.settings.sliderActive && e._destroySlider(), e._initSlider();
                        },
                    }),
                        enquire.register(this.settings.mediaQueryMediumUp, {
                            match: function () {
                                e.settings.sliderActive && e._destroySlider(), e._initSlider(!1);
                            },
                        });
                },
                _destroySlider: function () {
                    var e = this;
                    $(e.selectors.bannerSlider).each(function () {
                        $(this).find(".rich-banner--slider.slick-initialized").slick("unslick"), (e.settings.sliderActive = !1);
                    });
                },
                _initSlider: function (e) {
                    var t = this;
                    $(t.selectors.bannerSlider).each(function () {
                        var i = $(this);
                        void 0 === e && (e = !0);
                        var o = i.find(".rich-banner--slider:not(.slick-initialized)"),
                            s = {
                                rtl: theme.settings.rtl,
                                dots: !1,
                                arrows: !0,
                                slidesToScroll: 1,
                                slidesToShow: i.data("per_slide"),
                                autoplay: i.data("autoplay"),
                                autoplaySpeed: i.data("interval"),
                                variableWidth: i.data("variable_width"),
                                centerMode: i.data("variable_width"),
                                appendArrows: $(".slick-arrows", o.parent()),
                                prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
                                nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
                            };
                        1 == e && (s.slidesToShow = i.data("per_slide_mb")), o.slick(s), (t.settings.sliderActive = !0);
                    });
                },
                _initTilter: function () {
                    $(this.selectors.bannerTilter).each(function () {
                        var e = $(this);
                        e.on("mousemove", function (e) {
                            var t = $(this).offset().left,
                                i = $(this).offset().top,
                                o = e.pageX - t,
                                s = e.pageY - i,
                                a = $(this).width() / 2 - o,
                                n = $(this).height() / 2 - s;
                            $(this).css("transform", "perspective(500px) rotateX(" + n / 40 + "deg) rotateY(" + -a / 40 + "deg) translateZ(10px)"), Math.sign(a), Math.abs(a), $(this).removeClass("tilt-leave");
                        }),
                            e.on("mouseleave", function () {
                                $(this).addClass("tilt-leave");
                            });
                    });
                },
                _initAnime: function () {
                    $(this.selectors.bannerAnime).each(function () {
                        var e = $(this),
                            t = e.data("fx"),
                            i = e.data("fx_type");
                        t &&
                            ("dominos" == i
                                ? anime
                                      .timeline({ loop: !0 })
                                      .add({
                                          targets: e.find(".fx__dominos .letter").toArray(),
                                          rotateY: [-90, 0],
                                          duration: 1300,
                                          delay: function (e, t) {
                                              return 45 * t;
                                          },
                                      })
                                      .add({ targets: e.find(".fx__dominos").toArray(), opacity: 0, duration: 1e3, easing: "easeOutExpo", delay: 1e3 })
                                : "vertical-lines" == i
                                ? anime
                                      .timeline({ loop: !0 })
                                      .add({
                                          targets: e.find(".fx__vertical-lines .letter").toArray(),
                                          scale: [0.3, 1],
                                          opacity: [0, 1],
                                          translateZ: 0,
                                          easing: "easeOutExpo",
                                          duration: 600,
                                          delay: function (e, t) {
                                              return 70 * (t + 1);
                                          },
                                      })
                                      .add({
                                          targets: e.find(".fx__vertical-lines .line").toArray(),
                                          scaleX: [0, 1],
                                          opacity: [0.5, 1],
                                          easing: "easeOutExpo",
                                          duration: 700,
                                          offset: "-=875",
                                          delay: function (e, t, i) {
                                              return 80 * (i - t);
                                          },
                                      })
                                      .add({ targets: e.find(".fx__vertical-lines").toArray(), opacity: 0, duration: 1e3, easing: "easeOutExpo", delay: 1e3 })
                                : "fading" == i
                                ? anime
                                      .timeline({ loop: !0 })
                                      .add({
                                          targets: e.find(".fx__fading .letter").toArray(),
                                          opacity: [0, 1],
                                          easing: "easeInOutQuad",
                                          duration: 2250,
                                          delay: function (e, t) {
                                              return 150 * (t + 1);
                                          },
                                      })
                                      .add({ targets: e.find(".fx__fading").toArray(), opacity: 0, duration: 1e3, easing: "easeOutExpo", delay: 1e3 })
                                : "intro" == i
                                ? anime
                                      .timeline({ loop: !0 })
                                      .add({
                                          targets: e.find(".fx__intro .letter").toArray(),
                                          translateX: [40, 0],
                                          translateZ: 0,
                                          opacity: [0, 1],
                                          easing: "easeOutExpo",
                                          duration: 1200,
                                          delay: function (e, t) {
                                              return 500 + 30 * t;
                                          },
                                      })
                                      .add({
                                          targets: e.find(".fx__intro .letter").toArray(),
                                          translateX: [0, -30],
                                          opacity: [1, 0],
                                          easing: "easeInExpo",
                                          duration: 1100,
                                          delay: function (e, t) {
                                              return 100 + 30 * t;
                                          },
                                      })
                                : "surprising" == i
                                ? anime
                                      .timeline({ loop: !0 })
                                      .add({
                                          targets: e.find(".fx__surprising .word").toArray(),
                                          scale: [14, 1],
                                          opacity: [0, 1],
                                          easing: "easeOutCirc",
                                          duration: 800,
                                          delay: function (e, t) {
                                              return 800 * t;
                                          },
                                      })
                                      .add({ targets: e.find(".fx__surprising").toArray(), opacity: 0, duration: 1e3, easing: "easeOutExpo", delay: 1e3 })
                                : anime
                                      .timeline({ loop: !0 })
                                      .add({ targets: e.find(".fx__typing .line").toArray(), scaleY: [0, 1], opacity: [0.5, 1], easing: "easeOutExpo", duration: 700 })
                                      .add({ targets: e.find(".fx__typing .line").toArray(), translateX: [0, e.find(".fx__typing .letters").first().width()], easing: "easeOutExpo", duration: 700, delay: 100 })
                                      .add({
                                          targets: e.find(".fx__typing .letter").toArray(),
                                          opacity: [0, 1],
                                          easing: "easeOutExpo",
                                          duration: 600,
                                          offset: "-=775",
                                          delay: function (e, t) {
                                              return 34 * (t + 1);
                                          },
                                      })
                                      .add({ targets: e.find(".fx__typing").toArray(), opacity: 0, duration: 1e3, easing: "easeOutExpo", delay: 1e3 }));
                    });
                },
                _lineItem: function () {
                    theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                    var e = new theme.Sections();
                    e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer);
                },
                onLoad: function () {
                    this._lineItem();
                },
                onUnload: function (e) {
                    this.$container.off(this.bannerNamspace);
                },
            })),
            e
        );
    })()),
    (theme.CollectionsSlider = (function () {
        function e(e) {
            var t = (this.$container = $(e)),
                i = (this.sectionId = t.attr("data-section-id"));
            (this.selectors = {
                container: "#CollectionsSlider-" + i,
                carousel: "#CollectionsSlider-" + i + " .slider_large",
                carousel_small: "#CollectionsSlider-" + i + " .slider_small",
                carousel_content: "#CollectionsSlider-" + i + " .slider_content-wrapper",
            }),
                this.beforeInit(),
                this.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                beforeInit: function () {
                    var e = 0.01 * window.innerHeight;
                    if (
                        (document.documentElement.style.setProperty("--vh", e + "px"),
                        window.addEventListener("resize", function () {
                            var e = 0.01 * window.innerHeight;
                            document.documentElement.style.setProperty("--vh", e + "px");
                        }),
                        void 0 === Flickity.prototype._createPrevNextCells)
                    ) {
                        function t(e, t, i) {
                            e &&
                                e.getCellElements().forEach(function (e) {
                                    e.classList[t](i);
                                });
                        }
                        Flickity.createMethods.push("_createPrevNextCells"),
                            (Flickity.prototype._createPrevNextCells = function () {
                                this.on("select", this.setPrevNextCells);
                            }),
                            (Flickity.prototype.setPrevNextCells = function () {
                                t(this.previousSlide, "remove", "is-previous"), t(this.nextSlide, "remove", "is-next");
                                var e = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length),
                                    i = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
                                (this.previousSlide = this.slides[e]), (this.nextSlide = this.slides[i]), t(this.previousSlide, "add", "is-previous"), t(this.nextSlide, "add", "is-next");
                            });
                    }
                },
                init: function () {
                    var e = this,
                        t = $(e.selectors.carousel),
                        i = $(e.selectors.carousel_small),
                        o = ($(e.selectors.carousel_content), Math.floor(i.find(".slideshow__slide").length) - 1),
                        s = t.data("autoplay"),
                        a = t.data("speed"),
                        n = t.find(".slideshow__image"),
                        r = i.find(".slideshow__image");
                    theme.settings.rtl && (o = 1);
                    var c = new Flickity(e.selectors.carousel_content, {
                            prevNextButtons: !0,
                            pageDots: !0,
                            wrapAround: !0,
                            autoPlay: !!s && a,
                            draggable: !1,
                            setGallerySize: !1,
                            sync: e.selectors.carousel,
                            arrowShape: "M3.1,28.9 28.6,3.4 32.9,7.7 14.7,25.9 68.1,25.9 68.1,32 14.7,32 32.9,50.2 28.6,54.5 z",
                            on: { ready: function () {} },
                        }),
                        l = new Flickity(e.selectors.carousel_small, {
                            bgLazyLoad: 1,
                            imagesLoaded: !0,
                            prevNextButtons: !1,
                            pageDots: !1,
                            wrapAround: !0,
                            autoPlay: !!s && a,
                            draggable: !1,
                            setGallerySize: !1,
                            initialIndex: o,
                            on: {
                                ready: function () {
                                    var e = new TimelineLite(),
                                        t = i.find(".flickity-slider");
                                    e.fromTo(t, 2, { scale: 1.2 }, { ease: Power4.easeInOut, scale: 1 }, 0);
                                },
                            },
                        });
                    l.on("scroll", function () {
                        l.slides.forEach(function (e, t) {
                            var i = r[t],
                                o = 0;
                            i &&
                                ((o =
                                    0 === t
                                        ? Math.abs(l.x) > l.slidesWidth
                                            ? l.slidesWidth + l.x + l.slides[l.slides.length - 1].outerWidth + e.target
                                            : e.target + l.x
                                        : t === d.slides.length - 1 && Math.abs(l.x) + l.slides[t].outerWidth < l.slidesWidth
                                        ? e.target - l.slidesWidth + l.x - l.slides[t].outerWidth
                                        : e.target + l.x),
                                void 0 === window.mobileCheck || window.mobileCheck() || (i.style.transform = "translateX(" + -0.5 * o + "px)"));
                        });
                    });
                    var d = new Flickity(e.selectors.carousel, {
                        bgLazyLoad: 1,
                        imagesLoaded: !0,
                        accessibility: !1,
                        prevNextButtons: !1,
                        pageDots: !1,
                        contain: !0,
                        wrapAround: !0,
                        setGallerySize: !1,
                        sync: e.selectors.carousel_content,
                        autoPlay: !!s && a,
                        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15 },
                        on: {
                            ready: function () {
                                var e = new TimelineLite(),
                                    i = t.find(".flickity-slider"),
                                    o = t.find(".slider-content-wrapper"),
                                    s = t.find(".flickity-button svg"),
                                    a = t.find(".flickity-page-dots");
                                e.fromTo(i, 2, { scale: 1.2 }, { ease: Power4.easeInOut, scale: 1 }, 0),
                                    e.fromTo(o, 2.4, { opacity: 0 }, { ease: Power4.easeInOut, opacity: 1 }, 1),
                                    e.fromTo([s, a], 2, { opacity: 0 }, { ease: Power4.easeInOut, opacity: 1 }, 1.3);
                            },
                        },
                    });
                    $(document).on("click", e.selectors.carousel_content + " .flickity-prev-next-button.previous", function () {
                        l.previous();
                    }),
                        $(document).on("click", e.selectors.carousel_content + " .flickity-prev-next-button.next", function () {
                            l.next();
                        });
                    var u = null,
                        h = null;
                    d.on("dragMove", function (t, i, o) {
                        (u = d.selectedIndex), (h = e.getSwipeDirection(o)), s && l.stopPlayer();
                    }),
                        d.on("dragEnd", function (e) {
                            d.selectedIndex !== u && ("left" === h ? l.next() : l.previous());
                        }),
                        $(e.selectors.container).on("mouseenter", function () {
                            d.stopPlayer(), l.stopPlayer(), c.stopPlayer();
                        }),
                        d.on("scroll", function () {
                            d.slides.forEach(function (e, t) {
                                var i = n[t],
                                    o = 0;
                                i &&
                                    ((o =
                                        0 === t
                                            ? Math.abs(d.x) > d.slidesWidth
                                                ? d.slidesWidth + d.x + d.slides[d.slides.length - 1].outerWidth + e.target
                                                : e.target + d.x
                                            : t === d.slides.length - 1 && Math.abs(d.x) + d.slides[t].outerWidth < d.slidesWidth
                                            ? e.target - d.slidesWidth + d.x - d.slides[t].outerWidth
                                            : e.target + d.x),
                                    void 0 === window.mobileCheck || window.mobileCheck() || (i.style.transform = "translateX(" + -0.5 * o + "px)"));
                            });
                        });
                },
                getSwipeDirection: function (e) {
                    return 0 < e.x ? "right" : "left";
                },
                onSelect: function () {
                    void 0 !== theme.roarAdminJs && theme.roarAdminJs.refresh();
                },
                onLoad: function () {},
                onUnload: function (e) {},
            })),
            e
        );
    })());
var roarLookbook = {
    getSizedImageUrl: function (e, t) {
        if ((((o = document.createElement("a")).href = e), "cdn.shopify.com" != o.hostname)) return e;
        if (null == t) return e;
        if ("master" == t) return roarLookbook.removeProtocol(e);
        var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null == i) return null;
        var o = e.split(i[0]),
            s = i[0];
        return roarLookbook.removeProtocol(o[0] + "_" + t + s);
    },
    removeProtocol: function (e) {
        return e.replace(/http(s)?:/, "");
    },
    isProductUrl: function (e) {
        var t = window.location.hostname,
            i = document.createElement("a");
        return (i.href = e), i.hostname == t;
    },
    buildLookbook: function () {
        $(".roarlookbook").each(function (e) {
            var t = $(this);
            if (!t.hasClass("roarlookbook_init")) {
                var i = t.attr("data-lookbook"),
                    o = { lookbook: i, action: "lookbook_get" };
                (o = $.param(o)),
                    $.ajax({
                        type: "POST",
                        url: "/apps/roarlookbook",
                        async: !0,
                        cache: !1,
                        data: o,
                        dataType: "json",
                        beforeSend: function () {},
                        error: function (e) {},
                        success: function (o) {
                            t.append(o);
                            var s = t.find(".media__blank-preview");
                            s.imagesLoaded(function () {
                                t.addClass("roarlookbook_init").attr("data-lookbook", i + e), s.addClass("sfx-fadeIn");
                            });
                        },
                    });
            }
        });
    },
    resetHotspots: function (e) {
        var t = $(".hotspot", e),
            i = e.attr("data-lookbook");
        t.each(function () {
            var t = $(this),
                o = t.attr("data-id"),
                s = $("#" + i + "-" + o, e);
            s.fadeOut("fast", function () {
                s.remove(), t.removeClass("hotspot_init");
            });
        });
    },
    hotspotPopup: function () {
        $(document).off("click", ".roarlookbook .hotspot"),
            $(document).on("click", ".roarlookbook .hotspot", function (e) {
                var t = $(this);
                if (t.hasClass("hotspot_init")) (i = t.closest(".roarlookbook")), roarLookbook.resetHotspots(i);
                else {
                    var i = t.closest(".roarlookbook"),
                        o = t.attr("data-id"),
                        s = t.closest(".roarlookbook").attr("data-lookbook") + "-" + o,
                        a = "#" + t.closest(".roarlookbook").attr("data-lookbook") + "-" + o,
                        n = t.attr("data-title"),
                        r = t.attr("data-image"),
                        c = t.attr("data-price"),
                        l = t.attr("data-url"),
                        d = "";
                    if ("" == n && "" == l) return !1;
                    if (
                        (roarLookbook.resetHotspots(i),
                        (d += '<div id="' + s + '" class="hotspot-widget hotspot-loading">'),
                        (d += '<div class="hotspot-content">'),
                        (d += '<span class="hotspot-close">×</span>'),
                        (d += '<div class="hotspot-inner">'),
                        "" != r)
                    ) {
                        d += '<div class="hotspot-img">';
                        var u =
                            '<img src="' +
                            roarLookbook.getSizedImageUrl(r, "80x") +
                            '" src="' +
                            roarLookbook.getSizedImageUrl(r, "300x") +
                            '" data-srcset="' +
                            roarLookbook.getSizedImageUrl(r, "300x") +
                            " 1x, " +
                            roarLookbook.getSizedImageUrl(r, "600x") +
                            ' 2x" alt="" />';
                        (d += "" != l ? '<a href="' + l + '">' + u + "</a>" : u), (d += "</div>");
                    }
                    if (
                        ((d += '<div class="hotspot-desc">'),
                        "" != n && ((d += "<h3>"), (d += "" != l ? '<a href="' + l + '">' + n + "</a>" : n), (d += "</h3>")),
                        "" != c &&
                            ((d += '<div class="price"><span class="money">' + c + "</span></div>"),
                            roarLookbook.isProductUrl(l) &&
                                ((d += '<div class="hotspot-btns">'),
                                (d += '<div class="hotspot-btn"><a href="' + l + '">' + theme.apps.details + "</a></div>"),
                                (d += '<div class="hotspot-btn"><a class="roar_add_to_cart" href="' + l + '?add-to-cart=true">' + theme.apps.buyNow + "</a></div>"),
                                (d += "</div>"))),
                        (d += "</div>"),
                        (d += "</div>"),
                        (d += "</div>"),
                        (d += "</div>"),
                        $(a).length || i.append(d),
                        $(a).imagesLoaded(function () {
                            var e = $(a),
                                o = t.offset().left,
                                s = t.offset().top,
                                n = e.outerWidth(),
                                r = e.outerHeight(),
                                c = i.offset().left,
                                l = i.offset().top,
                                d = (i.outerWidth(), "hotspot-right");
                            n + 5 < o ? ((o = o - n - 5), (d = "hotspot-left")) : (o = o + t.outerWidth() + 5),
                                (s = s + t.outerHeight() / 2 - r / 2),
                                e
                                    .css({ left: o - c, top: s - l })
                                    .removeClass("hotspot-left")
                                    .removeClass("hotspot-right")
                                    .addClass(d),
                                t.addClass("hotspot_init"),
                                e.removeClass("hotspot-loading").fadeIn("fast");
                        }),
                        $(a).find("img").length)
                    ) {
                        var h = $(a).find("img");
                        h.attr("src", h.attr("data-src")).removeAttr("data-src").attr("srcset", h.attr("data-srcset")).removeAttr("data-srcset");
                    }
                }
            }),
            $(document).off("click", ".hotspot-close"),
            $(document).on("click", ".hotspot-close", function (e) {
                var t = $(this).closest(".hotspot-widget"),
                    i = t.attr("id").split("-")[1];
                $('.roarlookbook .hotspot[data-id="' + i + '"]').removeClass("hotspot_init"),
                    t.fadeOut("fast", function () {
                        t.remove();
                    });
            }),
            $(".roarlookbook").on("click", ".image-preview", function (e) {
                var t = $(this).closest(".roarlookbook");
                roarLookbook.resetHotspots(t);
            }),
            $(window).resize(function (e) {
                $(".roarlookbook .hotspot_init").length &&
                    $(".roarlookbook .hotspot_init").each(function () {
                        $(this).removeClass("hotspot_init").trigger("click");
                    });
            });
    },
    addToCart: function () {
        $(document).off("click", ".roar_add_to_cart"),
            $(document).on("click", ".roar_add_to_cart", function (e) {
                e.preventDefault();
                var t = $(this),
                    i = t.closest(".roarlookbook"),
                    o = t.attr("href");
                $.ajax({
                    type: "GET",
                    url: o,
                    beforeSend: function () {},
                    success: function (e) {
                        $(e).find('form[action="/cart/add"]').appendTo(i).submit().remove();
                    },
                    dataType: "html",
                });
            });
    },
    init: function () {
        $(".roarlookbook").length && (roarLookbook.buildLookbook(), roarLookbook.hotspotPopup(), roarLookbook.addToCart());
    },
};
function load_tabs() {
    $("ul.tabs").each(function () {
        var e,
            t,
            i = $(this).find("a");
        i.not(":first").each(function () {
            0 == $(this).hasClass("no-tab") && $($(this).attr("href")).hide();
        }),
            $(this)
                .find("a")
                .click(function (i) {
                    if (0 == $(this).hasClass("no-tab")) return e && (e.removeClass("active"), t.hide()), (e = $(this)), (t = $($(this).attr("href"))), e.addClass("active"), t.fadeIn(), !1;
                }),
            i.first().click();
    });
}
(theme.roarJs = (function () {
    function e(e, t, i) {
        void 0 === i && (i = !1), $(".alert-message").remove();
        var o = '<div class="alert alert-' + ("check" == e ? "success" : "error") + ' alert-message"><div class="alert__icon"><i class="ris ri-' + e + '"></i></div><div class="alert__content">' + t + "</div></div>";
        1 == i && (o = '<div class="alert alert-message cart_message"><div class="alert__background" style="background-image:url(' + e + ');"></div><div class="alert__description">' + t + "</div></div>"), $("body").append(o);
    }
    function t() {
        if (void 0 === window.mobileCheck) return !1;
        992 < $(window).width() &&
            !window.mobileCheck() &&
            0 < $(".products-grid.layout-2").length &&
            $(".products-grid.layout-2 .category__title:not(.split-text), .products-grid.layout-2 .product__link:not(.split-text), .product-single__notify label:not(.split-text)").each(function () {
                var e = $(this);
                new SplitText(e, { type: "lines" }), e.addClass("split-text").find("div").wrapInner("<span></span>");
            });
    }
    function i(e) {
        var t = new TimelineLite(),
            i = $(".product-single__title", e),
            o = $(".product-single .product__labels", e),
            s = $(".product-single .sidebar-container", e),
            a = $(".product-single__top .box-share-master-container", e),
            n = $(".product-single__right, .product-single__tools", e),
            r = $(".product-single__nav", e),
            c = $(".product-single__middle", e),
            l = $(".product-single__bottom", e);
        t.fromTo(i, 1.6, { y: 100, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.7),
            t.fromTo(c, 2, { y: 40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.8),
            t.fromTo(l, 2, { y: 40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 1),
            t.fromTo([o, a, n, r, s], 2, { opacity: 0 }, { ease: Power4.easeInOut, opacity: 1 }, 0.7);
    }
    function o() {
        if ("undefined" == typeof ScrollReveal) return !1;
        (window.sr = ScrollReveal()),
            sr.reveal(
                ".products-grid.layout-2 .product:not(.active)",
                {
                    opacity: 0,
                    viewFactor: 0.2,
                    afterReveal: function (e) {
                        if (void 0 === window.mobileCheck) return !1;
                        e.classList.add("active");
                        var t = $(e).find(".product__link div span, .category__title div span"),
                            i = $(e).find(".product__review, .more-products"),
                            o = $(e).find(".product__price");
                        (e.visuelRevealTL = new TimelineLite()),
                            992 < $(window).width() &&
                                !window.mobileCheck() &&
                                0 < $(".products-grid.layout-2").length &&
                                (e.visuelRevealTL.fromTo(t, 1, { ease: Power4.easeOut, x: 30, y: 100, skewX: 60, opacity: 0 }, { ease: Power4.easeOut, x: 0, y: 0, skewX: 0, opacity: 1 }, 0),
                                null !== i && e.visuelRevealTL.fromTo(i, 2, { y: 10, opacity: 0 }, { ease: Power4.easeOut, y: 0, opacity: 1 }, 0.4),
                                null !== o && e.visuelRevealTL.fromTo(o, 2, { y: 10 }, { ease: Power4.easeOut, y: 0, opacity: 1 }, 0.2));
                    },
                    beforeReveal: function (e) {
                        e.classList.add("active");
                        var t = $(e).find(".product__image, .category__image");
                        null !== t && ((e.visuelRevealTL = new TimelineLite()), e.visuelRevealTL.fromTo(t, 2, { scale: 1.1 }, { ease: Power4.easeOut, scale: 1 }, 0));
                    },
                },
                150
            );
    }
    function s() {
        "undefined" == typeof ParallaxScroll || void 0 === window.mobileCheck || window.mobileCheck() || ParallaxScroll.init(),
            (function () {
                function e(e) {
                    var t = this,
                        i = $(window),
                        o = i.scrollTop(),
                        s = !0,
                        a = i.width(),
                        n = i.height(),
                        r = null,
                        c = null,
                        l = null,
                        d = !1;
                    function u(e) {
                        (o = i.scrollTop()), (t.allowScrollUpdate = !0);
                    }
                    function h(e) {
                        return e && "[object Function]" === {}.toString.call(e);
                    }
                    (t.init = function (e) {
                        return (
                            (t.options = $.extend(
                                { target: null, tween: null, ease: Linear.easeNone, min: 0, max: 1, minSize: 0, speed: 0.3, defaultProgress: 1, debug: !1, onMin: null, onMax: null, onOutside: null, onInside: null, onUpdate: null },
                                e
                            )),
                            null === t.options.target || t.options.target.length < 1
                                ? (console.warn("Extra Scroll Animator: no target specified"), !1)
                                : null === t.options.tween
                                ? (console.warn("Extra Scroll Animator: no tween specified"), !1)
                                : ((t.allowScrollUpdate = !0), t.update(), void t.repaint())
                        );
                    }),
                        (t.updatePosition = function (e) {
                            if (s) {
                                var i,
                                    a = void 0 !== e && e ? 0 : t.options.speed,
                                    n = t.options.target.data("coords");
                                n &&
                                    ((i = 1 - (o - n.max) / (n.min - n.max)) <= 0 && !0 !== r ? ((r = !0), h(t.options.onMin) && t.options.onMin(), t.options.target.trigger("extra:scrollanimator:min")) : 0 < i && !1 !== r && (r = !1),
                                    1 <= i && !0 !== c ? ((c = !0), h(t.options.onMax) && t.options.onMax(), t.options.target.trigger("extra:scrollanimator:max")) : i <= 1 && !1 !== c && (c = !1),
                                    (!0 !== r && !0 !== c) || !1 === l
                                        ? i <= 1 && 0 <= i && !0 !== l && ((l = !0), h(t.options.onInside) && t.options.onInside(), t.options.target.trigger("extra:scrollanimator:inside"))
                                        : ((l = !1), h(t.options.onOutside) && t.options.onOutside(), t.options.target.trigger("extra:scrollanimator:outside")),
                                    !1 === l && (i = c ? 1 : 0),
                                    (function (e) {
                                        !0 === t.options.debug && console.log(e);
                                    })((i = Math.max(0, Math.min(i)))),
                                    TweenLite.to(t.options.tween, a, { progress: i, ease: t.options.ease }));
                            }
                        }),
                        (t.update = function () {
                            (a = i.width()), (n = i.height());
                            var e = {},
                                o = t.options.target.offset().top,
                                s = t.options.target.height(),
                                r = t.options.min,
                                c = t.options.max;
                            (e.min = o - n + n * r),
                                (e.max = o - n + s + n * c),
                                t.options.target.data("coords", e),
                                t.options.tween.paused(!0),
                                t.options.tween.progress(t.options.defaultProgress),
                                a < t.options.minSize ? i.off("scroll", u) : (i.on("scroll", u), t.updatePosition(!0)),
                                h(t.options.onUpdate) && t.options.onUpdate(e),
                                t.options.target.trigger("extra:scrollanimator:update", [e]);
                        }),
                        i.on("extra:resize", t.update),
                        i.on("extra:scrollanimator:resize", t.update),
                        i.on("extra:scrollanimator:tick", t.updatePosition),
                        (t.repaint = function () {
                            s && (t.allowScrollUpdate && (t.updatePosition(), (t.allowScrollUpdate = !1)), window.requestAnimationFrame(t.repaint));
                        }),
                        t.init(e),
                        (t.updateTween = function (e) {
                            t.options.tween && t.options.tween.kill(), (t.options.tween = e), t.options.tween.paused(!0), t.options.tween.progress(t.options.defaultProgress), (t.allowScrollUpdate = !0), t.update();
                        }),
                        (t.pause = function () {
                            d || (i.off("scroll", u), i.off("extra:resize", t.update), (d = !(s = !1)));
                        }),
                        (t.resume = function () {
                            d && (a < t.options.minSize ? i.off("scroll", u) : i.on("scroll", u), i.on("extra:resize", t.update), (d = !(s = !0)), t.repaint());
                        }),
                        (t.destroy = function () {
                            (s = !1),
                                i.off("scroll", u),
                                i.off("extra:resize", t.update),
                                i.off("extra:scrollanimator:tick", t.updatePosition),
                                t.options.tween && (t.options.tween.paused(!0), t.options.tween.progress(t.options.defaultProgress), t.options.tween.kill()),
                                (t.allowScrollUpdate = !1);
                        });
                }
                (window.initPrllx = function (t) {
                    $(".site-main .article__image").length &&
                        $(".site-main")
                            .find(".article__image")
                            .each(function () {
                                var t,
                                    i = $(this),
                                    o = i.children(),
                                    s = i.find(".prllx");
                                o.width(),
                                    (t = new TimelineLite({ onUpdate: function () {} })).set(s, { y: -1 * s.attr("data-prllx") }).to(s, 1, { y: s.attr("data-prllx"), overwrite: "all", ease: Power0.easeNone }, "-=0.5"),
                                    new e({ target: i, tween: t, defaultProgress: 0, speed: 0, min: -0.2, max: 1.3 }),
                                    i.on("extra:scrollanimator:update", function (e) {
                                        e.stopPropagation();
                                    });
                            });
                }),
                    (window.initSkrollr = function () {
                        if (0 == $(".site-main .skrollable").length || "undefined" == typeof skrollr) return !1;
                        $(".section__bground.skrollable").css("height", "120%").closest(".container-section").addClass("overflow-hidden"),
                            skrollr.init({
                                forceHeight: !1,
                                smoothScrolling: !1,
                                mobileCheck: function () {
                                    return !1;
                                },
                            });
                    }),
                    $(window).on("load", function () {
                        void 0 === window.mobileCheck || window.mobileCheck() || (window.initPrllx(), window.initSkrollr());
                    });
            })(),
            void 0 !== $.fn.imagesLoaded &&
                $(".page-header-bg").imagesLoaded({ background: !0 }, function () {
                    $(".page-header-bg-wrapper").addClass("loaded");
                    var e = new TimelineLite(),
                        t = $(".site-header__main"),
                        i = $(".site-header__top"),
                        o = $(".page-title"),
                        s = $(".term-description"),
                        a = $(".breadcrumbs"),
                        n = $(".page-categories, .page-meta_list"),
                        r = $(".page-delimiter"),
                        c = $(".back-btn svg"),
                        l = $(".content-area"),
                        d = $(".site-pagination"),
                        u = $("#site-footer"),
                        h = $("body");
                    h.addClass("run-anim"),
                        e.fromTo([t, i], 1, { autoAlpha: 0, opacity: 0 }, { ease: Power4.easeInOut, autoAlpha: 1, opacity: 1 }, 0.2).call(function (e) {
                            h.removeClass("run-anim");
                        }),
                        e.fromTo(o, 1.2, { y: 100, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.3),
                        e.fromTo(s, 1.4, { scale: 1.4, opacity: 0 }, { ease: Power4.easeInOut, scale: 1, opacity: 1 }, 0.2),
                        e.fromTo(c, 1, { x: 20, opacity: 0 }, { ease: Power4.easeInOut, x: 0, opacity: 1 }, 0.5),
                        $("body").hasClass("template-collection")
                            ? e.fromTo(a, 1.2, { y: 40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.25)
                            : $("body").hasClass("template-product")
                            ? e.fromTo(a, 1.2, { y: 40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.6)
                            : e.fromTo(a, 1.2, { y: 40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.25),
                        e.fromTo(n, 1.4, { y: -40, opacity: 0 }, { ease: Power4.easeInOut, y: 0, opacity: 1 }, 0.25),
                        e.fromTo(r, 1, { opacity: 0, width: 0 }, { opacity: 1, width: 70 }, 0.8),
                        e.fromTo([l, d], 1, { opacity: 0 }, { opacity: 1 }, 0.8),
                        e.fromTo(u, 1, { opacity: 0 }, { opacity: 1 }, 1.5);
                }),
            i($(".product-template__container")),
            0 != $(".blog-main .article__listing").length && "undefined" != typeof ScrollReveal && ((window.sr = ScrollReveal()), sr.reveal(".blog-main .article__listing", { opacity: 0, duration: 1600, mobile: !0, viewFactor: 0 })),
            t(),
            o();
    }
    return {
        init: function () {
            var t, i, o;
            $("#site-loader").length &&
                (NProgress.configure({ template: '<div class="bar" role="bar"></div>', parent: "#site-loader", showSpinner: !1, easing: "ease", minimum: 0.3, speed: 500 }),
                NProgress.start(),
                $(window).on("pagehide", function (e) {
                    e.persisted && ($("#site-container").addClass("loading").removeClass("loaded"), $("#site-loader").removeClass("loaded"));
                }),
                $(window).load(function (e) {
                    $("#site-container").addClass("loaded").removeClass("loading"), $("#site-loader").addClass("loaded"), NProgress.done();
                })),
                (function (e) {
                    try {
                        for (var t = "roarStorage_isAnAdult=", i = document.cookie.split(";"), o = 0; o < i.length; o++) {
                            for (var s = i[o]; " " == s.charAt(0); ) s = s.substring(1, s.length);
                            if (0 == s.indexOf(t)) return s.substring(t.length, s.length);
                        }
                        return null;
                    } catch (e) {
                        return null;
                    }
                })()
                    ? $("#age__check").remove()
                    : $("#age__check").show(),
                $(document).off("click", "#age__check .btn-birthdate"),
                $(document).on("click", "#age__check .btn-birthdate", function () {
                    var e = new Date();
                    e.setTime(e.getTime() + 12096e5);
                    var t = "; expires=" + e.toGMTString();
                    (document.cookie = "roarStorage_isAnAdult=true;" + t + "; path=/"), $("#age__check").remove();
                }),
                0 != $(".social-sharing").length &&
                    void 0 !== $.fn.socialShare &&
                    $(".social-sharing").each(function () {
                        var e = $(this);
                        e.socialShare({ name: e.data("name"), title: e.data("title"), mediaUrl: e.data("share_img"), social: e.data("share_elem"), animation: "launchpadReverse", blur: !0 });
                    }),
                s(),
                $("body").on("click", ".barberry-show-categories", function (e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.closest(".page-categories-wrapper");
                    if (t.hasClass("opened")) {
                        var o = new TimelineLite(),
                            s = i.find(".barberry-categories"),
                            a = i.find(".barberry-categories .category_item");
                        o.fromTo(s, 1, { "max-height": 1e3, autoAlpha: 1 }, { autoAlpha: 0, "max-height": 0, ease: Power3.easeInOut }, 0),
                            setTimeout(function () {
                                t.removeClass("opened"), s.removeClass("opened");
                            }, 700);
                    } else
                        (o = new TimelineLite()),
                            (s = i.find(".barberry-categories")),
                            (a = i.find(".barberry-categories .category_item")),
                            o.fromTo(s, 1, { "max-height": 0, autoAlpha: 0 }, { "max-height": 1e3, autoAlpha: 1, ease: Power4.easeIn }, 0),
                            o.staggerFromTo(a, 1, { opacity: 0, scale: 2, skewX: 30 }, { opacity: 1, scale: 1, skewX: 0, ease: Power4.easeOut }, 0.1, 0.3),
                            setTimeout(function () {
                                s.addClass("opened"), t.addClass("opened");
                            }, 500);
                }),
                roarLookbook.init(),
                $(".lookbook-section.is-slick_slider .lookbook-listing").length &&
                    $(".lookbook-section.is-slick_slider .lookbook-listing").each(function () {
                        var e = $(this),
                            t = {
                                rtl: theme.settings.rtl,
                                centerMode: !0,
                                centerPadding: "20%",
                                slidesToShow: 1,
                                appendArrows: $(".slick-arrows", e.parent()),
                                prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
                                nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
                            },
                            i = e.find(".lookbook__item").length,
                            o = setInterval(function () {
                                var s = e.find("img.image-preview").length;
                                i <= s &&
                                    (e.imagesLoaded(function () {
                                        setTimeout(function () {
                                            e.slick(t);
                                        }, 500);
                                    }),
                                    clearInterval(o));
                            }, 300);
                    }),
                $("[data-roarslider]").each(function () {
                    var e = $(this),
                        t = "revapi" + e.data("roarslider");
                    document.addEventListener(
                        t,
                        function (t) {
                            e.addClass("loaded");
                        },
                        !1
                    );
                }),
                $(document).off("click", ".section__anchor"),
                $(document).on("click", ".section__anchor", function (e) {
                    e.preventDefault();
                    var t = $(this).closest(".container-section"),
                        i = t.offset().top + t.outerHeight();
                    $(".header-sticky__placeholder").length && !$(".header-sticky__placeholder").hasClass("hide") && (i -= $(".header-sticky__placeholder").outerHeight()), $("html, body").animate({ scrollTop: i }, 500, "swing");
                }),
                (o = [
                    {},
                    {
                        movement: {
                            imgWrapper: { translation: { x: 10, y: 10, z: 30 }, rotation: { x: 0, y: -10, z: 0 }, reverseAnimation: { duration: 200, easing: "easeOutQuad" } },
                            lines: { translation: { x: 10, y: 10, z: [0, 70] }, rotation: { x: 0, y: 0, z: -2 }, reverseAnimation: { duration: 2e3, easing: "easeOutExpo" } },
                            caption: { rotation: { x: 0, y: 0, z: 2 }, reverseAnimation: { duration: 200, easing: "easeOutQuad" } },
                            overlay: { translation: { x: 10, y: -10, z: 0 }, rotation: { x: 0, y: 0, z: 2 }, reverseAnimation: { duration: 2e3, easing: "easeOutExpo" } },
                            shine: { translation: { x: 100, y: 100, z: 0 }, reverseAnimation: { duration: 200, easing: "easeOutQuad" } },
                        },
                    },
                    {
                        movement: {
                            imgWrapper: { rotation: { x: -5, y: 10, z: 0 }, reverseAnimation: { duration: 900, easing: "easeOutCubic" } },
                            caption: { translation: { x: 30, y: 30, z: [0, 40] }, rotation: { x: [0, 15], y: 0, z: 0 }, reverseAnimation: { duration: 1200, easing: "easeOutExpo" } },
                            overlay: { translation: { x: 10, y: 10, z: [0, 20] }, reverseAnimation: { duration: 1e3, easing: "easeOutExpo" } },
                            shine: { translation: { x: 100, y: 100, z: 0 }, reverseAnimation: { duration: 900, easing: "easeOutCubic" } },
                        },
                    },
                    {
                        movement: {
                            imgWrapper: { rotation: { x: -5, y: 10, z: 0 }, reverseAnimation: { duration: 50, easing: "easeOutQuad" } },
                            caption: { translation: { x: 20, y: 20, z: 0 }, reverseAnimation: { duration: 200, easing: "easeOutQuad" } },
                            overlay: { translation: { x: 5, y: -5, z: 0 }, rotation: { x: 0, y: 0, z: 6 }, reverseAnimation: { duration: 1e3, easing: "easeOutQuad" } },
                            shine: { translation: { x: 50, y: 50, z: 0 }, reverseAnimation: { duration: 50, easing: "easeOutQuad" } },
                        },
                    },
                    {
                        movement: {
                            imgWrapper: { translation: { x: 0, y: -8, z: 0 }, rotation: { x: 3, y: 3, z: 0 }, reverseAnimation: { duration: 1200, easing: "easeOutExpo" } },
                            lines: { translation: { x: 15, y: 15, z: [0, 15] }, reverseAnimation: { duration: 1200, easing: "easeOutExpo" } },
                            overlay: { translation: { x: 0, y: 8, z: 0 }, reverseAnimation: { duration: 600, easing: "easeOutExpo" } },
                            caption: { translation: { x: 10, y: -15, z: 0 }, reverseAnimation: { duration: 900, easing: "easeOutExpo" } },
                            shine: { translation: { x: 50, y: 50, z: 0 }, reverseAnimation: { duration: 1200, easing: "easeOutExpo" } },
                        },
                    },
                    {
                        movement: {
                            lines: { translation: { x: -5, y: 5, z: 0 }, reverseAnimation: { duration: 1e3, easing: "easeOutExpo" } },
                            caption: { translation: { x: 15, y: 15, z: 0 }, rotation: { x: 0, y: 0, z: 3 }, reverseAnimation: { duration: 1500, easing: "easeOutElastic", elasticity: 700 } },
                            overlay: { translation: { x: 15, y: -15, z: 0 }, reverseAnimation: { duration: 500, easing: "easeOutExpo" } },
                            shine: { translation: { x: 50, y: 50, z: 0 }, reverseAnimation: { duration: 500, easing: "easeOutExpo" } },
                        },
                    },
                    {
                        movement: {
                            imgWrapper: { translation: { x: 5, y: 5, z: 0 }, reverseAnimation: { duration: 800, easing: "easeOutQuart" } },
                            caption: { translation: { x: 10, y: 10, z: [0, 50] }, reverseAnimation: { duration: 1e3, easing: "easeOutQuart" } },
                            shine: { translation: { x: 50, y: 50, z: 0 }, reverseAnimation: { duration: 800, easing: "easeOutQuart" } },
                        },
                    },
                    {
                        movement: {
                            lines: { translation: { x: 40, y: 40, z: 0 }, reverseAnimation: { duration: 1500, easing: "easeOutElastic" } },
                            caption: { translation: { x: 20, y: 20, z: 0 }, rotation: { x: 0, y: 0, z: -5 }, reverseAnimation: { duration: 1e3, easing: "easeOutExpo" } },
                            overlay: { translation: { x: -30, y: -30, z: 0 }, rotation: { x: 0, y: 0, z: 3 }, reverseAnimation: { duration: 750, easing: "easeOutExpo" } },
                            shine: { translation: { x: 100, y: 100, z: 0 }, reverseAnimation: { duration: 750, easing: "easeOutExpo" } },
                        },
                    },
                ]),
                (i = 0),
                [].slice.call(document.querySelectorAll(".tilter")).forEach(function (e, t) {
                    (i = t % 30 == 0 ? i + 1 : i), new TiltFx(e, o[i - 1]);
                }),
                $(".slick__gallery").each(function () {
                    $(this).slick({
                        rtl: theme.settings.rtl,
                        prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
                        nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
                    });
                }),
                $(".soundcloud__audio").each(function () {
                    var e = $(this),
                        t = { async: !0, crossDomain: !0, url: "https://soundcloud.com/oembed", method: "GET", headers: {}, data: { format: "json", url: e.data("video") } };
                    $.ajax(t).done(function (t) {
                        e.replaceWith(t.html);
                    });
                }),
                $(document).off("click", ".sidebar__btn, .sidebar__close, .sidebar__overlay"),
                $(document).on("click", ".sidebar__btn, .sidebar__close, .sidebar__overlay", function () {
                    var e, t, i;
                    $("body").hasClass("sidebar-open")
                        ? $("body").removeClass("sidebar-open")
                        : ($("body").addClass("sidebar-open"),
                          (e = new TimelineLite()),
                          (t = $(".site-sidebar .widget-area")),
                          (i = $(".site-sidebar .site-widget")),
                          theme.settings.rtl
                              ? (e.fromTo(t, 1, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeInOut }, 0.1), e.staggerFromTo(i, 0.5, { opacity: 0, skewX: -10, x: 40 }, { opacity: 1, skewX: 0, x: 0 }, 0.1, 0.2))
                              : (e.fromTo(t, 1, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeInOut }, 0.1), e.staggerFromTo(i, 0.5, { opacity: 0, skewX: 10, x: -40 }, { opacity: 1, skewX: 0, x: 0 }, 0.1, 0.2)));
                }),
                $(document).off("click", ".filters__btn"),
                $(document).on("click", ".filters__btn", function () {
                    $(".shop__filtering").slideToggle();
                }),
                $(document).off("click", ".header__toggle"),
                $(document).on("click", ".header__toggle", function () {
                    $(this).toggleClass("active"), $(".collection-header ul").slideToggle();
                }),
                $(".quickview_btn").length &&
                    ($(document).off("click", ".quickview_btn"),
                    $(document).on("click", ".quickview_btn", function (e) {
                        e.preventDefault();
                        var t = $(this),
                            i = t.data("collection_handle"),
                            o = t.data("product_handle");
                        t
                            .closest(".product__item")
                            .find(".product__image")
                            .css("background-image")
                            .replace(/^url\(['"](.+)['"]\)/, "$1"),
                            $.ajax({
                                url: "/collections/" + i + "/products/" + o + "?view=quickview&cache=false",
                                beforeSend: function () {
                                    t.addClass("adding");
                                },
                                complete: function () {
                                    t.removeClass("adding");
                                },
                                success: function (e) {
                                    $(".cd-quick-view .cd-content").empty().html(e),
                                        setTimeout(function () {
                                            $(".cd-quick-view").addClass("opened");
                                        }, 300),
                                        setTimeout(function () {
                                            $("body").addClass("blurred").addClass("quickview-opened");
                                        }, 500),
                                        theme.roarJs.productInfoAnimation($(".cd-quick-view")),
                                        new theme.Sections().register("product-quickview", theme.Product),
                                        Shopify.PaymentButton.init();
                                },
                            });
                    }),
                    $(document).off("click", ".cd-close, .cd-overlay"),
                    $(document).on("click", ".cd-close, .cd-overlay", function () {
                        $("body").removeClass("blurred").removeClass("quickview-opened"), $(".cd-quick-view").removeClass("opened");
                    }),
                    $(document).keyup(function (e) {
                        "27" == e.which && $(".cd-quick-view").hasClass("opened") && $(".cd-close").trigger("click");
                    })),
                $(".product__colors .swatch-item").length &&
                    ($(document).off("click", ".product__colors .swatch-item"),
                    $(document).on("click", ".product__colors .swatch-item", function (e) {
                        e.preventDefault();
                        var t = $(this);
                        if (!t.hasClass("active")) {
                            var i = t.closest(".product__item").find(".product__image-featured"),
                                o = t.data("bgset");
                            i.attr("data-bgset", o).removeClass("lazyloaded").addClass("lazyload"), t.closest(".product__colors").find(".swatch-item").removeClass("active"), t.addClass("active");
                        }
                    })),
                $(document).off("click", ".addcart_btn:not(.added), .product-form__cart-submit"),
                $(document).on("click", ".addcart_btn:not(.added), .product-form__cart-submit", function (t) {
                    t.preventDefault();
                    var i = $(this),
                        o = i.closest("form"),
                        s = $("body");
                    return (
                        1 != theme.settings.cartAjax
                            ? o.submit()
                            : $.ajax({
                                  type: "POST",
                                  url: "/cart/add.js",
                                  async: !0,
                                  cache: !1,
                                  data: o.serialize(),
                                  dataType: "json",
                                  beforeSend: function () {
                                      i.addClass("adding");
                                  },
                                  success: function (t) {
                                    debugger;
                                      if ("redirect" == theme.settings.afterAddition) return !(window.location = "/cart");
                                      theme.MiniCart.update()
                                          .promise()
                                          .done(function () {
                                              var o = 0;
                                              i.hasClass("progress-btn") && (o = 500),
                                                  i.addClass("active"),
                                                  setTimeout(function () {
                                                      i.removeClass("adding").text(i.data("added")).addClass("added"),
                                                          o &&
                                                              setTimeout(function () {
                                                                  i.removeClass("active").removeClass("added");
                                                              }, 2e3);
                                                  }, o);
                                              var a = theme.settings.afterAddition,
                                                  n = 0;
                                              o && (n = o + 800),
                                                  (s.hasClass("compare-opened") || s.hasClass("quickview-opened")) && ((n = 0), (a = "message")),
                                                  setTimeout(function () {
                                                      switch (a) {
                                                          case "minicart":
                                                              theme.MiniCart.open();
                                                              break;
                                                          case "message":
                                                              var i = t;
                                                              if (void 0 !== i.id) {
                                                                  var o = theme.Images.getSizedImageUrl(i.image, "200x"),
                                                                      s = i.title;
                                                                  e(o, theme.strings.productAdded.replace("{{ product_name }}", s), !0);
                                                              } else e("alert", i.message + ": " + i.description);
                                                      }
                                                  }, n);
                                              $(".cart__list").find(".cart__item").each(function(){
                                                let totlQnty = $(this).attr("data-variant-qnty");
                                                let cartqnty = $(this).find(".cart-modal").find(".qty").val();
                                              cartqnty > 0 ? parseInt(cartqnty) :cartqnty;
                                              if(cartqnty >= totlQnty){ $(this).find(".cart-modal").find(".plus").addClass("opacity0");}
                                              else{
                                                $(this).find(".cart-modal").find(".plus").removeClass("opacity0");
                                              }
                                              if(cartqnty > 1){ $(this).find(".cart-modal").find(".minus").removeClass("opacity0");}
                                              else{
                                                $(this).find(".cart-modal").find(".minus").addClass("opacity0");
                                              }
                                              if(totlQnty == 0){
                                                $(this).remove();
                                              }

                                            });	
                                          });
                                  },
                              error:function(xhr){
                               
                              	console.log(xhr);
                              }
                              }),
                        !1
                    );
                }),
                $(document).off("click", ".product-form__cart-submit--grouped"),
                $(document).on("click", ".product-form__cart-submit--grouped", function (e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.closest(".product-single__content").find(".product-single__grouped .product-form__input");
                    return (
                        i.length &&
                            ((Shopify.queue = []),
                            i.each(function () {
                                0 < parseInt($(this).val()) && Shopify.queue.push({ variantId: $(this).data("variant_id"), quantity: parseInt($(this).val()) });
                            }),
                            (Shopify.moveAlong = function () {
                                if (Shopify.queue.length) {
                                    var e = Shopify.queue.shift();
                                    Shopify.addItem(e.variantId, e.quantity, e.properties, Shopify.moveAlong);
                                } else t.removeClass("adding"), theme.MiniCart.update(), "redirect" == theme.settings.afterAddition ? (location.href = "/cart") : "minicart" == theme.settings.afterAddition && theme.MiniCart.open();
                            }),
                            (Shopify.addItem = function (e, t, i, o) {
                                var s = { quantity: t, id: e };
                                0 != i && (s.properties = i),
                                    $.ajax({
                                        type: "POST",
                                        url: "/cart/add.js",
                                        dataType: "json",
                                        data: s,
                                        success: function () {
                                            "function" == typeof o && o();
                                        },
                                        error: function () {},
                                    });
                            }),
                            Shopify.queue.length && (t.addClass("adding"), Shopify.moveAlong())),
                        !1
                    );
                }),
                $(document).off("click", ".products-grid .product__item .options_btn"),
                $(document).on("click", ".products-grid .product__item .options_btn", function (e) {
                    e.preventDefault(), $(this).closest(".product__item").addClass("opened");
                }),
                $(document).off("click", ".products-grid .product__item .close_btn"),
                $(document).on("click", ".products-grid .product__item .close_btn", function (e) {
                    e.preventDefault(), $(this).closest(".product__item").removeClass("opened");
                }),
                $(".addwishlist_btn").length &&
                    ($(document).off("click", ".addwishlist_btn:not(.added)"),
                    $(document).on("click", ".addwishlist_btn:not(.added)", function (t) {
                        t.preventDefault();
                        var i = $(this),
                            o = parseInt(i.data("customer_id"));
                        if (0 < o) {
                            var s = i.data("shop_domain"),
                                a = parseInt(i.data("product_id")),
                                n = i.data("product_handle");
                            if (s.length && n.length && a) {
                                var r = document.createElement("form");
                                r.setAttribute("action", "/contact"), r.setAttribute("method", "POST"), r.setAttribute("style", "display:none");
                                var c = document.createElement("input");
                                c.setAttribute("type", "hidden"), c.setAttribute("name", "customer"), c.setAttribute("value", o);
                                var l = document.createElement("input");
                                l.setAttribute("type", "hidden"), l.setAttribute("name", "shop"), l.setAttribute("value", s);
                                var d = document.createElement("input");
                                d.setAttribute("type", "hidden"), d.setAttribute("name", "id"), d.setAttribute("value", a);
                                var u = document.createElement("input");
                                u.setAttribute("type", "hidden"), u.setAttribute("name", "handle"), u.setAttribute("value", n);
                                var h = document.createElement("input");
                                h.setAttribute("type", "hidden"),
                                    h.setAttribute("name", "action"),
                                    h.setAttribute("value", "add_wishlist"),
                                    r.appendChild(c),
                                    r.appendChild(l),
                                    r.appendChild(d),
                                    r.appendChild(u),
                                    r.appendChild(h),
                                    $("body").append(r);
                                var p = $(r).serialize();
                                $.ajax({
                                    type: "POST",
                                    url: "/a/wishlist",
                                    async: !0,
                                    cache: !1,
                                    data: p,
                                    dataType: "json",
                                    beforeSend: function () {
                                        i.addClass("adding");
                                    },
                                    complete: function () {
                                        i.removeClass("adding");
                                    },
                                    success: function (t) {
                                        if ((e("check", theme.strings.wishlistAdded), i.addClass("added").find(".tooltip").text(i.data("added")), $(r).remove(), 1 == t.code)) {
                                            var o = parseInt(t.json);
                                            o ? $(".wishlist__count").removeClass("hide").text(o) : $(".wishlist__count").addClass("hide").text(0);
                                        }
                                    },
                                });
                            }
                        } else window.location = "/account/login";
                    })),
                $(".removewishlist_btn").length &&
                    ($(document).off("click", ".removewishlist_btn"),
                    $(document).on("click", ".removewishlist_btn", function () {
                        var t = $(this),
                            i = parseInt(t.data("customer_id"));
                        if (0 < i) {
                            var o = t.data("shop_domain"),
                                s = parseInt(t.data("product_id"));
                            if (o.length && s) {
                                var a = document.createElement("form");
                                a.setAttribute("action", "/contact"), a.setAttribute("method", "POST"), a.setAttribute("style", "display:none");
                                var n = document.createElement("input");
                                n.setAttribute("type", "hidden"), n.setAttribute("name", "customer"), n.setAttribute("value", i);
                                var r = document.createElement("input");
                                r.setAttribute("type", "hidden"), r.setAttribute("name", "shop"), r.setAttribute("value", o);
                                var c = document.createElement("input");
                                c.setAttribute("type", "hidden"), c.setAttribute("name", "product"), c.setAttribute("value", s);
                                var l = document.createElement("input");
                                l.setAttribute("type", "hidden"), l.setAttribute("name", "action"), l.setAttribute("value", "remove_wishlist"), a.appendChild(n), a.appendChild(r), a.appendChild(c), a.appendChild(l), $("body").append(a);
                                var d = $(a).serialize();
                                $.ajax({
                                    type: "POST",
                                    url: "/a/wishlist",
                                    async: !0,
                                    cache: !1,
                                    data: d,
                                    dataType: "json",
                                    beforeSend: function () {
                                        $(".wishlist__table").addClass("loading");
                                    },
                                    complete: function () {
                                        $(".wishlist__table").removeClass("loading");
                                    },
                                    success: function (i) {
                                        if (($(a).remove(), 1 == i.code)) {
                                            var o = parseInt(i.json);
                                            o
                                                ? t.closest("tr").slideUp("fast", function () {
                                                      $(this).remove(), e("check", theme.strings.wishlistRemoved), $(".wishlist__count").removeClass("hide").text(o);
                                                  })
                                                : location.reload();
                                        }
                                    },
                                });
                            }
                        } else window.location = "/account/login";
                    })),
                $(".page-wishlist .ajax_load_button .loadmore").length &&
                    ($(document).off("click", ".page-wishlist .ajax_load_button .loadmore"),
                    $(document).on("click", ".page-wishlist .ajax_load_button .loadmore", function () {
                        var e = ".page-wishlist .ajax_load_button .loadmore",
                            t = ".page-wishlist .ajax_load_button",
                            i = ".page-wishlist .wishlist__item",
                            o = ".page-wishlist .pagination";
                        if ($(o).find("a.next").length) {
                            $(e).attr("data-processing", 1);
                            var s = $(o).find("a.next").attr("href"),
                                a = $(e).data("no_more");
                            $(t).addClass("loading"),
                                $.get(s, function (s) {
                                    $(o).empty().html($(s).find(o).html()),
                                        $(s)
                                            .find(i)
                                            .each(function () {
                                                $(i).last().after($(this));
                                            }),
                                        $(t).removeClass("loading"),
                                        $(e).attr("data-processing", 0),
                                        0 == $(o).find("a.next").length && ($(t).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(e).show().html(a).addClass("disabled").prop("disabled", !0));
                                });
                        } else (a = $(e).attr("data-no-more")), $(t).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(e).show().html(a).addClass("disabled").prop("disabled", !0);
                    })),
                (function () {
                    var e = "roarStorage_compare",
                        t = localStorage.getItem(e) || "[]";
                    try {
                        t = JSON.parse(t);
                    } catch (i) {
                        localStorage.removeItem(e), (t = JSON.parse("[]"));
                    }
                    t.length &&
                        $(".addcompare_btn").each(function () {
                            var e = $(this),
                                i = e.data("product_id");
                            t.includes(i) && e.addClass("added").find(".tooltip").text(e.data("added"));
                        }),
                        $(document).off("click", ".compare__close"),
                        $(document).on("click", ".compare__close", function () {
                            $("body").removeClass("compare-opened"), $(".compare__modal").removeClass("opened");
                        }),
                        $(document).keyup(function (e) {
                            "27" == e.which && $(".compare__modal").hasClass("opened") && $(".compare__close").trigger("click");
                        });
                })(),
                $(document).off("click", ".addcompare_btn"),
                $(document).on("click", ".addcompare_btn", function (t) {
                    t.preventDefault();
                    var i = $(this),
                        o = "roarStorage_compare",
                        s = localStorage.getItem(o) || "[]";
                    try {
                        s = JSON.parse(s);
                    } catch (t) {
                        localStorage.removeItem(o), (s = JSON.parse("[]"));
                    }
                    var a = i.data("product_id");
                    s.includes(a) || s.unshift(a), 50 <= s.length && e("alert", theme.strings.compareLimit);
                    try {
                        localStorage.setItem(o, JSON.stringify(s.slice(0, 50)));
                    } catch (t) {}
                    var n = s
                        .map(function (e) {
                            return "id:" + e;
                        })
                        .join(" OR ");
                    $.ajax({
                        url: "/search",
                        data: { view: "compare", type: "product", q: n },
                        dataType: "html",
                        type: "GET",
                        beforeSend: function () {
                            i.removeClass("added").addClass("adding");
                        },
                        complete: function () {
                            i.removeClass("adding");
                        },
                        success: function (e) {
                            !(function (e) {
                                $("body").addClass("compare-opened");
                                var t = $(".compare__modal");
                                t.removeClass("opened"),
                                    t.find(".compare__content").empty().html(e),
                                    t.addClass("opened"),
                                    $(".compare__list tr").each(function () {
                                        $(this).css("height", $(this).outerHeight());
                                    }),
                                    $(".compare__list").clone().appendTo(".compare__left"),
                                    $(".compare__left td").remove();
                            })(e),
                                i.addClass("added").find(".tooltip").text(i.data("added"));
                        },
                    });
                }),
                $(document).off("click", ".removecompare_btn"),
                $(document).on("click", ".removecompare_btn", function (e) {
                    e.preventDefault();
                    var t,
                        i = (t = $(this)).data("product_id"),
                        o = ".product__" + i,
                        s = "roarStorage_compare",
                        a = localStorage.getItem(s) || "[]";
                    try {
                        a = JSON.parse(a);
                    } catch (e) {
                        localStorage.removeItem(s), (a = JSON.parse("[]"));
                    }
                    a.includes(i) && a.splice(a.indexOf(i), 1);
                    try {
                        localStorage.setItem(s, JSON.stringify(a.slice(0, 50)));
                    } catch (e) {}
                    a.length ? $(".compare__list " + o).remove() : $(".compare__close").trigger("click"), (t = $(o + " .addcompare_btn")).removeClass("added").find(".tooltip").text(t.data("tooltip"));
                }),
                $(document).off("click", ".alert-message"),
                $(document).on("click", ".alert-message", function () {
                    $(this).hide();
                    var e = 0,
                        t = theme.settings.afterAddition;
                    $("body").hasClass("quickview-opened") && ((t = "message"), (e = 300), $(".cd-quick-view .cd-close").trigger("click")),
                        $(this).hasClass("cart_message") &&
                            "message" == t &&
                            setTimeout(function () {
                                theme.MiniCart.open();
                            }, e);
                }),
                $(document).off("click", ".password-login"),
                $(document).on("click", ".password-login", function (e) {
                    e.preventDefault(),
                        $("body").addClass("password-opened"),
                        setTimeout(function () {
                            $(".password-modal input").focus();
                        }, 250);
                }),
                $(document).off("click", ".password-modal .modal__close, .password__overlay"),
                $(document).on("click", ".password-modal .modal__close, .password__overlay", function () {
                    $("body").removeClass("password-opened");
                }),
                $(document).keyup(function (e) {
                    27 == e.keyCode && $("body").removeClass("password-opened");
                }),
                $(".password-modal").find(".errors").length &&
                    ($("body").addClass("password-opened"),
                    setTimeout(function () {
                        $(".password-modal input").focus();
                    }, 250)),
                (t = ["/cart?", "/search?", "/collections/"]),
                $(document).ajaxComplete(function (e, i, o) {
                    if (
                        (function (e, t) {
                            for (var i = 0; i < t.length; i++) if (e.match((".*" + t[i].trim() + ".*").replace(" ", ".*"))) return !0;
                            return !1;
                        })(o.url, t)
                    ) {
                        theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews(), theme.roarJs.splitText(), theme.roarJs.animationProduct();
                        var s = new theme.Sections();
                        s.register("line_item", theme.LineItem), s.register("countdown-timer", theme.CountdownTimer);
                    }
                }),
                (function () {
                    function e() {
                        var e = $(".page-header").outerHeight(),
                            t = $(window).height(),
                            i = $("#site-footer").height();
                        0 < t - e - i
                            ? $("#site-content")
                                  .css({ "margin-bottom": i - 1 })
                                  .css({ "min-height": t - e - i - 1 })
                            : $("#site-content").css({ "margin-bottom": i - 1 });
                    }
                    $("#site-footer").hasClass("is-reveal") &&
                        (e(),
                        $(window).resize(function () {
                            e();
                        }));
                })(),
                (function () {
                    var e = $(".progress-section"),
                        t = $(".progress-page");
                    if (t.length && e.length) {
                        e.append(t),
                            $(".scrolltotop").on("click", function () {
                                return $("html, body").animate({ scrollTop: 0 }, 800), !1;
                            }),
                            $(window).scroll(function () {
                                300 <= $(window).scrollTop() ? t.addClass("is-active") : t.removeClass("is-active");
                            });
                        var i = 0;
                        $(window).scroll(function () {
                            var e = $(window).scrollTop();
                            i < e ? t.addClass("is-visible") : e < i && t.removeClass("is-visible"), (i = e);
                        });
                        var o = document.querySelector(".progress-page path"),
                            s = o.getTotalLength();
                        function a() {
                            var e = $(window).scrollTop(),
                                t = $(document).height() - $(window).height(),
                                i = s - (e * s) / t;
                            o.style.strokeDashoffset = i;
                        }
                        (o.style.transition = o.style.WebkitTransition = "none"),
                            (o.style.strokeDasharray = s + " " + s),
                            (o.style.strokeDashoffset = s),
                            o.getBoundingClientRect(),
                            (o.style.transition = o.style.WebkitTransition = "stroke-dashoffset 10ms linear"),
                            a(),
                            $(window).scroll(a);
                    }
                })();
        },
        bgSet: function (e) {
            if (e) {
                var t = e.width / e.height,
                    i = "";
                return (
                    [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2048].forEach(function (o) {
                        e.width > o && (i += theme.Images.getSizedImageUrl(e.src, o + "x") + " " + o + "w " + Math.round(o / t) + "h,");
                    }),
                    (i += theme.Images.getSizedImageUrl(e.src, "master") + " " + e.width + "w " + e.height + "h")
                );
            }
        },
        backHistory: function () {
            history.go(-1);
        },
        initReviews: function () {
            "undefined" != typeof jQuery && "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
        },
        splitText: t,
        animationProduct: o,
        productInfoAnimation: i,
    };
})()),
    $(document).ready(function () {
        var e = new theme.Sections();
        e.register("cart-template", theme.Cart),
            e.register("cart-gift", theme.CartGift),
            e.register("shipping-calculator", theme.ShippingCalculator),
            e.register("collection-template", theme.Filters),
            e.register("sidebar-sticky", theme.SidebarSticky),
            e.register("product-template", theme.Product),
            e.register("header-mobile", theme.HeaderMobile),
            e.register("header-section", theme.HeaderSection),
            e.register("map", theme.Maps),
            e.register("slideshow-section", theme.SlideshowSection),
            e.register("line_item", theme.LineItem),
            e.register("instagram", theme.Instagram),
            e.register("countdown-timer", theme.CountdownTimer),
            e.register("products-slider", theme.ProductsSlider),
            e.register("product-tabs", theme.ProductTabs),
            e.register("newsletter-popup", theme.NewsletterPopup),
            e.register("lookbook-section", theme.LookbookSection),
            e.register("rich-banner", theme.RichBanner),
            e.register("collections-slider", theme.CollectionsSlider);
    }),
    (theme.init = function () {
        theme.roarJs.init(),
            theme.customerTemplates.init(),
            $('a[href="#"]').on("click", function (e) {
                e.preventDefault();
            });
    }),
    $(theme.init),
    $("#shopify-product-reviews").on("DOMSubtreeModified", function () {
        var e = $(this);
        !e.hasClass("customized") &&
            e.find(".spr-reviews").length &&
            (e.addClass("customized"),
            setTimeout(function () {
                e.find(".spr-header").append(e.find(".spr-reviews"));
            }, 300));
    }),
    load_tabs(),
    $("#1544072917883").click();
var acc = document.getElementsByClassName("accordion"),
    i;
for (i = 0; i < acc.length; i++)
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var e = this.nextElementSibling;
        console.log(e), this.nextElementSibling.classList.toggle("slideActive"), "block" === e.style.display ? $(e).slideUp(100) : $(e).slideDown(100);
    });

$(window).scroll(function() { 
var scroll = $(window).scrollTop(); 
if (scroll >= 500) { 
$(".header-sticky__placeholder").addClass("stick").removeClass("unstick"); 
} 
else{ 
$(".header-sticky__placeholder").addClass("unstick").removeClass("stick"); 
} 
});